import * as t from "react";
import { useState as A, useRef as I, useCallback as se, useEffect as Z, Fragment as Lo, Component as qo, useLayoutEffect as He, isValidElement as Kn, cloneElement as Io, forwardRef as Dr, createContext as Fo, useContext as Ro, useMemo as De, Children as ba, createRef as Cr } from "react";
import { createPortal as Sr } from "react-dom";
const Yw = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, Aa = "poc_portal_token", Mn = "poc_portal_refresh", Ea = "auth:session-expired", Po = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let Oo = Po + "/chat-api/api/auth";
function Vw(e) {
  e.authBase && (Oo = e.authBase);
}
function Ma(e) {
  try {
    const n = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(n))));
  } catch {
    return {};
  }
}
function Ar(e, n = 30) {
  const a = Ma(e).exp;
  return !a || a * 1e3 < Date.now() + n * 1e3;
}
function Xo(e = 30) {
  const n = localStorage.getItem(Mn);
  if (!n) return !0;
  const a = Ma(n).exp;
  return !!a && a * 1e3 < Date.now() + e * 1e3;
}
function Mr() {
  return localStorage.getItem(Aa);
}
function Br(e, n) {
  localStorage.setItem(Aa, e), n && localStorage.setItem(Mn, n);
}
function jr() {
  localStorage.removeItem(Aa), localStorage.removeItem(Mn), Wo();
}
function kn() {
  jr(), window.dispatchEvent(new Event(Ea));
}
function Jw(e) {
  return window.addEventListener(Ea, e), () => window.removeEventListener(Ea, e);
}
let wn = null;
const Tr = 2147483647;
function Lr() {
  if (Wo(), Xo()) {
    kn();
    return;
  }
  const e = localStorage.getItem(Mn), n = e ? Ma(e).exp : void 0;
  if (!n) return;
  const a = Math.min(Math.max(n * 1e3 - Date.now() - 30 * 1e3, 0), Tr);
  wn = setTimeout(() => {
    wn = null, Lr();
  }, a);
}
function Wo() {
  wn !== null && (clearTimeout(wn), wn = null);
}
let Xn = null;
function zo() {
  return Xn || (Xn = qr()), Xn;
}
async function qr() {
  try {
    return await Ir();
  } finally {
    Xn = null;
  }
}
async function Ir() {
  const e = localStorage.getItem(Mn);
  if (!e)
    return kn(), null;
  let n;
  try {
    n = await fetch(Oo + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: e })
    });
  } catch {
    return null;
  }
  if (!n.ok)
    return n.status < 500 && kn(), null;
  const a = await n.json().catch(() => ({}));
  return a.access_token ? (Br(a.access_token, a.refresh_token), a.access_token) : (kn(), null);
}
async function Fr() {
  if (Xo())
    return kn(), null;
  const e = Mr();
  return e && !Ar(e) ? e : zo();
}
async function Bn(e, n = {}) {
  const a = (s) => {
    var l;
    return {
      ...n,
      headers: { ...(l = n.headers) != null ? l : {}, ...s ? { Authorization: "Bearer " + s } : {} }
    };
  }, o = await Fr();
  let r = await fetch(e, a(o));
  if (r.status === 401 && o) {
    const s = await zo();
    s && (r = await fetch(e, a(s)));
  }
  return r;
}
let cn = Po + "/chat-api/api/comments";
function Qw(e) {
  e.base && (cn = e.base);
}
function Rr(e) {
  return e.parentId !== void 0 && e.parentId !== null;
}
async function jn(e) {
  var a;
  const n = await e.json().catch(() => ({}));
  if (!e.ok) throw new Error((a = n.error) != null ? a : `요청 실패 (${e.status})`);
  return n;
}
async function Oa(e, n, a, o, r) {
  const s = new URLSearchParams({ targetType: e, targetId: n, page: String(a), size: String(o) }), l = await Bn(`${cn}?${s}`, { cache: "no-store", signal: r });
  return jn(l);
}
async function Pr(e, n, a, o) {
  const r = await Bn(cn, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: e, targetId: n, content: a, parentId: o })
  });
  return jn(r);
}
async function Or(e, n) {
  const a = await Bn(`${cn}/${e}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: n })
  });
  return jn(a);
}
async function Xr(e) {
  const n = await Bn(`${cn}/${e}`, { method: "DELETE" });
  return (await jn(n)).status;
}
async function Wr(e, n, a) {
  if (n.length === 0) return {};
  const o = new URLSearchParams({ targetType: e, targetIds: n.join(",") }), r = await Bn(`${cn}/counts?${o}`, { cache: "no-store", signal: a });
  return (await jn(r)).counts;
}
const Xa = 50;
function ga(e) {
  return e.parentId === void 0 || e.parentId === null;
}
function zr(e, n) {
  if (ga(n)) return [...e, n];
  const a = n.parentId;
  let o = -1;
  for (let r = 0; r < e.length; r += 1)
    (e[r].id === a || e[r].parentId === a) && (o = r);
  return o < 0 ? [...e, n] : [...e.slice(0, o + 1), n, ...e.slice(o + 1)];
}
function mn(e, n) {
  return e instanceof Error && e.message ? e.message : n;
}
function Kr(e, n) {
  const [a, o] = A([]), [r, s] = A(!0), [l, i] = A(!0), [c, u] = A(null), [m, d] = A(0), [_, p] = A(0), f = e + " " + n, y = I(f);
  y.current = f;
  const [E, g] = A(0), w = se(() => g((x) => x + 1), []);
  Z(() => {
    const x = new AbortController(), C = f;
    return o([]), p(0), d(0), u(null), s(!0), i(!0), Oa(e, n, 0, Xa, x.signal).then((B) => {
      y.current === C && (o(B.items), d(B.total));
    }).catch((B) => {
      x.signal.aborted || y.current !== C || u(mn(B, "댓글을 불러오지 못했어요."));
    }).finally(() => {
      y.current === C && (s(!1), i(!1));
    }), () => x.abort();
  }, [e, n, f, E]);
  const k = a.filter(ga).length < m, b = se(() => {
    if (r || !k) return;
    const x = _ + 1, C = y.current;
    s(!0), Oa(e, n, x, Xa).then((B) => {
      y.current === C && (o((R) => [...R, ...B.items]), d(B.total), p(x));
    }).catch((B) => {
      y.current === C && u(mn(B, "댓글을 더 불러오지 못했어요."));
    }).finally(() => {
      y.current === C && s(!1);
    });
  }, [r, k, _, e, n]), $ = se(async (x, C) => {
    const B = x.trim();
    if (!B) return !1;
    const R = -Date.now(), P = {
      id: R,
      targetType: e,
      targetId: n,
      parentId: C != null ? C : null,
      authorName: "나",
      content: B,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, G = y.current;
    o((q) => zr(q, P)), u(null);
    try {
      const q = await Pr(e, n, B, C);
      return y.current !== G || (o((L) => L.map((F) => F.id === R ? q : F)), C === void 0 && d((L) => L + 1)), !0;
    } catch (q) {
      return y.current !== G || (o((L) => L.filter((F) => F.id !== R)), u(mn(q, "댓글을 등록하지 못했어요."))), !1;
    }
  }, [e, n]), h = se(async (x, C) => {
    const B = C.trim();
    if (!B) return !1;
    const R = y.current;
    try {
      const P = await Or(x, B);
      return y.current !== R || o((G) => G.map((q) => q.id === x ? P : q)), !0;
    } catch (P) {
      return y.current === R && u(mn(P, "댓글을 수정하지 못했어요.")), !1;
    }
  }, []), v = se(async (x) => {
    const C = y.current;
    try {
      const B = await Xr(x);
      return y.current !== C ? !0 : B === "soft-deleted" ? (o((R) => R.map((P) => P.id === x ? { ...P, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : P)), !0) : (o((R) => {
        const P = R.find((F) => F.id === x), G = R.filter((F) => F.id !== x);
        if (!P) return G;
        if (ga(P))
          return d((F) => Math.max(0, F - 1)), G;
        const q = P.parentId, L = G.find((F) => F.id === q);
        return L && L.deleted && !G.some((F) => F.parentId === q) ? (d((F) => Math.max(0, F - 1)), G.filter((F) => F.id !== q)) : G;
      }), !0);
    } catch (B) {
      return y.current === C && u(mn(B, "댓글을 삭제하지 못했어요.")), !1;
    }
  }, []);
  return {
    items: a,
    loading: r,
    initialLoading: l,
    error: c,
    count: a.filter((x) => !x.deleted).length,
    hasMore: k,
    loadMore: b,
    reload: w,
    add: $,
    edit: h,
    remove: v
  };
}
const Hr = "_thread_1layy_9", Gr = "_head_1layy_28", Ur = "_headTitle_1layy_37", Yr = "_headCount_1layy_43", Vr = "_list_1layy_54", Jr = "_row_1layy_61", Qr = "_isReply_1layy_73", Zr = "_pending_1layy_80", es = "_avatar_1layy_84", ts = "_avatarGhost_1layy_98", ns = "_body_1layy_103", as = "_meta_1layy_108", os = "_author_1layy_116", rs = "_dept_1layy_122", ss = "_time_1layy_130", ls = "_text_1layy_135", cs = "_textDeleted_1layy_143", is = "_acts_1layy_148", us = "_act_1layy_148", ms = "_actDanger_1layy_169", ds = "_empty_1layy_175", _s = "_error_1layy_182", ps = "_skeleton_1layy_196", fs = "_more_1layy_219", ys = "_foot_1layy_245", hs = "_composer_1layy_252", bs = "_composerInput_1layy_261", Es = "_composerActions_1layy_284", gs = "_btn_1layy_291", vs = "_btnPrimary_1layy_301", ks = "_btnGhost_1layy_310", J = {
  thread: Hr,
  head: Gr,
  headTitle: Ur,
  headCount: Yr,
  list: Vr,
  row: Jr,
  isReply: Qr,
  pending: Zr,
  avatar: es,
  avatarGhost: ts,
  body: ns,
  meta: as,
  author: os,
  dept: rs,
  time: ss,
  text: ls,
  textDeleted: cs,
  acts: is,
  act: us,
  actDanger: ms,
  empty: ds,
  error: _s,
  skeleton: ps,
  more: fs,
  foot: ys,
  composer: hs,
  composerInput: bs,
  composerActions: Es,
  btn: gs,
  btnPrimary: vs,
  btnGhost: ks
}, Wa = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function ws(e) {
  let n = 0;
  for (let a = 0; a < e.length; a += 1) n = (n * 31 + e.charCodeAt(a)) % 997;
  return Wa[n % Wa.length];
}
function Ns(e) {
  const n = e.trim();
  return n ? n[0].toUpperCase() : "?";
}
const za = 6e4, Ka = 36e5, Ha = 864e5, $s = 6048e5;
function xs(e) {
  const n = new Date(e).getTime();
  if (Number.isNaN(n)) return "";
  const a = Date.now() - n;
  if (a < za) return "방금";
  if (a < Ka) return `${Math.floor(a / za)}분 전`;
  if (a < Ha) return `${Math.floor(a / Ka)}시간 전`;
  if (a < $s) return `${Math.floor(a / Ha)}일 전`;
  const o = new Date(n), r = (s) => s < 10 ? `0${s}` : String(s);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function va({
  placeholder: e,
  submitLabel: n,
  autoFocus: a,
  initialValue: o,
  onSubmit: r,
  onCancel: s
}) {
  const [l, i] = A(o != null ? o : ""), [c, u] = A(!1), m = I(null);
  Z(() => {
    a && m.current && m.current.focus();
  }, [a]);
  const d = async () => {
    const _ = l.trim();
    if (!_ || c) return;
    u(!0);
    const p = await r(_);
    u(!1), p && i("");
  };
  return /* @__PURE__ */ t.createElement("div", { className: J.composer }, /* @__PURE__ */ t.createElement(
    "textarea",
    {
      ref: m,
      className: J.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: e,
      value: l,
      disabled: c,
      onChange: (_) => i(_.target.value),
      onKeyDown: (_) => {
        const p = _.nativeEvent.isComposing;
        _.key === "Enter" && !_.shiftKey && !p && (_.preventDefault(), d()), _.key === "Escape" && s && (_.nativeEvent.stopPropagation(), s());
      }
    }
  ), /* @__PURE__ */ t.createElement("div", { className: J.composerActions }, s && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${J.btn} ${J.btnGhost}`,
      onClick: s,
      disabled: c
    },
    "취소"
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${J.btn} ${J.btnPrimary}`,
      onClick: () => void d(),
      disabled: c || !l.trim()
    },
    c ? "보내는 중…" : n
  )));
}
function Ds({
  item: e,
  replying: n,
  editing: a,
  onReply: o,
  onEdit: r,
  onSubmitReply: s,
  onSubmitEdit: l,
  onDelete: i,
  onCancel: c
}) {
  var _, p;
  const u = Rr(e), m = u ? ` ${J.isReply}` : "";
  if (e.deleted)
    return /* @__PURE__ */ t.createElement("div", { className: `${J.row}${m}` }, /* @__PURE__ */ t.createElement("span", { className: `${J.avatar} ${J.avatarGhost}` }, "·"), /* @__PURE__ */ t.createElement("div", { className: J.body }, /* @__PURE__ */ t.createElement("div", { className: `${J.text} ${J.textDeleted}` }, "삭제된 댓글입니다")));
  const d = (_ = e.authorName) != null ? _ : "anonymous";
  return /* @__PURE__ */ t.createElement("div", { className: `${J.row}${m}${e.pending ? ` ${J.pending}` : ""}` }, /* @__PURE__ */ t.createElement("span", { className: J.avatar, style: { background: ws(d) } }, Ns(d)), /* @__PURE__ */ t.createElement("div", { className: J.body }, /* @__PURE__ */ t.createElement("div", { className: J.meta }, /* @__PURE__ */ t.createElement("span", { className: J.author }, d), e.dept && /* @__PURE__ */ t.createElement("span", { className: J.dept }, e.dept), /* @__PURE__ */ t.createElement("span", { className: J.time }, xs(e.createdAt)), e.updatedAt && /* @__PURE__ */ t.createElement("span", { className: J.time }, "(수정됨)")), a ? /* @__PURE__ */ t.createElement(
    va,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (p = e.content) != null ? p : "",
      onSubmit: l,
      onCancel: c
    }
  ) : /* @__PURE__ */ t.createElement("div", { className: J.text }, e.content), !a && !e.pending && /* @__PURE__ */ t.createElement("div", { className: J.acts }, !u && /* @__PURE__ */ t.createElement("button", { type: "button", className: J.act, onClick: o }, "답글"), e.mine && /* @__PURE__ */ t.createElement("button", { type: "button", className: J.act, onClick: r }, "수정"), e.mine && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${J.act} ${J.actDanger}`,
      onClick: i
    },
    "삭제"
  )), n && /* @__PURE__ */ t.createElement(
    va,
    {
      placeholder: `${d} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: s,
      onCancel: c
    }
  )));
}
function Zw({
  targetType: e,
  targetId: n,
  onCountChange: a,
  autoFocus: o,
  showHeader: r = !0,
  className: s,
  style: l
}) {
  const { items: i, initialLoading: c, loading: u, error: m, count: d, hasMore: _, loadMore: p, reload: f, add: y, edit: E, remove: g } = Kr(e, n), [w, D] = A(null), [k, b] = A(null);
  Z(() => {
    D(null), b(null);
  }, [e, n]);
  const $ = I(a);
  return $.current = a, Z(() => {
    !c && $.current && $.current(d);
  }, [d, c]), /* @__PURE__ */ t.createElement("div", { className: s ? `${J.thread} ${s}` : J.thread, style: l }, r && /* @__PURE__ */ t.createElement("div", { className: J.head }, /* @__PURE__ */ t.createElement("span", { className: J.headTitle }, "댓글"), /* @__PURE__ */ t.createElement("span", { className: J.headCount }, d)), /* @__PURE__ */ t.createElement("div", { className: J.list }, c && /* @__PURE__ */ t.createElement("div", { className: J.skeleton }, /* @__PURE__ */ t.createElement("span", null), /* @__PURE__ */ t.createElement("span", null), /* @__PURE__ */ t.createElement("span", null)), m && /* @__PURE__ */ t.createElement("div", { className: J.error }, /* @__PURE__ */ t.createElement("span", null, m), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${J.btn} ${J.btnGhost}`,
      onClick: f
    },
    "다시 시도"
  )), !c && !m && i.length === 0 && /* @__PURE__ */ t.createElement("div", { className: J.empty }, "첫 댓글을 남겨 보세요."), i.map((h) => /* @__PURE__ */ t.createElement(
    Ds,
    {
      key: h.id,
      item: h,
      replying: w === h.id,
      editing: k === h.id,
      onReply: () => {
        b(null), D(h.id);
      },
      onEdit: () => {
        D(null), b(h.id);
      },
      onCancel: () => {
        D(null), b(null);
      },
      onSubmitReply: async (v) => {
        const x = await y(v, h.id);
        return x && D(null), x;
      },
      onSubmitEdit: async (v) => {
        const x = await E(h.id, v);
        return x && b(null), x;
      },
      onDelete: () => {
        g(h.id);
      }
    }
  )), _ && /* @__PURE__ */ t.createElement("button", { type: "button", className: J.more, onClick: p, disabled: u }, u ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ t.createElement("div", { className: J.foot }, /* @__PURE__ */ t.createElement(
    va,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (h) => y(h)
    }
  )));
}
function e2(e, n) {
  const [a, o] = A({}), [r, s] = A(!1), [l, i] = A(0), c = n.join(",");
  return Z(() => {
    const u = c ? c.split(",") : [];
    if (u.length === 0) {
      o({});
      return;
    }
    const m = new AbortController();
    return s(!0), Wr(e, u, m.signal).then((d) => {
      m.signal.aborted || o(d);
    }).catch(() => {
      m.signal.aborted || o({});
    }).finally(() => {
      m.signal.aborted || s(!1);
    }), () => m.abort();
  }, [e, c, l]), {
    counts: a,
    loading: r,
    reload: () => i((u) => u + 1)
  };
}
const Cs = "_card_epi3f_1", Ss = "_header_epi3f_8", As = "_headerNoDivider_epi3f_13", Ms = "_body_epi3f_17", Bs = "_paddingSm_epi3f_22", js = "_paddingMd_epi3f_26", Ts = "_paddingLg_epi3f_30", lt = {
  card: Cs,
  header: Ss,
  headerNoDivider: As,
  body: Ms,
  paddingSm: Bs,
  paddingMd: js,
  paddingLg: Ts
};
function t2({
  children: e,
  header: n,
  padding: a = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: s,
  headerPadding: l,
  headerBorderColor: i,
  className: c
}) {
  const u = typeof a == "number" ? "" : a === "sm" ? lt.paddingSm : a === "lg" ? lt.paddingLg : lt.paddingMd, m = typeof a == "number" ? { padding: a } : void 0, d = c ? `${lt.card} ${c}` : lt.card, _ = r ? lt.header : `${lt.header} ${lt.headerNoDivider}`, p = {
    ...s !== void 0 ? { background: s } : {},
    ...l !== void 0 ? { padding: l } : {},
    ...i !== void 0 ? { borderBottomColor: i } : {}
  };
  return /* @__PURE__ */ t.createElement("div", { className: d, style: o !== void 0 ? { borderRadius: o } : void 0 }, n && /* @__PURE__ */ t.createElement("div", { className: _, style: p }, n), /* @__PURE__ */ t.createElement("div", { className: `${lt.body} ${u}`, style: m }, e));
}
const Ls = "_horizontal_mkht7_1", qs = "_vertical_mkht7_8", Ga = {
  horizontal: Ls,
  vertical: qs
};
function n2({ orientation: e = "horizontal", spacing: n = 0, color: a }) {
  const o = e === "vertical";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: o ? Ga.vertical : Ga.horizontal,
      style: {
        ...o ? { marginLeft: n, marginRight: n } : { marginTop: n, marginBottom: n },
        ...a !== void 0 ? { backgroundColor: a } : {}
      },
      role: "separator",
      "aria-orientation": e
    }
  );
}
const Is = "_root_nvy8t_1", Fs = "_icon_nvy8t_7", Rs = "_iconBadge_nvy8t_15", Ps = "_titleGroup_nvy8t_25", Os = "_title_nvy8t_25", Xs = "_subtitle_nvy8t_41", Ws = "_trailing_nvy8t_49", zs = "_closeButton_nvy8t_58", kt = {
  root: Is,
  icon: Fs,
  iconBadge: Rs,
  titleGroup: Ps,
  title: Os,
  subtitle: Xs,
  trailing: Ws,
  closeButton: zs
};
function a2({
  icon: e,
  iconColor: n,
  iconBadge: a = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: s,
  title: l,
  titleWeight: i,
  titleSize: c,
  subtitle: u,
  subtitleColor: m,
  subtitleSize: d,
  trailing: _,
  onClose: p
}) {
  const f = {
    ...i !== void 0 ? { fontWeight: i } : {},
    ...c !== void 0 ? { fontSize: c } : {}
  }, y = {
    ...m !== void 0 ? { color: m } : {},
    ...d !== void 0 ? { fontSize: d } : {}
  };
  return /* @__PURE__ */ t.createElement("div", { className: kt.root }, e && a && /* @__PURE__ */ t.createElement(
    "span",
    {
      className: kt.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...s !== void 0 ? { width: s, height: s } : {}
      }
    },
    e
  ), e && !a && /* @__PURE__ */ t.createElement("span", { className: kt.icon, style: n !== void 0 ? { color: n } : void 0 }, e), /* @__PURE__ */ t.createElement("div", { className: kt.titleGroup }, /* @__PURE__ */ t.createElement("span", { className: kt.title, style: f }, l), u && /* @__PURE__ */ t.createElement("span", { className: kt.subtitle, style: y }, u)), _ && /* @__PURE__ */ t.createElement("div", { className: kt.trailing }, _), p && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: kt.closeButton,
      onClick: p,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const Ks = "_badge_19977_1", Hs = {
  badge: Ks
};
function o2({
  size: e = 32,
  gradient: n = ["#7C3AED", "#3B82F6"],
  icon: a
}) {
  const o = e * 0.55;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: Hs.badge,
      style: {
        width: e,
        height: e,
        background: `linear-gradient(135deg, ${n[0]}, ${n[1]})`
      }
    },
    a != null ? a : /* @__PURE__ */ t.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ t.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const Gs = "_wrapper_ccmq2_1", Us = "_image_ccmq2_8", Ys = "_fallback_ccmq2_16", Vs = "_statusDot_ccmq2_29", qn = {
  wrapper: Gs,
  image: Us,
  fallback: Ys,
  statusDot: Vs
}, Js = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function Qs(e) {
  const n = e == null ? void 0 : e.trim();
  return n ? Array.from(n)[0].toUpperCase() : "";
}
const ra = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function Zs(e) {
  const n = e == null ? void 0 : e.trim();
  if (!n) return ra[5];
  let a = 0;
  for (let o = 0; o < n.length; o += 1)
    a = a * 31 + n.charCodeAt(o) | 0;
  return ra[Math.abs(a) % ra.length];
}
function Ko({
  src: e,
  fallbackText: n,
  alt: a,
  size: o = 32,
  statusDot: r,
  color: s,
  ring: l = !1,
  ringColor: i = "#fff"
}) {
  var d;
  const [c, u] = A(), m = !!e && c !== e;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: qn.wrapper,
      style: {
        width: o,
        height: o,
        ...l ? { boxShadow: `0 0 0 2px ${i}` } : {}
      }
    },
    m ? /* @__PURE__ */ t.createElement(
      "img",
      {
        className: qn.image,
        src: e,
        alt: (d = a != null ? a : n) != null ? d : "",
        onError: () => u(e)
      }
    ) : /* @__PURE__ */ t.createElement(
      "span",
      {
        className: qn.fallback,
        style: {
          backgroundColor: s != null ? s : Zs(n),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      Qs(n)
    ),
    r && /* @__PURE__ */ t.createElement(
      "span",
      {
        className: qn.statusDot,
        style: {
          backgroundColor: Js[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const el = "_stack_y8phg_1", tl = "_item_y8phg_6", nl = "_overflow_y8phg_18", In = {
  stack: el,
  item: tl,
  overflow: nl
};
function r2({
  avatars: e,
  max: n = 4,
  size: a = 32
}) {
  const o = e.slice(0, n), r = e.length - o.length;
  return /* @__PURE__ */ t.createElement("span", { className: In.stack }, o.map((s, l) => /* @__PURE__ */ t.createElement("span", { key: l, className: In.item, style: { zIndex: o.length - l } }, /* @__PURE__ */ t.createElement(Ko, { src: s.src, alt: s.alt, fallbackText: s.fallbackText, size: a }))), r > 0 && /* @__PURE__ */ t.createElement("span", { className: In.item, style: { zIndex: 0 } }, /* @__PURE__ */ t.createElement(
    "span",
    {
      className: In.overflow,
      style: { width: a, height: a, fontSize: Math.max(10, a * 0.36) }
    },
    "+",
    r
  )));
}
const al = "_badge_1mjda_1", ol = "_pill_1mjda_15", rl = "_dot_1mjda_19", sl = "_dotPulse_1mjda_26", ll = "_outline_1mjda_40", cl = "_soft_1mjda_46", dn = {
  badge: al,
  pill: ol,
  dot: rl,
  dotPulse: sl,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: ll,
  soft: cl
};
function s2({
  label: e,
  variant: n = "default",
  color: a,
  background: o,
  textColor: r,
  shape: s = "rounded",
  dot: l = !1,
  dotColor: i,
  dotPulse: c = !1,
  border: u = !1,
  borderColor: m = "currentColor"
}) {
  var f;
  const d = {};
  a && (n === "default" ? (d.backgroundColor = a, d.color = "#fff") : n === "outline" ? (d.borderColor = a, d.color = a) : (d.backgroundColor = `${a}1A`, d.color = a)), o !== void 0 && (d.backgroundColor = o), r !== void 0 && (d.color = r), u && (d.borderColor = m);
  const _ = [
    dn.badge,
    dn[n],
    s === "pill" ? dn.pill : ""
  ].filter(Boolean).join(" "), p = [dn.dot, c ? dn.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ t.createElement("span", { className: _, style: d }, l && /* @__PURE__ */ t.createElement("span", { className: p, style: { backgroundColor: i != null ? i : (f = r != null ? r : a) != null ? f : "currentColor" } }), e);
}
const il = "_row_1k2ap_1", ul = "_reply_1k2ap_7", ml = "_avatar_1k2ap_12", dl = "_avatarImage_1k2ap_25", _l = "_avatarFallback_1k2ap_32", pl = "_body_1k2ap_44", fl = "_headerLine_1k2ap_49", yl = "_author_1k2ap_56", hl = "_meta_1k2ap_62", bl = "_text_1k2ap_67", El = "_actionsRow_1k2ap_74", gl = "_actionBtn_1k2ap_81", Te = {
  row: il,
  reply: ul,
  avatar: ml,
  avatarImage: dl,
  avatarFallback: _l,
  body: pl,
  headerLine: fl,
  author: yl,
  meta: hl,
  text: bl,
  actionsRow: El,
  actionBtn: gl
};
function vl(e) {
  const n = e.trim();
  return n ? n[0].toUpperCase() : "";
}
function l2({
  avatarSrc: e,
  author: n,
  meta: a,
  text: o,
  likeCount: r,
  replyCount: s,
  isReply: l = !1,
  onLikeClick: i,
  onReplyClick: c
}) {
  const [u, m] = A(!1), d = !!e && !u;
  return /* @__PURE__ */ t.createElement("div", { className: `${Te.row} ${l ? Te.reply : ""}` }, /* @__PURE__ */ t.createElement("span", { className: Te.avatar }, d ? /* @__PURE__ */ t.createElement(
    "img",
    {
      className: Te.avatarImage,
      src: e,
      alt: n,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ t.createElement("span", { className: Te.avatarFallback }, vl(n))), /* @__PURE__ */ t.createElement("div", { className: Te.body }, /* @__PURE__ */ t.createElement("div", { className: Te.headerLine }, /* @__PURE__ */ t.createElement("span", { className: Te.author }, n), a && /* @__PURE__ */ t.createElement("span", { className: Te.meta }, a)), /* @__PURE__ */ t.createElement("div", { className: Te.text }, o), /* @__PURE__ */ t.createElement("div", { className: Te.actionsRow }, /* @__PURE__ */ t.createElement("button", { type: "button", className: Te.actionBtn, onClick: i }, /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ t.createElement("span", null, r)), /* @__PURE__ */ t.createElement("button", { type: "button", className: Te.actionBtn, onClick: c }, /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof s == "number" && /* @__PURE__ */ t.createElement("span", null, s)))));
}
const kl = "_wrapper_79n51_1", wl = {
  wrapper: kl
}, Nl = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, $l = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function xl({ ext: e, size: n = 32 }) {
  var l;
  const a = e.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: s } = (l = Nl[a]) != null ? l : $l;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: wl.wrapper,
      style: {
        width: n,
        height: n,
        backgroundColor: s,
        color: r,
        fontSize: Math.max(8, n * 0.26)
      }
    },
    o
  );
}
const Dl = "_chip_1jhj8_1", Cl = "_clickable_1jhj8_12", Sl = "_icon_1jhj8_21", Al = "_info_1jhj8_26", Ml = "_name_1jhj8_33", Bl = "_size_1jhj8_42", jl = "_chipError_1jhj8_48", Tl = "_chipDone_1jhj8_53", Ll = "_status_1jhj8_57", ql = "_statusError_1jhj8_66", Il = "_statusDone_1jhj8_67", Fl = "_statusIcon_1jhj8_69", Rl = "_statusLabel_1jhj8_71", Pl = "_progressTrack_1jhj8_78", Ol = "_progressFill_1jhj8_88", Xl = "_actionBtn_1jhj8_96", Ee = {
  chip: Dl,
  clickable: Cl,
  icon: Sl,
  info: Al,
  name: Ml,
  size: Bl,
  chipError: jl,
  chipDone: Tl,
  status: Ll,
  statusError: ql,
  statusDone: Il,
  statusIcon: Fl,
  statusLabel: Rl,
  progressTrack: Pl,
  progressFill: Ol,
  actionBtn: Xl
};
function c2({
  name: e,
  ext: n,
  size: a,
  onRemove: o,
  downloadable: r = !1,
  onClick: s,
  status: l,
  statusText: i,
  percent: c
}) {
  const u = l === "error" ? Ee.chipError : l === "done" ? Ee.chipDone : "";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: `${Ee.chip} ${s ? Ee.clickable : ""} ${u}`,
      onClick: s,
      title: l === "error" ? i : void 0
    },
    n && /* @__PURE__ */ t.createElement("span", { className: Ee.icon }, /* @__PURE__ */ t.createElement(xl, { ext: n, size: 28 })),
    /* @__PURE__ */ t.createElement("span", { className: Ee.info }, /* @__PURE__ */ t.createElement("span", { className: Ee.name }, e), i ? /* @__PURE__ */ t.createElement("span", { className: `${Ee.status} ${l === "error" ? Ee.statusError : l === "done" ? Ee.statusDone : ""}` }, l === "error" && /* @__PURE__ */ t.createElement("svg", { className: Ee.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ t.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ t.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ t.createElement("svg", { className: Ee.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ t.createElement("span", { className: Ee.statusLabel }, i)) : a ? /* @__PURE__ */ t.createElement("span", { className: Ee.size }, a) : null, l === "processing" && /* @__PURE__ */ t.createElement("span", { className: Ee.progressTrack }, /* @__PURE__ */ t.createElement("span", { className: Ee.progressFill, style: { width: `${Math.max(0, Math.min(100, c != null ? c : 0))}%` } }))),
    r ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Ee.actionBtn,
        "aria-label": "download",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Ee.actionBtn,
        "aria-label": "remove",
        onClick: (m) => {
          m.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const Wl = "_list_1yxwc_1", zl = "_row_1yxwc_6", Kl = "_inline_1yxwc_15", Hl = "_label_1yxwc_22", Gl = "_value_1yxwc_29", Ul = "_stacked_1yxwc_35", Yl = "_bold_1yxwc_51", Gt = {
  list: Wl,
  row: zl,
  inline: Kl,
  label: Hl,
  value: Gl,
  stacked: Ul,
  bold: Yl
};
function i2({
  rows: e,
  direction: n = "inline"
}) {
  return /* @__PURE__ */ t.createElement("div", { className: `${Gt.list} ${Gt[n]}` }, e.map((a, o) => /* @__PURE__ */ t.createElement("div", { key: o, className: Gt.row }, /* @__PURE__ */ t.createElement("span", { className: Gt.label }, a.label), /* @__PURE__ */ t.createElement("span", { className: `${Gt.value} ${a.bold ? Gt.bold : ""}` }, a.value))));
}
const Vl = "_container_2r163_1", Jl = "_row_2r163_5", Ql = "_clickable_2r163_12", Zl = "_leading_2r163_20", ec = "_main_2r163_26", tc = "_titleLine_2r163_34", nc = "_title_2r163_34", ac = "_tags_2r163_50", oc = "_meta_2r163_57", rc = "_actions_2r163_62", sc = "_expandable_2r163_69", We = {
  container: Vl,
  row: Jl,
  clickable: Ql,
  leading: Zl,
  main: ec,
  titleLine: tc,
  title: nc,
  tags: ac,
  meta: oc,
  actions: rc,
  expandable: sc
};
function u2({
  leading: e,
  title: n,
  meta: a,
  tags: o,
  actions: r,
  expandableContent: s,
  expanded: l = !1,
  onClick: i
}) {
  return /* @__PURE__ */ t.createElement("div", { className: We.container }, /* @__PURE__ */ t.createElement("div", { className: `${We.row} ${i ? We.clickable : ""}`, onClick: i }, e && /* @__PURE__ */ t.createElement("div", { className: We.leading }, e), /* @__PURE__ */ t.createElement("div", { className: We.main }, /* @__PURE__ */ t.createElement("div", { className: We.titleLine }, /* @__PURE__ */ t.createElement("span", { className: We.title }, n), o && /* @__PURE__ */ t.createElement("span", { className: We.tags }, o)), a && /* @__PURE__ */ t.createElement("div", { className: We.meta }, a)), r && /* @__PURE__ */ t.createElement("div", { className: We.actions, onClick: (c) => c.stopPropagation() }, r)), l && s && /* @__PURE__ */ t.createElement("div", { className: We.expandable }, s));
}
const lc = "_row_xzgny_1", cc = "_info_xzgny_8", ic = "_name_xzgny_16", uc = "_subtitle_xzgny_25", mc = "_status_xzgny_33", _n = {
  row: lc,
  info: cc,
  name: ic,
  subtitle: uc,
  status: mc
};
function m2({
  avatarSrc: e,
  name: n,
  subtitle: a,
  status: o,
  statusColor: r = "#64748B",
  statusBg: s = "#F1F5F9"
}) {
  return /* @__PURE__ */ t.createElement("div", { className: _n.row }, /* @__PURE__ */ t.createElement(Ko, { src: e, fallbackText: n, size: 36 }), /* @__PURE__ */ t.createElement("div", { className: _n.info }, /* @__PURE__ */ t.createElement("span", { className: _n.name }, n), a && /* @__PURE__ */ t.createElement("span", { className: _n.subtitle }, a)), o && /* @__PURE__ */ t.createElement(
    "span",
    {
      className: _n.status,
      style: { color: r, backgroundColor: s }
    },
    o
  ));
}
const dc = "_row_qoxwr_1", _c = "_clickable_qoxwr_9", pc = "_rank_qoxwr_17", fc = "_title_qoxwr_25", yc = "_trailing_qoxwr_36", pn = {
  row: dc,
  clickable: _c,
  rank: pc,
  title: fc,
  trailing: yc
}, hc = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function d2({
  rank: e,
  rankColor: n,
  title: a,
  trailingText: o,
  onClick: r
}) {
  var l;
  const s = (l = n != null ? n : hc[e]) != null ? l : "#64748B";
  return /* @__PURE__ */ t.createElement("div", { className: `${pn.row} ${r ? pn.clickable : ""}`, onClick: r }, /* @__PURE__ */ t.createElement("span", { className: pn.rank, style: { color: s } }, e), /* @__PURE__ */ t.createElement("span", { className: pn.title }, a), o && /* @__PURE__ */ t.createElement("span", { className: pn.trailing }, o));
}
const bc = "_badge_1qibj_1", Ec = "_sm_1qibj_11", gc = "_md_1qibj_16", vc = "_overdue_1qibj_21", kc = "_warning_1qibj_26", wc = "_progress_1qibj_31", Nc = "_success_1qibj_36", $c = "_info_1qibj_41", xc = "_neutral_1qibj_46", sa = {
  badge: bc,
  sm: Ec,
  md: gc,
  overdue: vc,
  warning: kc,
  progress: wc,
  success: Nc,
  info: $c,
  neutral: xc
};
function _2({
  label: e,
  tone: n = "neutral",
  size: a = "md",
  background: o,
  textColor: r
}) {
  const s = {};
  return o !== void 0 && (s.backgroundColor = o), r !== void 0 && (s.color = r), /* @__PURE__ */ t.createElement("span", { className: `${sa.badge} ${sa[n]} ${sa[a]}`, style: s }, e);
}
const Dc = "_wrapper_14p14_1", Cc = "_avatar_14p14_11", Sc = "_body_14p14_21", Ac = "_message_14p14_26", Mc = "_dots_14p14_32", Bc = "_dot_14p14_32", jc = "_action_14p14_70", Tc = "_actionIcon_14p14_89", Lc = "_gradientWrapper_14p14_95", qc = "_bareIcon_14p14_100", Ic = "_ctaButton_14p14_109", Be = {
  wrapper: Dc,
  avatar: Cc,
  body: Sc,
  message: Ac,
  dots: Mc,
  dot: Bc,
  action: jc,
  actionIcon: Tc,
  gradientWrapper: Lc,
  bareIcon: qc,
  ctaButton: Ic
};
function Ua() {
  return /* @__PURE__ */ t.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ t.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function Ya() {
  return /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ t.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function p2({
  message: e,
  accentColor: n = "#7C3AED",
  buttonLabel: a,
  buttonIcon: o,
  onAction: r,
  phase: s = "complete",
  variant: l = "card",
  gradientColors: i = ["#EEF4FF", "#F3EEFF"]
}) {
  const c = l === "gradient-cta";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [Be.wrapper, c ? Be.gradientWrapper : ""].join(" "),
      style: c ? { borderColor: `${n}33`, background: `linear-gradient(135deg, ${i[0]}, ${i[1]})` } : { borderColor: `${n}33` }
    },
    c ? /* @__PURE__ */ t.createElement("span", { className: Be.bareIcon, style: { color: n } }, /* @__PURE__ */ t.createElement(Ua, null)) : /* @__PURE__ */ t.createElement(
      "span",
      {
        className: Be.avatar,
        style: { backgroundColor: `${n}1A`, color: n }
      },
      /* @__PURE__ */ t.createElement(Ua, null)
    ),
    /* @__PURE__ */ t.createElement("div", { className: Be.body }, s === "loading" ? /* @__PURE__ */ t.createElement("span", { className: Be.dots }, /* @__PURE__ */ t.createElement("span", { className: Be.dot, style: { backgroundColor: n } }), /* @__PURE__ */ t.createElement("span", { className: Be.dot, style: { backgroundColor: n } }), /* @__PURE__ */ t.createElement("span", { className: Be.dot, style: { backgroundColor: n } })) : /* @__PURE__ */ t.createElement("span", { className: Be.message, style: c ? { color: n } : void 0 }, e)),
    a && r && (c ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Be.ctaButton,
        style: { backgroundColor: n },
        onClick: r
      },
      /* @__PURE__ */ t.createElement("span", null, a),
      /* @__PURE__ */ t.createElement("span", { className: Be.actionIcon }, o === void 0 ? /* @__PURE__ */ t.createElement(Ya, null) : o)
    ) : /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Be.action,
        style: { color: n },
        onClick: r
      },
      /* @__PURE__ */ t.createElement("span", null, a),
      /* @__PURE__ */ t.createElement("span", { className: Be.actionIcon }, o === void 0 ? /* @__PURE__ */ t.createElement(Ya, null) : o)
    ))
  );
}
const Fc = "_wrapper_68zkp_1", Rc = "_bordered_68zkp_13", Pc = "_compact_68zkp_17", Oc = "_icon_68zkp_23", Xc = "_title_68zkp_31", Wc = "_description_68zkp_38", zc = "_action_68zkp_46", At = {
  wrapper: Fc,
  bordered: Rc,
  compact: Pc,
  icon: Oc,
  title: Xc,
  description: Wc,
  action: zc
};
function Kc() {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ t.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function f2({
  icon: e,
  hideIcon: n = !1,
  title: a,
  titleColor: o,
  titleSize: r,
  titleWeight: s,
  description: l,
  actionLabel: i,
  onAction: c,
  bordered: u = !0,
  compact: m = !1
}) {
  const d = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [At.wrapper, u && !m ? At.bordered : "", m ? At.compact : ""].join(" ")
    },
    !n && /* @__PURE__ */ t.createElement("div", { className: At.icon }, e != null ? e : /* @__PURE__ */ t.createElement(Kc, null)),
    /* @__PURE__ */ t.createElement("p", { className: At.title, style: d }, a),
    l && /* @__PURE__ */ t.createElement("p", { className: At.description }, l),
    i && c && /* @__PURE__ */ t.createElement("button", { type: "button", className: At.action, onClick: c }, i)
  );
}
const Hc = "_wrapper_oide4_1", Gc = "_toggle_oide4_7", Uc = "_toggleOpen_oide4_29", Yc = "_panel_oide4_34", Vc = "_text_oide4_41", fn = {
  wrapper: Hc,
  toggle: Gc,
  toggleOpen: Uc,
  panel: Yc,
  text: Vc
};
function y2({
  label: e,
  summaryText: n,
  open: a,
  onToggle: o
}) {
  return /* @__PURE__ */ t.createElement("div", { className: fn.wrapper }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [fn.toggle, a ? fn.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": a
    },
    e
  ), a && /* @__PURE__ */ t.createElement("div", { className: fn.panel }, /* @__PURE__ */ t.createElement("p", { className: fn.text }, n)));
}
const Jc = "_wrapper_96dw1_1", Qc = "_labelRow_96dw1_8", Zc = "_label_96dw1_8", ei = "_value_96dw1_21", ti = "_track_96dw1_27", ni = "_xs_96dw1_35", ai = "_sm_96dw1_39", oi = "_md_96dw1_43", ri = "_square_96dw1_47", si = "_fill_96dw1_51", ct = {
  wrapper: Jc,
  labelRow: Qc,
  label: Zc,
  value: ei,
  track: ti,
  xs: ni,
  sm: ai,
  md: oi,
  square: ri,
  fill: si
};
function h2({
  value: e,
  max: n = 100,
  label: a,
  color: o = "#3B82F6",
  gradient: r,
  size: s = "md",
  rounded: l = !0,
  height: i,
  trackColor: c
}) {
  const u = n > 0 ? n : 100, m = Math.min(100, Math.max(0, e / u * 100)), d = r ? { width: `${m}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${m}%`, backgroundColor: o }, _ = {
    ...i !== void 0 ? { height: i } : {},
    ...c !== void 0 ? { background: c } : {}
  };
  return /* @__PURE__ */ t.createElement("div", { className: ct.wrapper }, a && /* @__PURE__ */ t.createElement("div", { className: ct.labelRow }, /* @__PURE__ */ t.createElement("span", { className: ct.label }, a), /* @__PURE__ */ t.createElement("span", { className: ct.value }, Math.round(m), "%")), /* @__PURE__ */ t.createElement("div", { className: [ct.track, ct[s], l ? "" : ct.square].join(" "), style: _ }, /* @__PURE__ */ t.createElement("div", { className: [ct.fill, l ? "" : ct.square].join(" "), style: d })));
}
const li = "_list_aixh6_1", ci = "_vertical_aixh6_8", ii = "_horizontal_aixh6_13", ui = "_item_aixh6_18", mi = "_iconWrap_aixh6_41", di = "_iconSvg_aixh6_51", _i = "_spin_aixh6_56", pi = "_label_aixh6_70", fi = "_item_active_aixh6_82", yi = "_item_done_aixh6_87", hi = "_connector_aixh6_91", bi = "_cardList_aixh6_114", Ei = "_cardItem_aixh6_122", gi = "_card_pending_aixh6_133", vi = "_card_active_aixh6_142", ki = "_card_done_aixh6_152", je = {
  list: li,
  vertical: ci,
  horizontal: ii,
  item: ui,
  iconWrap: mi,
  iconSvg: di,
  spin: _i,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: pi,
  item_active: fi,
  item_done: yi,
  connector: hi,
  cardList: bi,
  cardItem: Ei,
  card_pending: gi,
  card_active: vi,
  card_done: ki
};
function wi({ status: e }) {
  return e === "done" ? /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: je.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : e === "active" ? /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: [je.iconSvg, je.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: je.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function b2({
  steps: e,
  orientation: n = "vertical",
  variant: a = "timeline"
}) {
  const o = a === "card";
  return /* @__PURE__ */ t.createElement("ul", { className: [je.list, je[n], o ? je.cardList : ""].join(" ") }, e.map((r, s) => /* @__PURE__ */ t.createElement(
    "li",
    {
      key: `${r.label}-${s}`,
      className: [
        je.item,
        o ? je.cardItem : "",
        je[`item_${r.status}`],
        o ? je[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ t.createElement("span", { className: je.iconWrap }, /* @__PURE__ */ t.createElement(wi, { status: r.status })),
    /* @__PURE__ */ t.createElement("span", { className: je.label }, r.label),
    !o && s < e.length - 1 && /* @__PURE__ */ t.createElement("span", { className: je.connector })
  )));
}
const Ni = "_wrapper_1ohmw_1", $i = "_icon_1ohmw_7", xi = "_dots_1ohmw_14", Di = "_dot_1ohmw_14", Ci = "_sm_1ohmw_27", Si = "_md_1ohmw_32", Mt = {
  wrapper: Ni,
  icon: $i,
  dots: xi,
  dot: Di,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: Ci,
  md: Si
};
function E2({ withIcon: e, size: n = "md" }) {
  return /* @__PURE__ */ t.createElement("div", { className: Mt.wrapper }, e && /* @__PURE__ */ t.createElement("span", { className: Mt.icon }, e), /* @__PURE__ */ t.createElement("span", { className: [Mt.dots, Mt[n]].join(" ") }, /* @__PURE__ */ t.createElement("span", { className: Mt.dot }), /* @__PURE__ */ t.createElement("span", { className: Mt.dot }), /* @__PURE__ */ t.createElement("span", { className: Mt.dot })));
}
const Ai = "_container_85404_1", Mi = "_table_85404_9", Bi = "_row_85404_31", ji = "_striped_85404_35", Ti = "_clickable_85404_43", Li = "_alignLeft_85404_47", qi = "_alignCenter_85404_51", Ii = "_alignRight_85404_55", Fi = "_emptyCell_85404_59", it = {
  container: Ai,
  table: Mi,
  row: Bi,
  striped: ji,
  clickable: Ti,
  alignLeft: Li,
  alignCenter: qi,
  alignRight: Ii,
  emptyCell: Fi
};
function g2({
  columns: e,
  rows: n,
  striped: a = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const s = (l) => l === "center" ? it.alignCenter : l === "right" ? it.alignRight : it.alignLeft;
  return /* @__PURE__ */ t.createElement("div", { className: it.container }, /* @__PURE__ */ t.createElement("table", { className: it.table }, /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, e.map((l) => /* @__PURE__ */ t.createElement(
    "th",
    {
      key: l.key,
      className: s(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ t.createElement("tbody", null, n.length === 0 ? /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("td", { className: it.emptyCell, colSpan: e.length }, r)) : n.map((l, i) => {
    const c = [
      it.row,
      a && i % 2 === 1 ? it.striped : "",
      o ? it.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "tr",
      {
        key: i,
        className: c,
        onClick: o ? () => o(l, i) : void 0
      },
      e.map((u) => /* @__PURE__ */ t.createElement("td", { key: u.key, className: s(u.align) }, l[u.key]))
    );
  }))));
}
const Ri = "_grid_plbcd_1", Pi = "_cell_plbcd_6", Oi = "_primaryCell_plbcd_16", Xi = "_label_plbcd_21", Wi = "_value_plbcd_26", zi = "_note_plbcd_32", Ut = {
  grid: Ri,
  cell: Pi,
  primaryCell: Oi,
  label: Xi,
  value: Wi,
  note: zi
};
function v2({
  items: e,
  columns: n = 4,
  primaryFirst: a = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: s,
  valueColor: l,
  primaryBackground: i,
  primaryLabelColor: c,
  primaryValueColor: u,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: Ut.grid,
      style: { gridTemplateColumns: `repeat(${n}, 1fr)` }
    },
    e.map((d, _) => {
      const p = a && _ === 0, f = [Ut.cell, p ? Ut.primaryCell : ""].filter(Boolean).join(" "), y = {};
      o !== void 0 && (y.background = o), r !== void 0 && (y.borderColor = r), p && i !== void 0 && (y.background = i, y.borderColor = "transparent");
      const E = {};
      s !== void 0 && (E.color = s), p && c !== void 0 && (E.color = c);
      const g = {};
      l !== void 0 && (g.color = l), p && u !== void 0 && (g.color = u);
      const w = {};
      return p && m !== void 0 && (w.color = m), /* @__PURE__ */ t.createElement("div", { key: `${d.label}-${_}`, className: f, style: y }, /* @__PURE__ */ t.createElement("span", { className: Ut.label, style: E }, d.label), /* @__PURE__ */ t.createElement("span", { className: Ut.value, style: g }, d.value), d.note && /* @__PURE__ */ t.createElement("span", { className: Ut.note, style: w }, d.note));
    })
  );
}
const Ki = "_button_16ajt_1", Hi = "_disabledSolid_16ajt_19", Gi = "_icon_16ajt_26", Ui = "_label_16ajt_32", Yi = "_fullWidth_16ajt_37", Vi = "_sm_16ajt_41", Ji = "_md_16ajt_47", Qi = "_lg_16ajt_53", Zi = "_primary_16ajt_59", eu = "_secondary_16ajt_70", tu = "_outline_16ajt_81", nu = "_ghost_16ajt_93", au = "_active_16ajt_104", ou = "_colorOverride_16ajt_116", ru = "_gradient_16ajt_126", su = "_dashed_16ajt_135", lu = "_pill_16ajt_139", Re = {
  button: Ki,
  disabledSolid: Hi,
  icon: Gi,
  label: Ui,
  fullWidth: Yi,
  sm: Vi,
  md: Ji,
  lg: Qi,
  primary: Zi,
  secondary: eu,
  outline: tu,
  ghost: nu,
  active: au,
  colorOverride: ou,
  gradient: ru,
  dashed: su,
  pill: lu
};
function k2({
  variant: e = "primary",
  size: n = "md",
  icon: a,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: s = "dim",
  onClick: l,
  children: i,
  fullWidth: c = !1,
  type: u = "button",
  active: m = !1,
  color: d,
  background: _,
  borderColor: p,
  hoverColor: f,
  hoverBackground: y,
  gradient: E,
  borderStyle: g = "solid",
  shape: w = "rounded"
}) {
  const D = d !== void 0 || p !== void 0 || f !== void 0 || y !== void 0, k = [
    Re.button,
    Re[e],
    Re[n],
    c ? Re.fullWidth : "",
    r && s === "solid" ? Re.disabledSolid : "",
    m ? Re.active : "",
    D ? Re.colorOverride : "",
    E || _ ? Re.gradient : "",
    g === "dashed" ? Re.dashed : "",
    w === "pill" ? Re.pill : ""
  ].filter(Boolean).join(" "), b = {
    ...d !== void 0 ? { "--ax-btn-color": d } : {},
    ...p !== void 0 ? { "--ax-btn-border": p } : {},
    ...f !== void 0 ? { "--ax-btn-hover-color": f } : {},
    ...y !== void 0 ? { "--ax-btn-hover-bg": y } : {},
    ...E ? { background: `linear-gradient(135deg, ${E[0]}, ${E[1]})` } : {},
    ..._ !== void 0 ? { background: _ } : {}
  }, $ = a && /* @__PURE__ */ t.createElement("span", { className: Re.icon }, a);
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: u,
      className: k,
      style: b,
      disabled: r,
      onClick: l
    },
    o === "leading" && $,
    /* @__PURE__ */ t.createElement("span", { className: Re.label }, i),
    o === "trailing" && $
  );
}
const cu = "_iconButton_1oiog_1", iu = "_sm_1oiog_18", uu = "_md_1oiog_23", mu = "_lg_1oiog_28", du = "_plain_1oiog_33", _u = "_outline_1oiog_42", pu = "_circle_1oiog_53", fu = "_bordered_1oiog_62", yu = "_tint_1oiog_73", hu = "_active_1oiog_81", bu = "_hoverBgOverride_1oiog_92", Eu = "_gradient_1oiog_96", wt = {
  iconButton: cu,
  sm: iu,
  md: uu,
  lg: mu,
  plain: du,
  outline: _u,
  circle: pu,
  bordered: fu,
  tint: yu,
  active: hu,
  hoverBgOverride: bu,
  gradient: Eu
};
function w2({
  icon: e,
  title: n,
  active: a = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: s,
  onMouseDown: l,
  disabled: i = !1,
  color: c,
  hoverColor: u,
  bordered: m = !1,
  borderColor: d = "#e2e8f0",
  borderHoverColor: _ = "#3b82f6",
  tint: p = !1,
  tintColor: f = "#eef4ff",
  tintHoverColor: y = "#dbeafe",
  hoverBackground: E,
  gradient: g
}) {
  const w = typeof o == "number", D = [
    wt.iconButton,
    w ? "" : wt[o],
    wt[r],
    a ? wt.active : "",
    m ? wt.bordered : "",
    p ? wt.tint : "",
    E !== void 0 ? wt.hoverBgOverride : "",
    g ? wt.gradient : ""
  ].filter(Boolean).join(" "), k = {
    ...w ? { width: o, height: o } : {},
    ...c !== void 0 ? { "--ax-icon-color": c } : {},
    ...u !== void 0 ? { "--ax-icon-hover": u } : {},
    ...m ? { "--ax-icon-border": d, "--ax-icon-border-hover": _ } : {},
    ...p ? { "--ax-icon-tint": f, "--ax-icon-tint-hover": y } : {},
    ...E !== void 0 ? { "--ax-icon-hover-bg": E } : {},
    ...g ? { background: `linear-gradient(135deg, ${g[0]}, ${g[1]})` } : {}
  };
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: D,
      style: k,
      onClick: s,
      onMouseDown: l,
      disabled: i,
      title: n,
      "aria-label": n
    },
    e
  );
}
const gu = "_wrapper_wrch3_1", vu = "_searchIcon_wrch3_18", ku = "_input_wrch3_26", wu = "_clearButton_wrch3_40", Nu = "_hint_wrch3_60", yn = {
  wrapper: gu,
  searchIcon: vu,
  input: ku,
  clearButton: wu,
  hint: Nu
}, $u = /* @__PURE__ */ t.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ t.createElement("path", { d: "M21 21l-4.35-4.35" }));
function xu({
  value: e,
  onChange: n,
  placeholder: a,
  hint: o,
  onSubmit: r,
  onClear: s
}) {
  const l = (i) => {
    i.key === "Enter" && (r == null || r());
  };
  return /* @__PURE__ */ t.createElement("div", { className: yn.wrapper }, /* @__PURE__ */ t.createElement("span", { className: yn.searchIcon }, $u), /* @__PURE__ */ t.createElement(
    "input",
    {
      type: "text",
      className: yn.input,
      value: e,
      placeholder: a,
      onChange: (i) => n(i.target.value),
      onKeyDown: l
    }
  ), s && e.length > 0 && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: yn.clearButton,
      onClick: s,
      "aria-label": "clear"
    },
    /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ t.createElement("path", { d: "M6 6l12 12" }))
  ), o && /* @__PURE__ */ t.createElement("span", { className: yn.hint }, o));
}
const Du = "_control_1kv40_1", Cu = "_option_1kv40_10", Su = "_active_1kv40_28", Au = "_sm_1kv40_37", Mu = "_md_1kv40_43", Bu = "_dot_1kv40_49", ju = "_count_1kv40_56", Tu = "_outline_1kv40_70", Lu = "_outlineOption_1kv40_75", ut = {
  control: Du,
  option: Cu,
  active: Su,
  sm: Au,
  md: Mu,
  dot: Bu,
  count: ju,
  outline: Tu,
  outlineOption: Lu
};
function N2({
  options: e,
  value: n,
  onChange: a,
  size: o = "md",
  variant: r = "filled",
  activeBackground: s,
  activeColor: l,
  activeBorderColor: i
}) {
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [ut.control, ut[o], r === "outline" ? ut.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    e.map((c) => {
      const u = c.value === n, m = u ? {
        ...s !== void 0 ? { background: s } : {},
        ...l !== void 0 ? { color: l } : {},
        ...i !== void 0 ? { borderColor: i } : {}
      } : void 0;
      return /* @__PURE__ */ t.createElement(
        "button",
        {
          key: c.value,
          type: "button",
          role: "tab",
          "aria-selected": u,
          className: [ut.option, u ? ut.active : "", r === "outline" ? ut.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => a(c.value)
        },
        c.dot && /* @__PURE__ */ t.createElement("span", { className: ut.dot, style: { backgroundColor: c.dot } }),
        /* @__PURE__ */ t.createElement("span", { className: ut.label }, c.label),
        typeof c.count == "number" && /* @__PURE__ */ t.createElement("span", { className: ut.count }, c.count)
      );
    })
  );
}
const qu = "_chip_8jgxm_1", Iu = "_clickable_8jgxm_14", Fu = "_suggested_8jgxm_23", Ru = "_readonly_8jgxm_33", Pu = "_plusIcon_8jgxm_39", Ou = "_label_8jgxm_45", Xu = "_removeButton_8jgxm_50", Yt = {
  chip: qu,
  clickable: Iu,
  default: "_default_8jgxm_18",
  suggested: Fu,
  readonly: Ru,
  plusIcon: Pu,
  label: Ou,
  removeButton: Xu
};
function $2({
  label: e,
  variant: n = "default",
  onRemove: a,
  onClick: o,
  background: r,
  textColor: s,
  borderColor: l
}) {
  const i = [Yt.chip, Yt[n], o ? Yt.clickable : ""].filter(Boolean).join(" "), u = r !== void 0 || s !== void 0 || l !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...s !== void 0 ? { color: s } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, m = n !== "readonly" && !!a, d = /* @__PURE__ */ t.createElement(t.Fragment, null, n === "suggested" && /* @__PURE__ */ t.createElement("span", { className: Yt.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ t.createElement("span", { className: Yt.label }, e), m && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Yt.removeButton,
      "aria-label": `remove ${e}`,
      onClick: (_) => {
        _.stopPropagation(), a == null || a();
      }
    },
    /* @__PURE__ */ t.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ t.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ t.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: i,
      style: u,
      onClick: o,
      onKeyDown: (_) => {
        (_.key === "Enter" || _.key === " ") && (_.preventDefault(), o());
      }
    },
    d
  ) : /* @__PURE__ */ t.createElement("span", { className: i, style: u }, d);
}
const Wu = "_wrapper_15dm4_1", zu = "_disabled_15dm4_8", Ku = "_track_15dm4_13", Hu = "_checked_15dm4_30", Gu = "_thumb_15dm4_34", Uu = "_label_15dm4_50", Vt = {
  wrapper: Wu,
  disabled: zu,
  track: Ku,
  checked: Hu,
  thumb: Gu,
  label: Uu
};
function x2({
  checked: e,
  onChange: n,
  labelOn: a,
  labelOff: o,
  disabled: r = !1,
  color: s
}) {
  const l = e ? a : o;
  return /* @__PURE__ */ t.createElement("label", { className: [Vt.wrapper, r ? Vt.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": e,
      disabled: r,
      className: [Vt.track, e ? Vt.checked : ""].filter(Boolean).join(" "),
      style: e && s !== void 0 ? { background: s } : void 0,
      onClick: () => !r && n(!e)
    },
    /* @__PURE__ */ t.createElement("span", { className: Vt.thumb })
  ), l && /* @__PURE__ */ t.createElement("span", { className: Vt.label }, l));
}
const Yu = "_card_1uh3t_1", Vu = "_active_1uh3t_24", Ju = "_iconChip_1uh3t_29", Qu = "_body_1uh3t_41", Zu = "_label_1uh3t_48", em = "_description_1uh3t_54", Jt = {
  card: Yu,
  active: Vu,
  iconChip: Ju,
  body: Qu,
  label: Zu,
  description: em
};
function D2(e) {
  const { icon: n, label: a, description: o, active: r = !1, onClick: s } = e;
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${Jt.card} ${r ? Jt.active : ""}`,
      onClick: s,
      "aria-pressed": r
    },
    /* @__PURE__ */ t.createElement("span", { className: Jt.iconChip }, n),
    /* @__PURE__ */ t.createElement("span", { className: Jt.body }, /* @__PURE__ */ t.createElement("span", { className: Jt.label }, a), o && /* @__PURE__ */ t.createElement("span", { className: Jt.description }, o))
  );
}
const tm = "_breadcrumb_zkol9_1", nm = "_list_zkol9_6", am = "_item_zkol9_16", om = "_link_zkol9_22", rm = "_plain_zkol9_43", sm = "_current_zkol9_48", lm = "_separator_zkol9_54", Bt = {
  breadcrumb: tm,
  list: nm,
  item: am,
  link: om,
  plain: rm,
  current: sm,
  separator: lm
};
function C2(e) {
  const { items: n, separator: a = "/", textColor: o, hoverColor: r, currentColor: s } = e, l = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...s !== void 0 ? { "--ax-bc-current": s } : {}
  };
  return /* @__PURE__ */ t.createElement("nav", { className: Bt.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ t.createElement("ol", { className: Bt.list }, n.map((i, c) => {
    const u = c === n.length - 1;
    return /* @__PURE__ */ t.createElement("li", { key: c, className: Bt.item }, u ? /* @__PURE__ */ t.createElement("span", { className: Bt.current, "aria-current": "page" }, i.label) : i.onClick ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Bt.link,
        onClick: i.onClick
      },
      i.label
    ) : /* @__PURE__ */ t.createElement("span", { className: Bt.plain }, i.label), !u && /* @__PURE__ */ t.createElement("span", { className: Bt.separator, "aria-hidden": "true" }, a));
  })));
}
const cm = "_treeItem_1ouqz_1", im = "_active_1ouqz_18", um = "_chevron_1ouqz_28", mm = "_chevronExpanded_1ouqz_48", dm = "_chevronSpacer_1ouqz_52", _m = "_icon_1ouqz_57", pm = "_label_1ouqz_69", fm = "_count_1ouqz_76", ym = "_dark_1ouqz_86", mt = {
  treeItem: cm,
  active: im,
  chevron: um,
  chevronExpanded: mm,
  chevronSpacer: dm,
  icon: _m,
  label: pm,
  count: fm,
  dark: ym
};
function S2(e) {
  const {
    icon: n,
    label: a,
    count: o,
    indent: r = 0,
    active: s = !1,
    expandable: l = !1,
    expanded: i = !1,
    theme: c = "light",
    onToggleExpand: u,
    onClick: m
  } = e, d = (p) => {
    p.stopPropagation(), u == null || u();
  }, _ = c === "dark" ? mt.dark : "";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: `${mt.treeItem} ${_} ${s ? mt.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": s,
      "aria-expanded": l ? i : void 0
    },
    l ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: `${mt.chevron} ${i ? mt.chevronExpanded : ""}`,
        onClick: d,
        "aria-label": i ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ t.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ t.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ t.createElement("span", { className: mt.chevronSpacer }),
    n && /* @__PURE__ */ t.createElement("span", { className: mt.icon }, n),
    /* @__PURE__ */ t.createElement("span", { className: mt.label }, a),
    typeof o == "number" && /* @__PURE__ */ t.createElement("span", { className: mt.count }, o)
  );
}
const hm = "_backdrop_gstyy_1", bm = "_panel_gstyy_9", Em = "_right_gstyy_21", gm = "_left_gstyy_27", vm = "_header_gstyy_51", km = "_icon_gstyy_59", wm = "_titleGroup_gstyy_66", Nm = "_kicker_gstyy_71", $m = "_title_gstyy_66", xm = "_subtitle_gstyy_87", Dm = "_closeButton_gstyy_93", Cm = "_body_gstyy_115", Sm = "_footer_gstyy_123", Le = {
  backdrop: hm,
  panel: bm,
  right: Em,
  left: gm,
  header: vm,
  icon: km,
  titleGroup: wm,
  kicker: Nm,
  title: $m,
  subtitle: xm,
  closeButton: Dm,
  body: Cm,
  footer: Sm
};
function A2({
  open: e,
  onClose: n,
  icon: a,
  kicker: o,
  title: r,
  titleSize: s,
  titleWeight: l,
  subtitle: i,
  footer: c,
  children: u,
  side: m = "right",
  headerBackground: d,
  topOffset: _
}) {
  if (!e)
    return null;
  const p = [Le.panel, m === "left" ? Le.left : Le.right].filter(Boolean).join(" "), f = {
    ...s !== void 0 ? { fontSize: s } : {},
    ...l !== void 0 ? { fontWeight: l } : {}
  }, y = _ !== void 0 ? { top: _, height: `calc(100vh - ${_}px)` } : void 0;
  return /* @__PURE__ */ t.createElement("div", { className: Le.backdrop, onClick: n }, /* @__PURE__ */ t.createElement("div", { className: p, style: y, onClick: (E) => E.stopPropagation() }, /* @__PURE__ */ t.createElement("div", { className: Le.header, style: d !== void 0 ? { background: d } : void 0 }, a && /* @__PURE__ */ t.createElement("span", { className: Le.icon }, a), /* @__PURE__ */ t.createElement("div", { className: Le.titleGroup }, o && /* @__PURE__ */ t.createElement("p", { className: Le.kicker }, o), /* @__PURE__ */ t.createElement("h2", { className: Le.title, style: f }, r), i && /* @__PURE__ */ t.createElement("p", { className: Le.subtitle }, i)), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Le.closeButton,
      onClick: n,
      "aria-label": "닫기"
    },
    "×"
  )), /* @__PURE__ */ t.createElement("div", { className: Le.body }, u), c && /* @__PURE__ */ t.createElement("div", { className: Le.footer }, c)));
}
const Am = "_backdrop_6kso7_1", Mm = "_menu_6kso7_8", Bm = "_alignRight_6kso7_24", jm = "_alignLeft_6kso7_28", Tm = "_item_6kso7_32", Lm = "_itemIcon_6kso7_50", qm = "_itemText_6kso7_59", Im = "_itemLabel_6kso7_66", Fm = "_itemDescription_6kso7_72", Rm = "_danger_6kso7_77", Ve = {
  backdrop: Am,
  menu: Mm,
  alignRight: Bm,
  alignLeft: jm,
  item: Tm,
  itemIcon: Lm,
  itemText: qm,
  itemLabel: Im,
  itemDescription: Fm,
  danger: Rm
};
function M2({
  open: e,
  onClose: n,
  items: a,
  anchor: o = "right"
}) {
  if (!e)
    return null;
  const r = [Ve.menu, o === "left" ? Ve.alignLeft : Ve.alignRight].filter(Boolean).join(" "), s = (l) => {
    l.onClick(), n();
  };
  return /* @__PURE__ */ t.createElement(Lo, null, /* @__PURE__ */ t.createElement("div", { className: Ve.backdrop, onClick: n }), /* @__PURE__ */ t.createElement("div", { className: r, onClick: (l) => l.stopPropagation() }, a.map((l, i) => {
    const c = [Ve.item, l.danger ? Ve.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: i,
        type: "button",
        className: c,
        onClick: () => s(l)
      },
      l.icon && /* @__PURE__ */ t.createElement("span", { className: Ve.itemIcon }, l.icon),
      /* @__PURE__ */ t.createElement("span", { className: Ve.itemText }, /* @__PURE__ */ t.createElement("span", { className: Ve.itemLabel }, l.label), l.description && /* @__PURE__ */ t.createElement("span", { className: Ve.itemDescription }, l.description))
    );
  })));
}
const Pm = "_backdrop_3pc9i_1", Om = "_card_3pc9i_12", Xm = "_header_3pc9i_23", Wm = "_icon_3pc9i_31", zm = "_titleGroup_3pc9i_38", Km = "_title_3pc9i_38", Hm = "_subtitle_3pc9i_50", Gm = "_closeButton_3pc9i_56", Um = "_body_3pc9i_78", Ym = "_footer_3pc9i_85", Je = {
  backdrop: Pm,
  card: Om,
  header: Xm,
  icon: Wm,
  titleGroup: zm,
  title: Km,
  subtitle: Hm,
  closeButton: Gm,
  body: Um,
  footer: Ym
};
function B2({
  open: e,
  onClose: n,
  icon: a,
  title: o,
  subtitle: r,
  footer: s,
  width: l = 480,
  children: i
}) {
  if (!e)
    return null;
  const c = typeof l == "number" ? `${l}px` : l;
  return /* @__PURE__ */ t.createElement("div", { className: Je.backdrop, onClick: n }, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: Je.card,
      style: { width: c },
      onClick: (u) => u.stopPropagation()
    },
    /* @__PURE__ */ t.createElement("div", { className: Je.header }, a && /* @__PURE__ */ t.createElement("span", { className: Je.icon }, a), /* @__PURE__ */ t.createElement("div", { className: Je.titleGroup }, /* @__PURE__ */ t.createElement("h2", { className: Je.title }, o), r && /* @__PURE__ */ t.createElement("p", { className: Je.subtitle }, r)), /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Je.closeButton,
        onClick: n,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ t.createElement("div", { className: Je.body }, i),
    s && /* @__PURE__ */ t.createElement("div", { className: Je.footer }, s)
  ));
}
const Vm = "_page_1f94v_5", Jm = "_inner_1f94v_18", Va = {
  page: Vm,
  inner: Jm
};
function j2({
  gnbHeight: e = 64,
  minWidth: n = 1024,
  className: a = "",
  style: o,
  children: r
}) {
  return /* @__PURE__ */ t.createElement(
    "main",
    {
      className: [Va.page, "axe-page", a].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...o }
    },
    /* @__PURE__ */ t.createElement("div", { className: Va.inner, style: { minWidth: n } }, r)
  );
}
const Qm = "_orbitPortalRoot_177qv_2", Zm = {
  orbitPortalRoot: Qm
};
class un extends qo {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const n = this.props.portalClassName || Zm.orbitPortalRoot, a = Array.from(document.body.childNodes).find((o) => o.className === n);
      if (!a) {
        const o = document.createElement("div");
        return o.className = n, document.body.appendChild(o), o;
      }
      return a;
    };
  }
  render() {
    return Sr(this.props.children, this.getPortalRoot());
  }
}
const ed = "_anchor_7h2m7_2", td = "_tip_7h2m7_5", Ja = {
  anchor: ed,
  tip: td
};
let nd = 0;
function ea({
  content: e,
  children: n,
  placement: a = "bottom",
  delay: o = 250,
  focusable: r,
  describe: s = !0,
  className: l = ""
}) {
  const [i, c] = A(!1), [u, m] = A({ top: 0, left: 0 }), d = I(null), _ = I(null), p = I(null), f = I("");
  f.current || (f.current = `axe-tip-${++nd}`);
  const y = () => {
    p.current && (clearTimeout(p.current), p.current = null);
  }, E = (k) => {
    y(), k <= 0 ? c(!0) : p.current = setTimeout(() => c(!0), k);
  }, g = () => {
    y(), c(!1);
  };
  if (Z(() => y, []), He(() => {
    if (!i) return;
    const k = () => {
      const b = d.current, $ = _.current;
      if (!b || !$) return;
      const h = b.getBoundingClientRect(), v = $.offsetHeight, x = $.offsetWidth;
      let C = a === "top" ? h.top - v - 6 : h.bottom + 6;
      a === "bottom" && C + v > window.innerHeight - 4 && h.top - v - 6 > 4 && (C = h.top - v - 6), a === "top" && C < 4 && h.bottom + 6 + v < window.innerHeight - 4 && (C = h.bottom + 6);
      const B = Math.max(4, Math.min(h.left + h.width / 2 - x / 2, window.innerWidth - x - 4));
      m((R) => R.top === C && R.left === B ? R : { top: C, left: B });
    };
    return k(), window.addEventListener("resize", k), window.addEventListener("scroll", k, !0), () => {
      window.removeEventListener("resize", k), window.removeEventListener("scroll", k, !0);
    };
  }, [i, a, e]), Z(() => {
    if (!i) return;
    const k = (b) => {
      b.key === "Escape" && g();
    };
    return document.addEventListener("keydown", k), () => document.removeEventListener("keydown", k);
  }, [i]), !(e != null && e !== !1 && e !== "")) return n;
  const D = Kn(n) ? Io(n, i && s ? { "aria-describedby": f.current } : {}) : n;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      ref: d,
      className: [Ja.anchor, l].filter(Boolean).join(" "),
      tabIndex: r ? 0 : void 0,
      onMouseEnter: () => E(o),
      onMouseLeave: g,
      onFocus: () => E(0),
      onBlur: g
    },
    D,
    i && /* @__PURE__ */ t.createElement(un, null, /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: _,
        id: f.current,
        role: "tooltip",
        className: Ja.tip,
        style: { top: u.top, left: u.left },
        onMouseEnter: y,
        onMouseLeave: g
      },
      e
    ))
  );
}
const ad = "_bar_j0oph_1", od = "_menu_j0oph_9", rd = "_title_j0oph_19", sd = "_info_j0oph_21", ld = "_badge_j0oph_29", cd = "_badge_muted_j0oph_30", id = "_badge_ok_j0oph_31", ud = "_badge_warn_j0oph_32", md = "_meta_j0oph_34", dd = "_actions_j0oph_18", _d = "_notice_j0oph_48", pd = "_notice_info_j0oph_53", fd = "_notice_ok_j0oph_54", yd = "_notice_err_j0oph_55", Qe = {
  bar: ad,
  menu: od,
  title: rd,
  info: sd,
  badge: ld,
  badge_muted: cd,
  badge_ok: id,
  badge_warn: ud,
  meta: md,
  actions: dd,
  notice: _d,
  notice_info: pd,
  notice_ok: fd,
  notice_err: yd
};
function T2({
  title: e,
  onMenu: n,
  info: a,
  badge: o,
  meta: r,
  notice: s,
  children: l
}) {
  var i;
  return /* @__PURE__ */ t.createElement("header", { className: Qe.bar }, n && /* @__PURE__ */ t.createElement("button", { type: "button", className: Qe.menu, "aria-label": "메뉴", onClick: n }, "☰"), /* @__PURE__ */ t.createElement("h1", { className: Qe.title }, e), a && /* @__PURE__ */ t.createElement(ea, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ t.createElement("span", { className: Qe.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(o) ? o : [o]).filter(Boolean).map((c, u) => {
    var m;
    return /* @__PURE__ */ t.createElement("span", { key: u, className: [Qe.badge, Qe[`badge_${(m = c.tone) != null ? m : "muted"}`]].join(" ") }, c.label);
  }), r && /* @__PURE__ */ t.createElement("span", { className: Qe.meta }, r), /* @__PURE__ */ t.createElement("span", { className: Qe.actions }, s && s.text && /* @__PURE__ */ t.createElement("span", { className: [Qe.notice, Qe[`notice_${(i = s.tone) != null ? i : "info"}`]].join(" "), role: "status" }, s.text), l));
}
const hd = "_btn_a0orf_1", bd = "_sm_a0orf_18", Ed = "_primary_a0orf_21", gd = "_dark_a0orf_23", vd = "_danger_a0orf_25", kd = "_soon_a0orf_29", wd = "_soonTag_a0orf_30", Nd = "_blocked_a0orf_39", $d = "_kbd_a0orf_51", xd = "_iconBtn_a0orf_54", Dd = "_link_a0orf_70", ft = {
  btn: hd,
  sm: bd,
  primary: Ed,
  dark: gd,
  danger: vd,
  soon: kd,
  soonTag: wd,
  blocked: Nd,
  kbd: $d,
  iconBtn: xd,
  link: Dd
}, on = Dr(function({
  variant: n = "default",
  size: a = "md",
  kbd: o,
  soon: r,
  blockedReason: s,
  children: l,
  className: i = "",
  type: c = "button",
  onClick: u,
  title: m,
  disabled: d,
  ..._
}, p) {
  const f = r || s || "", y = f !== "", E = /* @__PURE__ */ t.createElement(
    "button",
    {
      ref: p,
      type: c,
      className: [ft.btn, ft[n], a === "sm" ? ft.sm : "", r ? ft.soon : y ? ft.blocked : "", i].filter(Boolean).join(" "),
      "aria-disabled": y ? !0 : void 0,
      disabled: y ? void 0 : d,
      title: y ? void 0 : m,
      onClick: y ? (g) => g.preventDefault() : u,
      ..._
    },
    l,
    o && /* @__PURE__ */ t.createElement("kbd", { className: ft.kbd }, o),
    r && /* @__PURE__ */ t.createElement("em", { className: ft.soonTag }, "준비 중")
  );
  return y ? /* @__PURE__ */ t.createElement(ea, { content: f }, E) : E;
});
function ka({ label: e, children: n, className: a = "", type: o = "button", ...r }) {
  return /* @__PURE__ */ t.createElement(ea, { content: e, describe: !1 }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: o,
      className: [ft.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...r
    },
    n
  ));
}
function Ba({ children: e, className: n = "", type: a = "button", ...o }) {
  return /* @__PURE__ */ t.createElement("button", { type: a, className: [ft.link, n].filter(Boolean).join(" "), ...o }, e);
}
const Cd = "_wrap_ngnft_1", Sd = "_btn_ngnft_2", Ad = "_on_ngnft_6", Md = "_caret_ngnft_8", Bd = "_pop_ngnft_9", jd = "_sec_ngnft_14", Td = "_item_ngnft_17", Ld = "_danger_ngnft_24", Nt = {
  wrap: Cd,
  btn: Sd,
  on: Ad,
  caret: Md,
  pop: Bd,
  sec: jd,
  item: Td,
  danger: Ld
}, qd = (e, n, a, o = {}) => ({ kind: "item", key: e, label: n, onClick: a, ...o }), L2 = (e, n, a) => ({ kind: "section", key: e, label: n, note: a });
function Id({ label: e, entries: n, disabled: a, title: o }) {
  const [r, s] = A(!1), l = I(null), i = I(null), c = I(null), u = () => {
    var d, _;
    return Array.from((_ = (d = c.current) == null ? void 0 : d.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? _ : []);
  };
  Z(() => {
    var d;
    r && ((d = u()[0]) == null || d.focus());
  }, [r]), Z(() => {
    if (!r) return;
    const d = (p) => {
      l.current && !l.current.contains(p.target) && s(!1);
    }, _ = (p) => {
      var f;
      p.key === "Escape" && (s(!1), (f = i.current) == null || f.focus());
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", _), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", _);
    };
  }, [r]);
  const m = (d) => {
    const _ = u();
    if (_.length === 0) return;
    const p = _.indexOf(document.activeElement);
    let f = -1;
    if (d.key === "ArrowDown") f = (p + 1) % _.length;
    else if (d.key === "ArrowUp") f = (p <= 0 ? _.length : p) - 1;
    else if (d.key === "Home") f = 0;
    else if (d.key === "End") f = _.length - 1;
    else if (d.key === "Tab") {
      s(!1);
      return;
    } else return;
    d.preventDefault(), _[f].focus();
  };
  return /* @__PURE__ */ t.createElement("span", { className: Nt.wrap, ref: l }, /* @__PURE__ */ t.createElement(
    "button",
    {
      ref: i,
      type: "button",
      className: [Nt.btn, r ? Nt.on : ""].join(" "),
      disabled: a,
      title: o,
      "aria-haspopup": "menu",
      "aria-expanded": r,
      onClick: () => s((d) => !d),
      onKeyDown: (d) => {
        d.key === "ArrowDown" && !r && (d.preventDefault(), s(!0));
      }
    },
    e,
    /* @__PURE__ */ t.createElement("span", { className: Nt.caret, "aria-hidden": "true" }, "▾")
  ), r && /* @__PURE__ */ t.createElement("div", { ref: c, className: Nt.pop, role: "menu", onKeyDown: m }, n.map((d) => d.kind === "section" ? /* @__PURE__ */ t.createElement("div", { key: d.key, className: Nt.sec }, d.label, d.note && /* @__PURE__ */ t.createElement("small", null, d.note)) : /* @__PURE__ */ t.createElement(
    "button",
    {
      key: d.key,
      type: "button",
      role: "menuitem",
      disabled: d.disabled,
      className: [Nt.item, d.danger ? Nt.danger : ""].join(" "),
      onClick: () => {
        var _;
        s(!1), (_ = i.current) == null || _.focus(), d.onClick();
      }
    },
    /* @__PURE__ */ t.createElement("span", null, d.label),
    d.disabled && d.reason && /* @__PURE__ */ t.createElement("small", null, d.reason)
  ))));
}
function q2(e, n, a = !0) {
  const o = I(n);
  o.current = n, Z(() => {
    if (!a) return;
    const r = (s) => {
      if (s.key !== "Enter" || !(s.ctrlKey || s.metaKey) || s.isComposing || s.repeat || s.defaultPrevented) return;
      const l = e.current, i = document.activeElement;
      !l || !i || !l.contains(i) || (s.preventDefault(), o.current());
    };
    return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
  }, [e, a]);
}
function Fd() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Rd = "_bar_1g564_2", Pd = "_sticky_1g564_12", Od = "_start_1g564_19", Xd = "_end_1g564_20", Wd = "_status_1g564_22", zd = "_dirty_1g564_23", Kd = "_kbd_1g564_25", jt = {
  bar: Rd,
  sticky: Pd,
  start: Od,
  end: Xd,
  status: Wd,
  dirty: zd,
  kbd: Kd
};
function I2({ start: e, children: n, status: a, dirty: o, inline: r, shortcutHint: s, className: l = "" }) {
  return /* @__PURE__ */ t.createElement("div", { className: ["axe-save-bar", jt.bar, r ? "" : jt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ t.createElement("span", { className: jt.start }, e), /* @__PURE__ */ t.createElement("span", { className: jt.end }, a && /* @__PURE__ */ t.createElement("span", { className: [jt.status, o ? jt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), n, s && /* @__PURE__ */ t.createElement("kbd", { className: jt.kbd }, Fd())));
}
const Hd = {
  print: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ t.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ t.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ t.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ t.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ t.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ t.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ t.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ t.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ t.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ t.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ t.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Gd = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Ud({ name: e, className: n }) {
  return /* @__PURE__ */ t.createElement("span", { className: n, "aria-hidden": "true" }, Gd[e]);
}
function Hn({ name: e, size: n = 15, className: a }) {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: a,
      width: n,
      height: n,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Hd[e]
  );
}
const Yd = "_root_j67qt_2", Vd = "_closed_j67qt_3", Jd = "_tab_j67qt_6", Qd = "_collapse_j67qt_7", Zd = "_body_j67qt_16", e_ = "_card_j67qt_32", t_ = "_head_j67qt_37", n_ = "_cardOpen_j67qt_44", a_ = "_headBtn_j67qt_47", o_ = "_icon_j67qt_56", r_ = "_badge_j67qt_57", s_ = "_trailing_j67qt_58", l_ = "_chev_j67qt_59", c_ = "_panelWrap_j67qt_63", i_ = "_panelOpen_j67qt_67", u_ = "_panelBody_j67qt_68", m_ = "_panelInner_j67qt_69", d_ = "_panelSettled_j67qt_70", ge = {
  root: Yd,
  closed: Vd,
  tab: Jd,
  collapse: Qd,
  body: Zd,
  card: e_,
  head: t_,
  cardOpen: n_,
  headBtn: a_,
  icon: o_,
  badge: r_,
  trailing: s_,
  chev: l_,
  panelWrap: c_,
  panelOpen: i_,
  panelBody: u_,
  panelInner: m_,
  panelSettled: d_
}, __ = 1280, p_ = 8, Ho = "axe-side-bar:";
function f_(e) {
  if (!e) return null;
  try {
    const n = window.localStorage.getItem(Ho + e);
    return n === "1" ? !0 : n === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function y_(e, n) {
  if (e)
    try {
      window.localStorage.setItem(Ho + e, n ? "1" : "0");
    } catch {
    }
}
function F2({
  enabled: e = !0,
  defaultOpen: n = !0,
  width: a = 260,
  collapseBelow: o = __,
  storageKey: r,
  className: s = "",
  children: l
}) {
  var _;
  const i = I(f_(r)), [c, u] = A((_ = i.current) != null ? _ : n), m = I(i.current !== null);
  if (Z(() => {
    if (!e || !o || typeof window.matchMedia != "function") return;
    const p = window.matchMedia(`(max-width: ${o - 1}px)`), f = () => {
      m.current || u(!p.matches && n);
    };
    return f(), p.addEventListener ? p.addEventListener("change", f) : p.addListener(f), () => {
      p.removeEventListener ? p.removeEventListener("change", f) : p.removeListener(f);
    };
  }, [e, o, n]), !e) return null;
  const d = () => {
    m.current = !0, y_(r, !c), u(!c);
  };
  return /* @__PURE__ */ t.createElement(
    "aside",
    {
      className: ["axe-side-bar", ge.root, c ? "" : ge.closed, s].filter(Boolean).join(" "),
      style: { width: c ? a : p_ }
    },
    /* @__PURE__ */ t.createElement("div", { className: ge.tab }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: ge.collapse,
        onClick: d,
        title: c ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": c
      },
      /* @__PURE__ */ t.createElement(Ud, { name: c ? "collapse" : "expand" })
    )),
    /* @__PURE__ */ t.createElement("div", { className: ge.body }, l)
  );
}
const Go = Fo(null);
function R2({ children: e, defaultOpenId: n = null, exclusive: a = !0 }) {
  const [o, r] = A(n);
  return a ? /* @__PURE__ */ t.createElement(Go.Provider, { value: { openId: o, setOpenId: r } }, e) : /* @__PURE__ */ t.createElement(t.Fragment, null, e);
}
const Uo = "axe-side-panel:";
function h_(e) {
  if (!e) return null;
  try {
    const n = window.localStorage.getItem(Uo + e);
    return n === "1" ? !0 : n === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function b_(e, n) {
  if (e)
    try {
      window.localStorage.setItem(Uo + e, n ? "1" : "0");
    } catch {
    }
}
function P2({
  title: e,
  enabled: n = !0,
  defaultOpen: a = !0,
  icon: o,
  badge: r,
  trailing: s,
  storageKey: l,
  panelId: i,
  className: c = "",
  children: u
}) {
  var b;
  const m = Ro(Go), d = !!m && i != null, _ = I(h_(l)), [p, f] = A((b = _.current) != null ? b : a), y = d ? m.openId === i : p, [E, g] = A(y), [w, D] = A(y);
  if (!n) return null;
  y && !E && g(!0);
  const k = () => {
    const $ = !y;
    b_(l, $), g(!0), D(!1), d ? m.setOpenId($ ? i : null) : f($);
  };
  return /* @__PURE__ */ t.createElement("section", { className: ["axe-side-card", ge.card, y ? ge.cardOpen : "", c].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("header", { className: ge.head, onClick: k }, /* @__PURE__ */ t.createElement("button", { type: "button", className: ge.headBtn, "aria-expanded": y }, o && /* @__PURE__ */ t.createElement("span", { className: ge.icon, "aria-hidden": "true" }, o), /* @__PURE__ */ t.createElement("strong", null, e)), r && /* @__PURE__ */ t.createElement("span", { className: ge.badge }, r), s && /* @__PURE__ */ t.createElement("span", { className: ge.trailing, onClick: ($) => $.stopPropagation() }, s), /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: ge.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ t.createElement("path", { d: "M6 9l6 6 6-6" })
  )), E && /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [ge.panelWrap, y ? ge.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: ($) => {
        $.target === $.currentTarget && $.propertyName === "grid-template-rows" && D(!0);
      }
    },
    /* @__PURE__ */ t.createElement("div", { className: [ge.panelBody, y && w ? ge.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: ge.panelInner }, u))
  ));
}
const E_ = "_guide_qnh7l_1", g_ = "_title_qnh7l_5", v_ = "_desc_qnh7l_6", k_ = "_act_qnh7l_7", w_ = "_why_qnh7l_13", N_ = "_steps_qnh7l_14", $_ = "_no_qnh7l_20", x_ = "_cur_qnh7l_24", D_ = "_link_qnh7l_26", dt = {
  guide: E_,
  title: g_,
  desc: v_,
  act: k_,
  why: w_,
  steps: N_,
  no: $_,
  cur: x_,
  link: D_
};
function O2({ title: e, desc: n, action: a, steps: o }) {
  return /* @__PURE__ */ t.createElement("section", { className: dt.guide, "aria-label": e }, /* @__PURE__ */ t.createElement("h2", { className: dt.title }, e), n && /* @__PURE__ */ t.createElement("p", { className: dt.desc }, n), a && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("button", { type: "button", className: dt.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ t.createElement("p", { className: dt.why }, a.reason)), o && o.length > 0 && /* @__PURE__ */ t.createElement("ol", { className: dt.steps }, o.map((r, s) => /* @__PURE__ */ t.createElement("li", { key: r.label, className: r.current ? dt.cur : void 0 }, /* @__PURE__ */ t.createElement("span", { className: dt.no }, s + 1), r.onClick && !r.current ? /* @__PURE__ */ t.createElement("button", { type: "button", className: dt.link, onClick: r.onClick }, r.label) : /* @__PURE__ */ t.createElement("span", null, r.label), r.hint && /* @__PURE__ */ t.createElement("small", null, r.hint)))));
}
const C_ = "_list_1w2rs_1", S_ = "_row_1w2rs_2", A_ = "_label_1w2rs_6", M_ = "_value_1w2rs_7", B_ = "_emphasis_1w2rs_8", j_ = "_changed_1w2rs_10", Qt = {
  list: C_,
  row: S_,
  label: A_,
  value: M_,
  emphasis: B_,
  changed: j_
};
function X2({ items: e, className: n }) {
  return /* @__PURE__ */ t.createElement("dl", { className: [Qt.list, n != null ? n : ""].join(" ") }, e.map((a, o) => /* @__PURE__ */ t.createElement("div", { key: o, className: [Qt.row, a.emphasis ? Qt.emphasis : ""].join(" ") }, /* @__PURE__ */ t.createElement("dt", { className: Qt.label }, a.label), /* @__PURE__ */ t.createElement("dd", { className: [Qt.value, a.changed ? Qt.changed : ""].join(" ") }, a.value))));
}
const T_ = "_underline_145xy_2", L_ = "_active_145xy_24", q_ = "_segmented_145xy_33", la = {
  underline: T_,
  active: L_,
  segmented: q_
};
function Yo({
  items: e,
  value: n,
  onChange: a,
  variant: o = "underline",
  className: r = "",
  "aria-label": s
}) {
  return /* @__PURE__ */ t.createElement(
    "nav",
    {
      className: [o === "segmented" ? la.segmented : la.underline, r].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": s
    },
    e.map((l) => /* @__PURE__ */ t.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === n,
        className: l.key === n ? la.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const I_ = "_bar_1e999_1", F_ = "_actions_1e999_17", R_ = "_field_1e999_24", P_ = "_fieldLabel_1e999_25", O_ = "_readout_1e999_33", X_ = "_search_1e999_44", W_ = "_detail_1e999_58", z_ = "_pill_1e999_70", K_ = "_hint_1e999_81", yt = {
  bar: I_,
  actions: F_,
  field: R_,
  fieldLabel: P_,
  readout: O_,
  search: X_,
  detail: W_,
  pill: z_,
  hint: K_
};
function W2({
  children: e,
  onSearch: n,
  searchLabel: a = "조회",
  searchDisabled: o,
  searchTitle: r,
  detailSearch: s = !1,
  onDetailSearch: l,
  detailLabel: i = "상세검색",
  trailing: c
}) {
  return /* @__PURE__ */ t.createElement("section", { className: yt.bar }, e, /* @__PURE__ */ t.createElement("span", { className: yt.actions }, c, s && /* @__PURE__ */ t.createElement("button", { type: "button", className: yt.detail, onClick: l }, "⌕ ", i), n && /* @__PURE__ */ t.createElement("button", { type: "button", className: yt.search, onClick: n, disabled: o, title: r }, "⌕ ", a)));
}
function H_({ label: e, children: n }) {
  return /* @__PURE__ */ t.createElement("label", { className: yt.field }, /* @__PURE__ */ t.createElement("span", { className: yt.fieldLabel }, e), n);
}
function z2({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: yt.readout }, e);
}
function K2({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: yt.pill, role: "status" }, e);
}
function H2({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: yt.hint }, e);
}
function G_(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function G2({ rows: e, value: n, onChange: a, disabled: o, label: r = "기수" }) {
  return /* @__PURE__ */ t.createElement(H_, { label: r }, /* @__PURE__ */ t.createElement(
    "select",
    {
      value: n != null ? n : "",
      "aria-label": r,
      disabled: o,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (s) => a(Number(s.target.value))
    },
    e.map((s) => /* @__PURE__ */ t.createElement("option", { key: s.gisu, value: s.gisu }, G_(s)))
  ));
}
class Vo {
  constructor(n, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((o) => {
        try {
          for (const r of o) {
            const s = r.borderBoxSize[0];
            this._callback({ width: s.inlineSize, height: s.blockSize }, r);
          }
        } catch (r) {
          console.error(r);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = n, this._callback = a, this.initializeResizeObserver();
  }
}
const U_ = "_card_1u6a3_2", Y_ = "_grow_1u6a3_19", V_ = "_head_1u6a3_21", J_ = "_title_1u6a3_30", Q_ = "_trailing_1u6a3_31", Z_ = "_scroll_1u6a3_9", ep = "_foot_1u6a3_47", tp = "_strip_1u6a3_49", np = "_spacer_1u6a3_50", ap = "_table_1u6a3_52", op = "_fixed_1u6a3_53", rp = "_fz_1u6a3_71", sp = "_fzEdge_1u6a3_83", lp = "_frozen_1u6a3_90", cp = "_statusCell_1u6a3_206", ip = "_status_1u6a3_206", up = "_st_error_1u6a3_214", mp = "_stIcon_1u6a3_215", dp = "_spin_1u6a3_221", _p = "_axeSpin_1u6a3_1", pp = "_busy_1u6a3_231", fp = "_statusRow_1u6a3_233", yp = "_busyBar_1u6a3_234", hp = "_axeBusy_1u6a3_1", _e = {
  card: U_,
  grow: Y_,
  head: V_,
  title: J_,
  trailing: Q_,
  scroll: Z_,
  foot: ep,
  strip: tp,
  spacer: np,
  table: ap,
  fixed: op,
  fz: rp,
  fzEdge: sp,
  frozen: lp,
  statusCell: cp,
  status: ip,
  st_error: up,
  stIcon: mp,
  spin: dp,
  axeSpin: _p,
  busy: pp,
  statusRow: fp,
  busyBar: yp,
  axeBusy: hp
}, bp = 120;
function Ep(e) {
  if (!e || !e.length) return;
  let n = 0, a = 0;
  for (const o of e)
    if (o == null) a += 1;
    else if (typeof o == "number") n += o;
    else if (/^\d+(\.\d+)?px$/.test(o)) n += parseFloat(o);
    else return;
  return a > 0 ? n + a * bp : void 0;
}
function Qa({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ t.createElement("colgroup", null, e.map((n, a) => /* @__PURE__ */ t.createElement("col", { key: a, style: n == null ? void 0 : { width: n } })));
}
const Za = /* @__PURE__ */ new Set();
function gp(e) {
  var o;
  if (typeof process == "undefined" || ((o = process.env) == null ? void 0 : o.NODE_ENV) === "production") return;
  const n = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var s, l;
    r.scrollWidth > r.clientWidth + 1 && n.push((l = (s = r.textContent) == null ? void 0 : s.trim()) != null ? l : "");
  }), !n.length) return;
  const a = n.slice(0, 5).join("|");
  Za.has(a) || (Za.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${n.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    n.slice(0, 5)
  ));
}
function eo(e, n, a) {
  if (!e) return;
  const o = /* @__PURE__ */ new Map();
  for (const r of Array.from(e.rows)) {
    o.forEach((l, i) => {
      l <= 1 ? o.delete(i) : o.set(i, l - 1);
    });
    let s = 0;
    for (const l of Array.from(r.cells)) {
      for (; o.has(s); ) s += 1;
      const i = l.colSpan || 1, c = n > 0 && s + i <= n;
      if (l.classList.toggle(_e.fz, c), l.classList.toggle(_e.fzEdge, c && s + i === n), l.style.left = c ? `${a[s]}px` : "", l.rowSpan > 1) for (let u = s; u < s + i; u += 1) o.set(u, l.rowSpan);
      s += i;
    }
  }
}
function U2({
  cols: e,
  footer: n,
  title: a,
  trailing: o,
  grow: r,
  fixed: s,
  stickyCols: l = 0,
  busy: i,
  className: c = "",
  children: u
}) {
  const m = s || e !== void 0 && e.length > 0, d = m ? Ep(e) : void 0, { stick: _, offsets: p } = De(() => {
    const h = Math.max(Math.trunc(l), 0), v = [];
    if (h === 0 || !e) return { stick: 0, offsets: v };
    let x = 0, C = 0;
    for (let B = 0; B < h; B += 1) {
      const R = e[B];
      if (typeof R != "number") break;
      v.push(x), x += R, C += 1;
    }
    return { stick: C, offsets: v };
  }, [e, l]), f = [_e.table, m ? _e.fixed : "", _ > 0 ? _e.frozen : ""].filter(Boolean).join(" "), y = I(null), E = I(null), g = I(null), w = I(null), D = I(0), k = () => {
    const h = y.current, v = g.current, x = w.current;
    if (!h || !v || !x) return;
    const C = h.scrollWidth;
    x.style.width = C + "px", v.style.display = C > h.clientWidth + 1 ? "" : "none";
    const B = h.offsetWidth - h.clientWidth;
    v.style.paddingRight = B + "px", E.current && (E.current.style.paddingRight = B + "px"), gp(h);
  };
  Z(() => {
    const h = y.current;
    if (!h) return;
    const v = new Vo(h, k);
    return () => v.detach();
  }, []), He(() => {
    var h, v, x, C;
    (_ > 0 || D.current > 0) && (eo((v = (h = y.current) == null ? void 0 : h.querySelector("table")) != null ? v : null, _, p), eo((C = (x = E.current) == null ? void 0 : x.querySelector("table")) != null ? C : null, _, p)), D.current = _, k();
  });
  const b = (h) => {
    const v = h.target.scrollLeft;
    y.current && (y.current.scrollLeft = v), E.current && (E.current.scrollLeft = v);
  }, $ = (h) => {
    const v = h.target.scrollLeft;
    E.current && (E.current.scrollLeft = v), g.current && (g.current.scrollLeft = v);
  };
  return /* @__PURE__ */ t.createElement("div", { className: [_e.card, r ? _e.grow : "", i ? _e.busy : "", c].filter(Boolean).join(" ") }, i && /* @__PURE__ */ t.createElement("div", { className: _e.busyBar, "aria-hidden": "true" }), (a !== void 0 || o !== void 0) && /* @__PURE__ */ t.createElement("header", { className: _e.head }, /* @__PURE__ */ t.createElement("span", { className: _e.title }, a), o && /* @__PURE__ */ t.createElement("span", { className: _e.trailing }, o)), /* @__PURE__ */ t.createElement("div", { className: _e.scroll, ref: y, onScroll: $ }, /* @__PURE__ */ t.createElement("table", { className: f, "aria-busy": i || void 0, style: d ? { minWidth: d } : void 0 }, /* @__PURE__ */ t.createElement(Qa, { cols: e }), u)), n && /* @__PURE__ */ t.createElement("div", { className: _e.foot, ref: E }, /* @__PURE__ */ t.createElement("table", { className: f, style: d ? { minWidth: d } : void 0 }, /* @__PURE__ */ t.createElement(Qa, { cols: e }), /* @__PURE__ */ t.createElement("tbody", null, n))), /* @__PURE__ */ t.createElement("div", { className: _e.strip, ref: g, onScroll: b }, /* @__PURE__ */ t.createElement("div", { ref: w, className: _e.spacer })));
}
const vp = 7.09, kp = 3.88, wp = 4.46, Np = 16, $p = 2;
function xp(e, n = {}) {
  var s;
  const a = Math.max(1, e), o = Math.floor((a - 1) / 3), r = a * vp + o * kp + (n.negative ? wp : 0) + Np + $p;
  return Math.max(Math.ceil(r), (s = n.min) != null ? s : 0);
}
function Y2(e, n = {}) {
  var r, s;
  let a = 0, o = (r = n.negative) != null ? r : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const i = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(i)) continue;
    i < 0 && (o = !0);
    const c = Math.floor(Math.abs(i)).toString().length;
    c > a && (a = c);
  }
  return a === 0 ? Math.max((s = n.min) != null ? s : 96, 96) : xp(a, { ...n, negative: o });
}
function V2(e) {
  const n = document.createElement("span");
  n.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(n);
  const a = (l) => (n.textContent = l, n.getBoundingClientRect().width), o = a("000000000000"), r = a("000,000,000,000"), s = a("-000,000,000,000");
  return n.remove(), { digit: o / 12, comma: (r - o) / 3, minus: s - r };
}
function J2({
  colSpan: e,
  loading: n,
  error: a,
  count: o,
  empty: r = "조회 결과가 없습니다",
  idle: s = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: i = ""
}) {
  const c = a != null && a !== !1 && a !== "", u = o == null || o === 0, m = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let d;
  if (c) d = "error";
  else if (n && u) d = "loading";
  else if (o == null) {
    if (s === null) return null;
    d = "idle";
  } else if (o === 0) d = "empty";
  else return null;
  const _ = /* @__PURE__ */ t.createElement(t.Fragment, null, d === "loading" && /* @__PURE__ */ t.createElement("span", { className: _e.spin, "aria-hidden": "true" }), d === "error" && /* @__PURE__ */ t.createElement("span", { className: _e.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ t.createElement("span", null, d === "error" ? m : d === "loading" ? l : d === "idle" ? s : r)), p = /* @__PURE__ */ t.createElement("div", { className: [_e.status, _e[`st_${d}`]].join(" "), role: "status" }, _);
  return e === void 0 ? /* @__PURE__ */ t.createElement("div", { className: i || void 0, "data-state": d }, p) : /* @__PURE__ */ t.createElement("tr", { className: [_e.statusRow, i].filter(Boolean).join(" "), "data-state": d }, /* @__PURE__ */ t.createElement("td", { colSpan: e, className: _e.statusCell }, p));
}
function Q2(e) {
  return {
    tabIndex: 0,
    onKeyDown: (n) => {
      n.target === n.currentTarget && (n.key === "Enter" || n.key === " ") && (n.preventDefault(), e());
    }
  };
}
const Dp = "_cell_n9rrj_1", Cp = "_toggle_n9rrj_2", Sp = "_spacer_n9rrj_8", Ap = "_label_n9rrj_9", Mp = "_dim_n9rrj_10", hn = {
  cell: Dp,
  toggle: Cp,
  spacer: Sp,
  label: Ap,
  dim: Mp
};
function Z2(e, { id: n, parentId: a, defaultOpen: o = !0 }) {
  const [r, s] = A(() => /* @__PURE__ */ new Set()), [l, i] = A(() => /* @__PURE__ */ new Set()), { parents: c, kids: u } = De(() => {
    const p = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Set(), y = new Set(e.map((E) => String(n(E))));
    for (const E of e) {
      const g = a(E), w = g == null || !y.has(String(g)) ? null : String(g);
      p.set(String(n(E)), w), w && f.add(w);
    }
    return { parents: p, kids: f };
  }, [e, n, a]), m = se((p) => o ? !r.has(p) : l.has(p), [o, r, l]), d = De(() => e.filter((p) => {
    var E, g;
    let f = (E = c.get(String(n(p)))) != null ? E : null;
    const y = /* @__PURE__ */ new Set();
    for (; f && !y.has(f); ) {
      if (!m(f)) return !1;
      y.add(f), f = (g = c.get(f)) != null ? g : null;
    }
    return !0;
  }), [e, c, n, m]), _ = se((p, f) => {
    const y = (E, g) => {
      const w = new Set(E);
      return g ? w.add(p) : w.delete(p), w;
    };
    o ? s((E) => y(E, !f)) : i((E) => y(E, f));
  }, [o]);
  return {
    visible: d,
    hasChildren: (p) => u.has(String(n(p))),
    isOpen: (p) => m(String(n(p))),
    toggle: (p) => {
      const f = String(n(p));
      _(f, !m(f));
    },
    expandAll: () => {
      s(/* @__PURE__ */ new Set()), i(new Set(u));
    },
    collapseAll: () => {
      s(new Set(u)), i(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const p = r, f = l;
      return s(/* @__PURE__ */ new Set()), i(new Set(u)), () => {
        s(p), i(f);
      };
    },
    reveal: (p) => {
      var E, g;
      let f = (E = c.get(String(p))) != null ? E : null;
      const y = /* @__PURE__ */ new Set();
      for (; f && !y.has(f); )
        _(f, !0), y.add(f), f = (g = c.get(f)) != null ? g : null;
    }
  };
}
function eN({ depth: e, hasChildren: n, open: a, onToggle: o, dim: r, children: s }) {
  const l = (i) => {
    i.stopPropagation(), o();
  };
  return /* @__PURE__ */ t.createElement("span", { className: [hn.cell, r ? hn.dim : ""].filter(Boolean).join(" "), style: { paddingLeft: e * 16 } }, n ? /* @__PURE__ */ t.createElement("button", { type: "button", className: hn.toggle, "aria-expanded": a, "aria-label": a ? "하위 접기" : "하위 펼치기", onClick: l }, a ? "▾" : "▸") : /* @__PURE__ */ t.createElement("span", { className: hn.spacer, "aria-hidden": "true" }), /* @__PURE__ */ t.createElement("span", { className: hn.label }, s));
}
function Bp(e, n, a, o = !1) {
  const r = e[n.r];
  if (!r || n.i < 0 || n.i >= r.length) return null;
  const s = r[n.i], l = e.findIndex((c) => c.length > 0);
  let i = -1;
  for (let c = e.length - 1; c >= 0; c--) if (e[c].length > 0) {
    i = c;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return n.i > 0 ? { r: n.r, i: n.i - 1 } : null;
    case "ArrowRight":
      return n.i < r.length - 1 ? { r: n.r, i: n.i + 1 } : null;
    case "Home":
      return o ? { r: l, i: 0 } : { r: n.r, i: 0 };
    case "End":
      return o ? { r: i, i: e[i].length - 1 } : { r: n.r, i: r.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const c = a === "ArrowUp" ? -1 : 1;
      for (let u = n.r + c; u >= 0 && u < e.length; u += c)
        if (e[u].length > 0) return { r: u, i: jp(e[u], s) };
      return null;
    }
    default:
      return null;
  }
}
function jp(e, n) {
  let a = 0;
  for (let o = 1; o < e.length; o++)
    Math.abs(e[o] - n) < Math.abs(e[a] - n) && (a = o);
  return a;
}
function tN(e, n = {}) {
  var l;
  const a = (l = n.cellSelector) != null ? l : "[data-roving]", o = I(null), [r, s] = A(null);
  Z(() => {
    e.current !== r && s(e.current);
  }), Z(() => {
    if (!r) return;
    const i = () => Array.from(r.querySelectorAll(a)), c = () => {
      const p = i();
      if (!p.length) {
        o.current = null;
        return;
      }
      (!o.current || !p.includes(o.current)) && (o.current = p[0]), p.forEach((f) => {
        const y = f === o.current ? "0" : "-1";
        f.getAttribute("tabindex") !== y && f.setAttribute("tabindex", y);
      });
    }, u = () => {
      const p = i(), f = [], y = [], E = /* @__PURE__ */ new Map(), g = [];
      return p.forEach((w) => {
        var v;
        const D = w.closest("td, th"), k = D && r.contains(D) ? D.parentElement : null, b = (v = k != null ? k : w.parentElement) != null ? v : r;
        let $ = f.indexOf(b);
        $ < 0 && ($ = f.length, f.push(b), y.push([]), g.push([]));
        let h;
        if (D && k) {
          h = 0;
          for (const x of Array.from(k.cells)) {
            if (x === D) break;
            h += Math.max(1, x.colSpan || 1);
          }
        } else
          h = y[$].length;
        E.set(w, { r: $, i: y[$].length }), y[$].push(h), g[$].push(w);
      }), { rows: y, where: E, byPos: g };
    }, m = (p) => {
      var b;
      const f = p.target;
      if (!f || !f.matches(a) || !r.contains(f) || p.altKey || p.metaKey) return;
      const { rows: y, where: E, byPos: g } = u(), w = E.get(f);
      if (!w) return;
      const D = Bp(y, w, p.key, p.ctrlKey);
      if (D === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(p.key) && p.preventDefault();
        return;
      }
      p.preventDefault();
      const k = (b = g[D.r]) == null ? void 0 : b[D.i];
      k && (o.current = k, c(), k.focus());
    }, d = (p) => {
      const f = p.target;
      !f || !f.matches(a) || f === o.current || (o.current = f, c());
    };
    c(), r.addEventListener("keydown", m), r.addEventListener("focusin", d);
    const _ = typeof MutationObserver != "undefined" ? new MutationObserver(c) : null;
    return _ == null || _.observe(r, { childList: !0, subtree: !0 }), () => {
      r.removeEventListener("keydown", m), r.removeEventListener("focusin", d), _ == null || _.disconnect();
    };
  }, [r, a]);
}
const Tp = "_card_14vt3_1", Lp = "_accent_14vt3_8", qp = "_grow_14vt3_9", Ip = "_head_14vt3_11", Fp = "_body_14vt3_20", Rp = "_title_14vt3_28", Pp = "_trailing_14vt3_29", Op = "_summary_14vt3_32", Xp = "_sumHead_14vt3_33", Wp = "_sumTotal_14vt3_42", zp = "_tone_warn_14vt3_43", Kp = "_tone_ok_14vt3_44", Hp = "_sumList_14vt3_46", Gp = "_sumEm_14vt3_55", Up = "_sumFoot_14vt3_57", Yp = "_sumNote_14vt3_66", we = {
  card: Tp,
  accent: Lp,
  grow: qp,
  head: Ip,
  body: Fp,
  title: Rp,
  trailing: Pp,
  summary: Op,
  sumHead: Xp,
  sumTotal: Wp,
  tone_warn: zp,
  tone_ok: Kp,
  sumList: Hp,
  sumEm: Gp,
  sumFoot: Up,
  sumNote: Yp
};
function Jo({
  title: e,
  trailing: n,
  accent: a,
  grow: o,
  flush: r,
  className: s = "",
  children: l
}) {
  return /* @__PURE__ */ t.createElement(
    "section",
    {
      className: [we.card, a ? we.accent : "", o ? we.grow : "", s].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ t.createElement("header", { className: we.head }, /* @__PURE__ */ t.createElement("span", { className: we.title }, e), n && /* @__PURE__ */ t.createElement("span", { className: we.trailing }, n)),
    r ? l : /* @__PURE__ */ t.createElement("div", { className: ["axe-card-body", we.body].join(" ") }, l)
  );
}
function nN({
  title: e,
  total: n,
  items: a,
  footerLabel: o,
  footerValue: r,
  note: s,
  tone: l = "default",
  children: i
}) {
  return /* @__PURE__ */ t.createElement("section", { className: [we.card, we.accent, we.summary, we[`tone_${l}`]].join(" ") }, /* @__PURE__ */ t.createElement("header", { className: we.sumHead }, /* @__PURE__ */ t.createElement("span", null, e), n !== void 0 && /* @__PURE__ */ t.createElement("strong", { className: we.sumTotal }, n)), /* @__PURE__ */ t.createElement("ul", { className: we.sumList }, a.map((c, u) => {
    var m;
    return /* @__PURE__ */ t.createElement("li", { key: (m = c.key) != null ? m : u, className: c.em ? we.sumEm : "" }, /* @__PURE__ */ t.createElement("span", null, c.label), /* @__PURE__ */ t.createElement("strong", null, c.value));
  })), i, o !== void 0 && /* @__PURE__ */ t.createElement("footer", { className: we.sumFoot }, /* @__PURE__ */ t.createElement("span", null, o), /* @__PURE__ */ t.createElement("strong", null, r)), s && /* @__PURE__ */ t.createElement("div", { className: we.sumNote }, s));
}
function wa(e, n, a = "codeName") {
  const o = (e != null ? e : "").trim();
  if (!o) return "";
  const r = (n != null ? n : "").trim();
  return !r || a === "code" ? o : a === "name" ? r : `${o}. ${r}`;
}
function Vp(e, n = "전체", a = "codeName") {
  if (e.length === 0) return n;
  const o = wa(e[0].cd, e[0].nm, a);
  return e.length === 1 ? o : `${o} 외 ${e.length - 1}건`;
}
function Jp(e, n, a, o) {
  const r = (e != null ? e : "").trim();
  if (!r) return null;
  if (n && n.name && n.code === r) return n.name;
  if (a && a.code === r && a.name) return a.name;
  const s = o == null ? void 0 : o.find((l) => l.code === r);
  return s && s.name ? s.name : null;
}
const Qp = "_root_ycvqx_1", Zp = "_rootNone_ycvqx_5", ef = "_field_ycvqx_12", tf = "_codeInput_ycvqx_13", nf = "_pickBtn_ycvqx_17", af = "_suggest_ycvqx_34", of = "_suggestList_ycvqx_40", rf = "_suggestRow_ycvqx_41", sf = "_suggestOn_ycvqx_42", lf = "_suggestEmpty_ycvqx_47", cf = "_suggestMore_ycvqx_47", uf = "_popup_ycvqx_51", mf = "_popupHead_ycvqx_65", df = "_searchRow_ycvqx_75", _f = "_list_ycvqx_79", pf = "_current_ycvqx_88", ff = "_empty_ycvqx_92", yf = "_summaryBtn_ycvqx_100", hf = "_ov_ycvqx_121", bf = "_modal_ycvqx_132", Ef = "_modalWide_ycvqx_132", gf = "_head_ycvqx_144", vf = "_sub_ycvqx_152", kf = "_x_ycvqx_154", wf = "_body_ycvqx_171", Nf = "_chips_ycvqx_179", $f = "_chip_ycvqx_179", xf = "_chipOn_ycvqx_193", Df = "_search_ycvqx_75", Cf = "_tbl_ycvqx_212", Sf = "_row_ycvqx_242", Af = "_rowCursor_ycvqx_244", Mf = "_rowPicked_ycvqx_245", Bf = "_rowCurrent_ycvqx_246", jf = "_curTag_ycvqx_247", Tf = "_busy_ycvqx_248", Lf = "_count_ycvqx_249", qf = "_chk_ycvqx_251", If = "_tdLeft_ycvqx_252", Ff = "_tdCenter_ycvqx_253", Rf = "_emptyCell_ycvqx_255", Pf = "_stop_ycvqx_257", Of = "_more_ycvqx_268", Xf = "_pager_ycvqx_280", Wf = "_note_ycvqx_293", zf = "_foot_ycvqx_296", Kf = "_ghost_ycvqx_305", Hf = "_primary_ycvqx_317", W = {
  root: Qp,
  rootNone: Zp,
  field: ef,
  codeInput: tf,
  pickBtn: nf,
  suggest: af,
  suggestList: of,
  suggestRow: rf,
  suggestOn: sf,
  suggestEmpty: lf,
  suggestMore: cf,
  popup: uf,
  popupHead: mf,
  searchRow: df,
  list: _f,
  current: pf,
  empty: ff,
  summaryBtn: yf,
  ov: hf,
  modal: bf,
  modalWide: Ef,
  head: gf,
  sub: vf,
  x: kf,
  body: wf,
  chips: Nf,
  chip: $f,
  chipOn: xf,
  search: Df,
  tbl: Cf,
  row: Sf,
  rowCursor: Af,
  rowPicked: Mf,
  rowCurrent: Bf,
  curTag: jf,
  busy: Tf,
  count: Lf,
  chk: qf,
  tdLeft: If,
  tdCenter: Ff,
  emptyCell: Rf,
  stop: Pf,
  more: Of,
  pager: Xf,
  note: Wf,
  foot: zf,
  ghost: Kf,
  primary: Hf
}, Qo = 250, Fn = 7;
let Gf = 0;
function to(e, n) {
  const a = n.trim().toLowerCase();
  if (!a) return e;
  const o = e.toLowerCase().indexOf(a);
  return o < 0 ? e : /* @__PURE__ */ t.createElement(t.Fragment, null, e.slice(0, o), /* @__PURE__ */ t.createElement("b", null, e.slice(o, o + a.length)), e.slice(o + a.length));
}
function aN({
  value: e = "",
  name: n,
  show: a = "codeName",
  onChange: o,
  items: r,
  source: s,
  multiple: l = !1,
  selected: i,
  onConfirm: c,
  current: u,
  trigger: m,
  emptyLabel: d = "전체",
  open: _,
  onOpenChange: p,
  placeholder: f,
  title: y = "코드도움",
  variant: E,
  disabled: g,
  className: w = "",
  maxLength: D,
  numeric: k = !1,
  ariaLabel: b = "코드",
  autoFocus: $,
  onEnter: h,
  onEscape: v,
  onBlur: x,
  invalid: C
}) {
  const B = s ? "source" : "static", R = E != null ? E : B === "source" ? "modal" : "anchor", P = m != null ? m : l ? "summary" : "input", [G, q] = A(!1), L = _ != null ? _ : G, F = se(
    (T) => {
      _ === void 0 && q(T), p && p(T);
    },
    [_, p]
  ), oe = I(null), N = I(null), O = I(null), [Y, H] = A(null), ue = () => {
    if (!g) {
      if (R === "anchor") {
        const T = oe.current;
        if (!T) return;
        const K = T.getBoundingClientRect(), V = 320, re = K.bottom + V > window.innerHeight ? Math.max(8, K.top - V - 4) : K.bottom + 4;
        H({ left: Math.min(K.left, window.innerWidth - 320), top: re });
      }
      F(!0);
    }
  }, j = se(() => F(!1), [F]), [U, ee] = A(!1), [ae, ce] = A(null), z = I(null);
  (!z.current || z.current.name !== n) && (z.current = { name: n, code: e });
  const ie = Jp(e, z.current, ae, r), Et = wa(e, ie, a), gt = wa(e, ie), de = (T) => {
    !l && T[0] && ce({ code: T[0].cd, name: T[0].nm }), c ? c(T) : T[0] && o && o(T[0].cd, { code: T[0].cd, name: T[0].nm });
  }, [pe, Wt] = A(null), [Ie, Fe] = A(-1), [zt, ot] = A(null), vt = I(null), Kt = I(0), rt = I(`axe-cp-${++Gf}`), Tn = I(s);
  Tn.current = s;
  const Ln = I(r);
  Ln.current = r;
  const S = se(() => {
    vt.current != null && (window.clearTimeout(vt.current), vt.current = null), Kt.current += 1, Wt(null), Fe(-1);
  }, []);
  Z(() => S, [S]);
  const X = (T) => {
    vt.current != null && window.clearTimeout(vt.current), Kt.current += 1;
    const K = Kt.current;
    if (!T.trim()) {
      Wt(null), Fe(-1);
      return;
    }
    vt.current = window.setTimeout(async () => {
      var Ye;
      let V = [], re = !1;
      try {
        const st = Tn.current;
        if (st) {
          const Ht = await st.fetch({ q: T, ty: null, page: 0 });
          V = Ht.rows, re = !!Ht.hasMore || V.length > Fn;
        } else {
          const Ht = T.trim().toLowerCase();
          V = ((Ye = Ln.current) != null ? Ye : []).filter((St) => {
            var Pa;
            return St.code.toLowerCase().includes(Ht) || St.name.toLowerCase().includes(Ht) || ((Pa = St.sub) != null ? Pa : "").toLowerCase().includes(Ht);
          }).map((St) => ({ cd: St.code, nm: St.name, sub: St.sub })), re = V.length > Fn;
        }
      } catch {
        return;
      }
      K === Kt.current && (Wt({ rows: V.slice(0, Fn), more: re, q: T }), Fe(-1));
    }, Qo);
  }, te = (T) => {
    S(), de([T]);
  };
  return Z(() => {
    if (!pe) {
      ot(null);
      return;
    }
    const T = () => {
      const K = oe.current;
      if (!K) return;
      const V = K.getBoundingClientRect(), re = Math.min(pe.rows.length, Fn) * 28 + 34, Ye = V.bottom + re > window.innerHeight - 8 && V.top - re - 2 > 8 ? V.top - re - 2 : V.bottom + 2, st = Math.max(V.width, 260);
      ot({ left: Math.max(8, Math.min(V.left, window.innerWidth - st - 8)), top: Ye, width: st });
    };
    return T(), window.addEventListener("resize", T), window.addEventListener("scroll", T, !0), () => {
      window.removeEventListener("resize", T), window.removeEventListener("scroll", T, !0);
    };
  }, [pe]), /* @__PURE__ */ t.createElement("span", { ref: oe, className: [P === "none" ? W.rootNone : W.root, w].filter(Boolean).join(" ") }, P === "input" && /* @__PURE__ */ t.createElement("span", { className: W.field }, /* @__PURE__ */ t.createElement(
    "input",
    {
      className: W.codeInput,
      style: { paddingRight: 24 },
      value: U ? e : Et,
      placeholder: f,
      disabled: g,
      maxLength: D,
      inputMode: k ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: $,
      "aria-label": b,
      "aria-invalid": C ? !0 : void 0,
      onChange: (T) => {
        const K = T.target.value.trim(), V = k ? K.replace(/[^0-9]/g, "") : K, re = D ? V.slice(0, D) : V;
        o && o(re), !g && (s || r) && X(re);
      },
      onKeyDown: (T) => {
        if (T.key === "F2") {
          T.preventDefault(), S(), ue();
          return;
        }
        if (!pe) {
          T.key === "Enter" && h && !T.nativeEvent.isComposing ? (T.preventDefault(), h()) : T.key === "Escape" && v && (T.preventDefault(), v());
          return;
        }
        const K = pe.rows.length;
        T.key === "ArrowDown" && K ? (T.preventDefault(), Fe((V) => (V + 1) % K)) : T.key === "ArrowUp" && K ? (T.preventDefault(), Fe((V) => (V <= 0 ? K : V) - 1)) : T.key === "Enter" && Ie >= 0 && pe.rows[Ie] ? (T.preventDefault(), te(pe.rows[Ie])) : T.key === "Enter" && h && !T.nativeEvent.isComposing ? (T.preventDefault(), S(), h()) : T.key === "Escape" && (T.preventDefault(), T.stopPropagation(), T.nativeEvent.stopImmediatePropagation(), S());
      },
      onFocus: () => ee(!0),
      onBlur: () => {
        ee(!1), S(), x && x();
      },
      title: typeof C == "string" && C ? C : gt && gt !== e ? `${gt} (F2: 코드도움)` : "F2: 코드도움",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!pe,
      "aria-controls": pe ? rt.current : void 0,
      "aria-activedescendant": pe && Ie >= 0 ? `${rt.current}-${Ie}` : void 0
    }
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: W.pickBtn,
      "aria-label": "코드도움 열기",
      disabled: g,
      onClick: ue,
      onMouseDown: (T) => T.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ t.createElement(Hn, { name: "search", size: 13 })
  )), P === "summary" && /* @__PURE__ */ t.createElement("button", { type: "button", className: W.summaryBtn, disabled: g, onClick: ue }, /* @__PURE__ */ t.createElement("span", null, Vp(i != null ? i : [], d, a)), /* @__PURE__ */ t.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ t.createElement(Hn, { name: "search", size: 13 }))), pe && zt && P === "input" && !L && /* @__PURE__ */ t.createElement(un, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: W.suggest,
      style: { left: zt.left, top: zt.top, width: zt.width },
      onMouseDown: (T) => T.preventDefault()
    },
    pe.rows.length === 0 ? /* @__PURE__ */ t.createElement("div", { className: W.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ t.createElement("ul", { id: rt.current, role: "listbox", className: W.suggestList }, pe.rows.map((T, K) => /* @__PURE__ */ t.createElement(
      "li",
      {
        key: T.cd,
        id: `${rt.current}-${K}`,
        role: "option",
        "aria-selected": K === Ie,
        className: [W.suggestRow, K === Ie ? W.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Fe(K),
        onClick: () => te(T)
      },
      /* @__PURE__ */ t.createElement("code", null, to(T.cd, pe.q)),
      /* @__PURE__ */ t.createElement("span", null, to(T.nm, pe.q)),
      T.useYn === !1 && /* @__PURE__ */ t.createElement("em", null, "중단")
    ))),
    pe.more && /* @__PURE__ */ t.createElement("div", { className: W.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), L && B === "static" && R === "anchor" && Y && /* @__PURE__ */ t.createElement(
    Uf,
    {
      items: r != null ? r : [],
      value: e,
      title: y,
      popupRef: N,
      anchorRef: oe,
      pos: Y,
      onPick: (T) => {
        ce({ code: T.code, name: T.name }), o && o(T.code, T), j();
      },
      onClose: j
    }
  ), L && (B === "source" || R === "modal") && /* @__PURE__ */ t.createElement(
    Vf,
    {
      source: s,
      items: r,
      title: y,
      multiple: l,
      selected: i,
      current: u,
      searchRef: O,
      onConfirm: (T) => {
        de(T), j();
      },
      onClose: j
    }
  ));
}
function Uf({
  items: e,
  value: n,
  title: a,
  popupRef: o,
  anchorRef: r,
  pos: s,
  onPick: l,
  onClose: i
}) {
  const [c, u] = A(""), m = De(() => {
    const d = c.trim().toLowerCase();
    return d ? e.filter(
      (_) => {
        var p;
        return _.code.toLowerCase().includes(d) || _.name.toLowerCase().includes(d) || ((p = _.sub) != null ? p : "").toLowerCase().includes(d);
      }
    ) : e;
  }, [e, c]);
  return Z(() => {
    const d = (p) => {
      const f = p.target;
      o.current && !o.current.contains(f) && r.current && !r.current.contains(f) && i();
    }, _ = (p) => {
      p.key === "Escape" && i();
    };
    return document.addEventListener("mousedown", d), document.addEventListener("keydown", _), () => {
      document.removeEventListener("mousedown", d), document.removeEventListener("keydown", _);
    };
  }, [o, r, i]), /* @__PURE__ */ t.createElement(un, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: o,
      className: W.popup,
      style: { left: s.left, top: s.top },
      role: "dialog",
      "aria-label": "코드도움"
    },
    /* @__PURE__ */ t.createElement("header", { className: W.popupHead }, /* @__PURE__ */ t.createElement("strong", null, a), /* @__PURE__ */ t.createElement("button", { type: "button", "aria-label": "닫기", onClick: i }, "✕")),
    /* @__PURE__ */ t.createElement("div", { className: W.searchRow }, /* @__PURE__ */ t.createElement(
      "input",
      {
        autoFocus: !0,
        value: c,
        placeholder: "코드·명칭 검색",
        onChange: (d) => u(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && m.length && l(m[0]), d.key === "Escape" && i();
        }
      }
    )),
    /* @__PURE__ */ t.createElement("ul", { className: W.list }, m.map((d) => /* @__PURE__ */ t.createElement("li", { key: d.code }, /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => l(d), className: d.code === n ? W.current : "" }, /* @__PURE__ */ t.createElement("code", null, d.code), /* @__PURE__ */ t.createElement("span", null, d.name), d.sub && /* @__PURE__ */ t.createElement("small", null, d.sub)))), m.length === 0 && /* @__PURE__ */ t.createElement("li", { className: W.empty }, "검색 결과가 없습니다"))
  ));
}
function Yf(e, n) {
  const a = e.map((o) => ({ cd: o.code, nm: o.name, sub: o.sub }));
  return {
    key: "static",
    title: typeof n == "string" ? n : "코드도움",
    nameLabel: "명칭",
    fetch: ({ q: o }) => {
      const r = o.trim().toLowerCase();
      return r ? Promise.resolve({
        rows: a.filter(
          (s) => {
            var l;
            return s.cd.toLowerCase().includes(r) || s.nm.toLowerCase().includes(r) || String((l = s.sub) != null ? l : "").toLowerCase().includes(r);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function Vf({
  source: e,
  items: n,
  title: a,
  multiple: o,
  selected: r,
  current: s,
  searchRef: l,
  onConfirm: i,
  onClose: c
}) {
  const u = De(() => Yf(n != null ? n : [], a), [n, a]), m = e != null ? e : u, [d, _] = A(""), [p, f] = A(null), [y, E] = A(0), [g, w] = A([]), [D, k] = A(!1), [b, $] = A(!1), [h, v] = A(null), [x, C] = A(0), [B, R] = A(/* @__PURE__ */ new Map()), P = I(m);
  P.current = m, Z(() => {
    _(""), f(null), E(0), C(0), v(null), R(new Map((r != null ? r : []).map((U) => [U.cd, U])));
    const j = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(j);
  }, [m.key]), Z(() => {
    let j = !0;
    $(!0);
    const U = () => {
      P.current.fetch({ q: d.trim(), ty: p, page: y }).then((ae) => {
        var z, ie;
        if (!j) return;
        w((z = ae.rows) != null ? z : []), k(!!ae.hasMore), v(null);
        const ce = s ? ((ie = ae.rows) != null ? ie : []).findIndex((Et) => Et.cd === s) : -1;
        C(ce > 0 ? ce : 0);
      }).catch((ae) => {
        j && (w([]), k(!1), v(ae instanceof Error ? ae.message : "코드도움 조회에 실패했습니다"));
      }).finally(() => {
        j && $(!1);
      });
    }, ee = window.setTimeout(U, d.trim() ? Qo : 0);
    return () => {
      j = !1, window.clearTimeout(ee);
    };
  }, [m.key, d, p, y]);
  const G = I(null);
  Z(() => {
    const j = G.current && G.current.children[x];
    j && "scrollIntoView" in j && j.scrollIntoView({ block: "nearest" });
  }, [x, g]);
  const q = De(() => {
    var U, ee;
    const j = [
      { key: "cd", label: "코드", width: (U = m.codeWidth) != null ? U : "96px", align: "center" },
      {
        key: "nm",
        label: m.nameLabel,
        align: "left",
        render: (ae) => /* @__PURE__ */ t.createElement(t.Fragment, null, ae.nm, ae.useYn === !1 && /* @__PURE__ */ t.createElement("span", { className: W.stop }, "중단"))
      }
    ];
    return m.typeLabel && j.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (ae) => m.typeLabel ? m.typeLabel(ae) : ""
    }), j.concat((ee = m.extraColumns) != null ? ee : []);
  }, [m]), L = se((j) => {
    R((U) => {
      const ee = new Map(U);
      return ee.has(j.cd) ? ee.delete(j.cd) : ee.set(j.cd, j), ee;
    });
  }, []), F = se((j) => i([j]), [i]), oe = se(() => i(Array.from(B.values())), [B, i]), N = g.length > 0 && g.every((j) => B.has(j.cd)), O = () => {
    R((j) => {
      const U = new Map(j);
      return N ? g.forEach((ee) => U.delete(ee.cd)) : g.forEach((ee) => U.set(ee.cd, ee)), U;
    });
  }, Y = I(null), H = I(c);
  H.current = c, Z(() => {
    const j = (U) => {
      U.key !== "Escape" || U.isComposing || (U.stopPropagation(), U.preventDefault(), H.current());
    };
    return document.addEventListener("keydown", j, !0), () => document.removeEventListener("keydown", j, !0);
  }, []);
  const ue = (j) => {
    if (!(j.nativeEvent.isComposing || j.keyCode === 229)) {
      if (j.key === "Tab" && Y.current) {
        const U = Array.from(Y.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
        if (U.length) {
          const ee = U[0], ae = U[U.length - 1], ce = document.activeElement;
          j.shiftKey && ce === ee ? (j.preventDefault(), ae.focus()) : !j.shiftKey && ce === ae && (j.preventDefault(), ee.focus());
        }
        return;
      }
      if (j.key === "Escape") {
        j.stopPropagation(), c();
        return;
      }
      if (j.key === "ArrowDown" || j.key === "ArrowUp") {
        j.preventDefault(), C((U) => Math.max(0, Math.min(g.length - 1, U + (j.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (j.key === " " && o && g[x]) {
        j.preventDefault(), L(g[x]);
        return;
      }
      if (j.key === "Enter") {
        if (j.preventDefault(), b) return;
        o ? oe() : g[x] && F(g[x]);
      }
    }
  };
  return /* @__PURE__ */ t.createElement(un, null, /* @__PURE__ */ t.createElement("div", { className: W.ov, onClick: c }, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: m.wide ? `${W.modal} ${W.modalWide}` : W.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": m.title,
      ref: Y,
      onClick: (j) => j.stopPropagation(),
      onKeyDown: ue
    },
    /* @__PURE__ */ t.createElement("div", { className: W.head }, /* @__PURE__ */ t.createElement("h2", null, m.title), o && /* @__PURE__ */ t.createElement("span", { className: W.sub }, "복수 선택 가능"), /* @__PURE__ */ t.createElement("button", { type: "button", className: W.x, onClick: c, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ t.createElement("div", { className: W.body }, m.filters && m.filters.length > 0 && /* @__PURE__ */ t.createElement("div", { className: W.chips }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${W.chip} ${W.chipOn}` : W.chip,
        onClick: () => {
          f(null), E(0);
        }
      },
      "전체"
    ), m.filters.map((j) => /* @__PURE__ */ t.createElement(
      "button",
      {
        key: j.value,
        type: "button",
        className: p === j.value ? `${W.chip} ${W.chipOn}` : W.chip,
        onClick: () => {
          f(j.value), E(0);
        }
      },
      j.label
    ))), /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: l,
        className: W.search,
        value: d,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (j) => {
          _(j.target.value), E(0);
        }
      }
    ), /* @__PURE__ */ t.createElement("div", { className: W.tbl }, /* @__PURE__ */ t.createElement("table", null, /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, o && /* @__PURE__ */ t.createElement("th", { className: W.chk }, /* @__PURE__ */ t.createElement(
      "input",
      {
        type: "checkbox",
        checked: N,
        onChange: O,
        "aria-label": "표시된 행 전체 선택"
      }
    )), q.map((j) => /* @__PURE__ */ t.createElement("th", { key: j.key, style: j.width ? { width: j.width } : void 0 }, j.label)))), /* @__PURE__ */ t.createElement("tbody", { ref: G, className: b && g.length > 0 ? W.busy : void 0, "aria-busy": b }, g.length === 0 ? /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("td", { className: W.emptyCell, colSpan: q.length + (o ? 1 : 0) }, b ? "조회 중…" : h || m.emptyText || "검색 결과가 없습니다")) : g.map((j, U) => /* @__PURE__ */ t.createElement(
      "tr",
      {
        key: j.cd,
        className: [
          W.row,
          U === x ? W.rowCursor : "",
          B.has(j.cd) ? W.rowPicked : "",
          !o && s && j.cd === s ? W.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": U === x,
        onClick: () => {
          C(U), o ? L(j) : F(j);
        }
      },
      o && /* @__PURE__ */ t.createElement("td", { className: W.chk }, /* @__PURE__ */ t.createElement(
        "input",
        {
          type: "checkbox",
          checked: B.has(j.cd),
          onChange: () => L(j),
          onClick: (ee) => ee.stopPropagation(),
          "aria-label": `${j.cd} 선택`
        }
      )),
      q.map((ee) => {
        var ae, ce;
        return /* @__PURE__ */ t.createElement(
          "td",
          {
            key: ee.key,
            className: ee.align === "left" ? W.tdLeft : W.tdCenter,
            title: ee.render ? void 0 : String((ae = j[ee.key]) != null ? ae : "")
          },
          ee.render ? ee.render(j) : String((ce = j[ee.key]) != null ? ce : ""),
          ee.key === "cd" && !o && s && j.cd === s && /* @__PURE__ */ t.createElement("em", { className: W.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ t.createElement("p", { className: W.count, role: "status", "aria-live": "polite" }, b ? "조회 중…" : h ? "" : `${g.length}건`, !o && !b && !h && g.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 줄을 누르세요"), (D || y > 0) && /* @__PURE__ */ t.createElement("div", { className: W.more }, /* @__PURE__ */ t.createElement("span", null, D ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ t.createElement("span", { className: W.pager }, /* @__PURE__ */ t.createElement("button", { type: "button", disabled: y === 0, onClick: () => E((j) => Math.max(0, j - 1)) }, "이전"), /* @__PURE__ */ t.createElement("b", null, y + 1), D && /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => E((j) => j + 1) }, "다음"))), o && /* @__PURE__ */ t.createElement("p", { className: W.note }, "선택 ", /* @__PURE__ */ t.createElement("b", null, B.size), "건 — 선택이 없으면 ", /* @__PURE__ */ t.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ t.createElement("div", { className: W.foot }, o && /* @__PURE__ */ t.createElement("button", { type: "button", className: W.ghost, onClick: () => R(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ t.createElement("button", { type: "button", className: W.ghost, onClick: c }, "취소"), o && /* @__PURE__ */ t.createElement("button", { type: "button", className: W.primary, onClick: oe }, "확인"))
  )));
}
const no = "1900-01-01", ao = "2099-12-31", ca = ["일", "월", "화", "수", "목", "금", "토"], Gn = (e) => String(e).padStart(2, "0");
function Oe(e, n) {
  return new Date(Date.UTC(e, n, 0)).getUTCDate();
}
function Ge(e, n, a) {
  return `${String(e).padStart(4, "0")}-${Gn(n)}-${Gn(a)}`;
}
function me(e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!n) return null;
  const a = +n[1], o = +n[2], r = +n[3];
  return o < 1 || o > 12 || r < 1 || r > Oe(a, o) ? null : { y: a, m: o, d: r };
}
function Jf(e) {
  const n = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!n) return null;
  const a = +n[1], o = +n[2];
  return o < 1 || o > 12 ? null : { y: a, m: o, d: 1 };
}
function bn(e, n) {
  return n === "month" ? Jf(e) : me(e);
}
function Ae(e, n) {
  return n === "month" ? `${String(e.y).padStart(4, "0")}-${Gn(e.m)}` : Ge(e.y, e.m, e.d);
}
function Me(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function rn(e, n) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + n));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function Ct(e, n) {
  const a = e.y * 12 + (e.m - 1) + n, o = Math.floor(a / 12), r = (a % 12 + 12) % 12 + 1;
  return { y: o, m: r, d: Math.min(e.d, Oe(o, r)) };
}
function Qf(e, n, a) {
  return e >= n && e <= a;
}
function Zt(e, n) {
  return e.replace(/\D/g, "").slice(0, n === "month" ? 6 : 8);
}
function ia(e, n) {
  const a = e.slice(0, 4), o = e.slice(4, 6), r = e.slice(6, 8);
  let s = a;
  return e.length > 4 && (s += "-" + o), n === "date" && e.length > 6 && (s += "-" + r), s;
}
function oo(e, n) {
  if (n <= 0) return 0;
  let a = 0;
  for (let o = 0; o < e.length; o++)
    if (/\d/.test(e[o]) && (a++, a === n))
      return o + 1;
  return e.length;
}
function Wn(e, n, a) {
  let o, r, s = 1;
  if (n === "month")
    if (e.length === 6)
      o = +e.slice(0, 4), r = +e.slice(4, 6);
    else if (e.length === 4)
      o = 2e3 + +e.slice(0, 2), r = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    o = +e.slice(0, 4), r = +e.slice(4, 6), s = +e.slice(6, 8);
  else if (e.length === 6)
    o = 2e3 + +e.slice(0, 2), r = +e.slice(2, 4), s = +e.slice(4, 6);
  else if (e.length === 4)
    o = a.y, r = +e.slice(0, 2), s = +e.slice(2, 4);
  else return null;
  return r < 1 || r > 12 || s < 1 || s > Oe(o, r) ? null : { y: o, m: r, d: s };
}
function Zf(e, n, a) {
  const o = e.trim(), r = n === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(o) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(o);
  if (r) {
    const s = { y: +r[1], m: +r[2], d: n === "month" ? 1 : +r[3] };
    return s.m >= 1 && s.m <= 12 && s.d >= 1 && s.d <= Oe(s.y, s.m) ? s : null;
  }
  return Wn(o.replace(/\D/g, ""), n, a);
}
function e1(e, n) {
  const a = { y: e, m: n, d: 1 }, o = rn(a, -Me(a));
  return Array.from({ length: 42 }, (r, s) => rn(o, s));
}
function t1(e, n) {
  const a = e.y, o = [], r = (u, m) => `${String(u).padStart(4, "0")}-${Gn(m)}`, s = (u, m, d) => Ge(u, m, d);
  if (n === "month") {
    o.push({ label: "이번 달", from: r(a, e.m), to: r(a, e.m) });
    const u = Ct(e, -1);
    o.push({ label: "지난달", from: r(u.y, u.m), to: r(u.y, u.m) }), o.push({ label: "올해", from: r(a, 1), to: r(a, 12) }), o.push({ label: "올해 누계", from: r(a, 1), to: r(a, e.m) }), o.push({ label: "전년도", from: r(a - 1, 1), to: r(a - 1, 12) });
    for (let m = 1; m <= 4; m++) o.push({ label: `${m}분기`, from: r(a, m * 3 - 2), to: r(a, m * 3) });
    return o.push({ label: "상반기", from: r(a, 1), to: r(a, 6) }), o.push({ label: "하반기", from: r(a, 7), to: r(a, 12) }), o;
  }
  const l = Ge(e.y, e.m, e.d);
  o.push({ label: "오늘", from: l, to: l });
  const i = rn(e, -Me(e));
  o.push({ label: "이번 주", from: Ae(i, "date"), to: Ae(rn(i, 6), "date") }), o.push({ label: "이번 달", from: s(a, e.m, 1), to: s(a, e.m, Oe(a, e.m)) });
  const c = Ct({ ...e, d: 1 }, -1);
  o.push({ label: "지난달", from: s(c.y, c.m, 1), to: s(c.y, c.m, Oe(c.y, c.m)) }), o.push({ label: "올해", from: s(a, 1, 1), to: s(a, 12, 31) }), o.push({ label: "올해 오늘까지", from: s(a, 1, 1), to: l }), o.push({ label: "전년도", from: s(a - 1, 1, 1), to: s(a - 1, 12, 31) });
  for (let u = 1; u <= 4; u++)
    o.push({ label: `${u}분기`, from: s(a, u * 3 - 2, 1), to: s(a, u * 3, Oe(a, u * 3)) });
  return o;
}
const n1 = "_wrap_uxy72_1", a1 = "_disabled_uxy72_18", o1 = "_input_uxy72_22", r1 = "_month_uxy72_36", s1 = "_weekday_uxy72_39", l1 = "_sun_uxy72_40", c1 = "_sat_uxy72_41", i1 = "_icon_uxy72_43", u1 = "_readOnly_uxy72_57", m1 = "_required_uxy72_62", d1 = "_invalid_uxy72_63", _1 = "_pop_uxy72_66", p1 = "_calHead_uxy72_79", f1 = "_calTitleStatic_uxy72_80", y1 = "_calTitle_uxy72_80", h1 = "_grid_uxy72_90", b1 = "_wd_uxy72_91", E1 = "_day_uxy72_95", g1 = "_mon_uxy72_36", v1 = "_out_uxy72_104", k1 = "_sel_uxy72_105", w1 = "_today_uxy72_108", N1 = "_months_uxy72_111", $1 = "_foot_uxy72_114", x1 = "_clear_uxy72_127", D1 = "_range_uxy72_130", C1 = "_tilde_uxy72_131", S1 = "_rangeErr_uxy72_132", ne = {
  wrap: n1,
  disabled: a1,
  input: o1,
  month: r1,
  weekday: s1,
  sun: l1,
  sat: c1,
  icon: i1,
  readOnly: u1,
  required: m1,
  invalid: d1,
  pop: _1,
  calHead: p1,
  calTitleStatic: f1,
  calTitle: y1,
  grid: h1,
  wd: b1,
  day: E1,
  mon: g1,
  out: v1,
  sel: k1,
  today: w1,
  months: N1,
  foot: $1,
  clear: x1,
  range: D1,
  tilde: C1,
  rangeErr: S1
}, $t = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function ro({
  value: e,
  onChange: n,
  mode: a = "date",
  min: o,
  max: r,
  disabled: s,
  readOnly: l,
  required: i,
  invalid: c,
  showWeekday: u,
  placeholder: m,
  id: d,
  name: _,
  onBlur: p,
  "aria-label": f,
  "aria-describedby": y,
  className: E = "",
  style: g
}) {
  const w = a === "month", D = o || (w ? no.slice(0, 7) : no), k = r || (w ? ao.slice(0, 7) : ao), b = (S) => Qf(S, D, k), $ = !!s || !!l, [h, v] = A(e || ""), [x, C] = A(!1), [B, R] = A(!1), [P, G] = A(w ? "month" : "day"), [q, L] = A(() => {
    var X;
    const S = (X = bn(e, a)) != null ? X : $t();
    return { y: S.y, m: S.m };
  }), [F, oe] = A({ top: 0, left: 0 }), N = I(null), O = I(null), Y = I(null), H = I(null);
  Z(() => {
    v(e || ""), C(!1);
  }, [e]), Z(() => {
    const S = bn(e, a);
    S && L({ y: S.y, m: S.m });
  }, [e, a]), He(() => {
    const S = O.current;
    H.current != null && S && document.activeElement === S && S.setSelectionRange(H.current, H.current), H.current = null;
  }, [h]), He(() => {
    if (!B) return;
    const S = () => {
      const X = N.current, te = Y.current;
      if (!X || !te) return;
      const T = X.getBoundingClientRect(), K = te.offsetHeight, V = te.offsetWidth;
      let re = T.bottom + 4;
      re + K > window.innerHeight - 8 && T.top - K - 4 > 8 && (re = T.top - K - 4);
      const Ye = Math.max(8, Math.min(T.left, window.innerWidth - V - 8));
      oe((st) => st.top === re && st.left === Ye ? st : { top: re, left: Ye });
    };
    return S(), window.addEventListener("resize", S), window.addEventListener("scroll", S, !0), () => {
      window.removeEventListener("resize", S), window.removeEventListener("scroll", S, !0);
    };
  }, [B, P, q.y, q.m]), Z(() => {
    if (!B) return;
    const S = (X) => {
      var T, K;
      const te = X.target;
      (T = N.current) != null && T.contains(te) || (K = Y.current) != null && K.contains(te) || R(!1);
    };
    return document.addEventListener("mousedown", S), () => document.removeEventListener("mousedown", S);
  }, [B]);
  const ue = (S) => {
    S !== (e || "") && n(S);
  }, j = (S) => {
    v(S), C(!1), ue(S);
  }, U = () => {
    const S = Zt(h, a);
    if (!S) return;
    const X = Wn(S, a, $t()), te = X ? Ae(X, a) : null;
    if (te && b(te)) {
      j(te);
      return;
    }
    v(e || ""), C(!1);
  }, ee = (S, X) => {
    const te = Zt(S.slice(0, X), a).length, T = Zt(S, a), K = ia(T, a);
    if (H.current = oo(K, Math.min(te, T.length)), v(K), !T) {
      C(!1), ue("");
      return;
    }
    if (T.length === (w ? 6 : 8)) {
      const V = Wn(T, a, $t()), re = V ? Ae(V, a) : null;
      re && b(re) ? (C(!1), ue(re)) : C(!0);
    } else C(!1);
  }, ae = (S, X) => {
    var Ye;
    const te = $t(), T = Zt(h, a), K = (Ye = Wn(T, a, te)) != null ? Ye : bn(e, a);
    let V;
    K ? w ? V = Ct(K, S === "year" ? 12 * X : X) : S === "day" ? V = rn(K, X) : V = Ct(K, S === "month" ? X : 12 * X) : V = te;
    const re = Ae(V, a);
    b(re) && j(re);
  }, ce = (S) => {
    var X;
    j(S), R(!1), (X = O.current) == null || X.focus();
  }, z = () => {
    var X;
    if ($) return;
    const S = (X = bn(e, a)) != null ? X : $t();
    L({ y: S.y, m: S.m }), G(w ? "month" : "day"), R(!0);
  }, ie = (S) => {
    var te, T;
    if ($) return;
    const X = S.currentTarget;
    switch (S.key) {
      case "Escape":
        B ? (R(!1), S.preventDefault(), S.stopPropagation(), S.nativeEvent.stopImmediatePropagation()) : h !== (e || "") && (v(e || ""), C(!1), S.preventDefault(), S.stopPropagation(), S.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => X.select()));
        break;
      case "ArrowDown":
        S.preventDefault(), S.altKey ? B ? R(!1) : z() : ae("day", 1);
        break;
      case "ArrowUp":
        S.preventDefault(), ae("day", -1);
        break;
      case "PageDown":
        S.preventDefault(), ae("month", 1);
        break;
      case "PageUp":
        S.preventDefault(), ae("month", -1);
        break;
      case "F2":
      case "F4":
        S.preventDefault(), B ? R(!1) : z();
        break;
      case "Enter":
        U(), B && R(!1);
        break;
      case "t":
      case "T":
        if (S.ctrlKey || S.metaKey || S.altKey) break;
        S.preventDefault(), j(Ae($t(), a));
        break;
      case "Backspace": {
        const K = (te = X.selectionStart) != null ? te : 0;
        if (K === ((T = X.selectionEnd) != null ? T : 0) && K > 0 && h[K - 1] === "-") {
          S.preventDefault();
          const V = Zt(h.slice(0, K), a).length, re = Zt(h, a);
          ee(ia(re.slice(0, V - 1) + re.slice(V), a), 0), H.current = oo(ia(re.slice(0, V - 1) + re.slice(V), a), V - 1);
        }
        break;
      }
    }
  }, Et = (S) => {
    if ($) return;
    S.preventDefault();
    const X = Zf(S.clipboardData.getData("text"), a, $t()), te = X ? Ae(X, a) : null;
    te && b(te) ? j(te) : C(!0);
  }, gt = (S) => {
    var te, T;
    const X = S.relatedTarget;
    X && ((te = N.current) != null && te.contains(X) || (T = Y.current) != null && T.contains(X)) || (U(), R(!1), p && p());
  }, de = bn(e, a), pe = $t(), Wt = x || !!c, Ie = u && !w && de ? Me(de) : null, Fe = (S) => Ae(S, a), zt = (S, X) => {
    const te = Ae({ y: S, m: X, d: 1 }, "date"), T = Ae({ y: S, m: X, d: Oe(S, X) }, "date"), K = w ? D + "-01" : D, V = w ? k + "-31" : k;
    return T >= K && te <= V;
  }, ot = (S) => {
    const X = Ct({ y: q.y, m: q.m, d: 1 }, S);
    L({ y: X.y, m: X.m });
  }, vt = () => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: ne.calHead }, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => ot(-12) }, "«"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => ot(-1) }, "‹"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, className: ne.calTitle, "aria-label": "연·월 선택", onClick: () => G("month") }, q.y, "년 ", q.m, "월"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => ot(1) }, "›"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => ot(12) }, "»")), /* @__PURE__ */ t.createElement("div", { className: ne.grid }, ca.map((S, X) => /* @__PURE__ */ t.createElement("span", { key: S, className: [ne.wd, X === 0 ? ne.sun : "", X === 6 ? ne.sat : ""].join(" ") }, S)), e1(q.y, q.m).map((S) => {
    const X = Ae(S, "date"), te = Me(S), T = [
      ne.day,
      S.m !== q.m ? ne.out : "",
      te === 0 ? ne.sun : "",
      te === 6 ? ne.sat : "",
      X === Ae(pe, "date") ? ne.today : "",
      de && X === Ae(de, "date") ? ne.sel : ""
    ].join(" "), K = !b(X);
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: X,
        type: "button",
        tabIndex: -1,
        className: T,
        disabled: K,
        "aria-label": `${S.y}년 ${S.m}월 ${S.d}일 ${ca[te]}요일`,
        "aria-pressed": !!de && X === Ae(de, "date"),
        onClick: () => ce(X)
      },
      S.d
    );
  }))), Kt = () => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: ne.calHead }, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => ot(-12) }, "«"), /* @__PURE__ */ t.createElement("span", { className: ne.calTitleStatic }, q.y, "년"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => ot(12) }, "»")), /* @__PURE__ */ t.createElement("div", { className: ne.months }, Array.from({ length: 12 }, (S, X) => X + 1).map((S) => {
    const X = !!de && de.y === q.y && de.m === S, te = [ne.mon, X ? ne.sel : "", pe.y === q.y && pe.m === S ? ne.today : ""].join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: S,
        type: "button",
        tabIndex: -1,
        className: te,
        disabled: !zt(q.y, S),
        "aria-pressed": X,
        onClick: () => {
          w ? ce(Fe({ y: q.y, m: S, d: 1 })) : (L({ y: q.y, m: S }), G("day"));
        }
      },
      S,
      "월"
    );
  }))), rt = Ae(pe, a), Tn = w ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, disabled: !b(rt), onClick: () => ce(rt) }, "이번 달")) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, disabled: !b(rt), onClick: () => ce(rt) }, "오늘"), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !b(Fe({ y: q.y, m: q.m, d: 1 })),
      onClick: () => ce(Fe({ y: q.y, m: q.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !b(Fe({ y: q.y, m: q.m, d: Oe(q.y, q.m) })),
      onClick: () => ce(Fe({ y: q.y, m: q.m, d: Oe(q.y, q.m) }))
    },
    "월말"
  )), Ln = [
    ne.wrap,
    s ? ne.disabled : "",
    l ? ne.readOnly : "",
    i && !e && !h ? ne.required : "",
    Wt ? ne.invalid : "",
    w ? ne.month : "",
    E
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ t.createElement("span", { ref: N, className: Ln, style: g, onBlur: gt }, /* @__PURE__ */ t.createElement(
    "input",
    {
      ref: O,
      id: d,
      name: _,
      className: ne.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: h,
      placeholder: m != null ? m : w ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: s,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": B,
      "aria-label": f,
      "aria-describedby": y,
      "aria-invalid": Wt || void 0,
      "aria-required": i || void 0,
      onChange: (S) => {
        var X;
        return ee(S.target.value, (X = S.target.selectionStart) != null ? X : S.target.value.length);
      },
      onKeyDown: ie,
      onPaste: Et
    }
  ), Ie != null && /* @__PURE__ */ t.createElement("span", { className: [ne.weekday, Ie === 0 ? ne.sun : "", Ie === 6 ? ne.sat : ""].join(" "), "aria-hidden": "true" }, "(", ca[Ie], ")"), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: ne.icon,
      disabled: $,
      "aria-label": w ? "월 선택 열기" : "달력 열기",
      onMouseDown: (S) => S.preventDefault(),
      onClick: () => {
        var S;
        (S = O.current) == null || S.focus(), B ? R(!1) : z();
      }
    },
    /* @__PURE__ */ t.createElement(Hn, { name: "calendar", size: 15 })
  ), B && /* @__PURE__ */ t.createElement(un, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: Y,
      className: ne.pop,
      style: { top: F.top, left: F.left },
      role: "dialog",
      "aria-label": w ? "월 선택" : "날짜 선택",
      onMouseDown: (S) => S.preventDefault()
    },
    P === "day" && !w ? vt() : Kt(),
    /* @__PURE__ */ t.createElement("div", { className: ne.foot }, Tn, !i && /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, className: ne.clear, onClick: () => ce("") }, "지우기"))
  )));
}
const It = (e) => String(e).padStart(2, "0");
function Zo() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${It(e.getMonth() + 1)}-${It(e.getDate())}`;
}
function oN(e) {
  if (!e) return "";
  const n = new Date(e);
  return Number.isNaN(n.getTime()) ? String(e) : `${n.getFullYear()}-${It(n.getMonth() + 1)}-${It(n.getDate())} ${It(n.getHours())}:${It(n.getMinutes())}:${It(n.getSeconds())}`;
}
function rN(e, n) {
  return !!e && !!n && e <= n;
}
function sN({
  from: e,
  to: n,
  onChange: a,
  mode: o = "date",
  min: r,
  max: s,
  disabled: l,
  label: i = "기간",
  presets: c = !0,
  showWeekday: u
}) {
  const m = !!e && !!n && e > n, d = /* @__PURE__ */ new Date(), _ = c === !1 ? [] : Array.isArray(c) ? c : t1({ y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate() }, o), p = (f) => (!r || f.from >= r) && (!s || f.to <= s);
  return /* @__PURE__ */ t.createElement("span", { className: ne.range }, /* @__PURE__ */ t.createElement(
    ro,
    {
      value: e,
      mode: o,
      min: r,
      max: s,
      disabled: l,
      showWeekday: u,
      "aria-label": `${i} 시작`,
      onChange: (f) => a(f, n)
    }
  ), /* @__PURE__ */ t.createElement("span", { className: ne.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ t.createElement(
    ro,
    {
      value: n,
      mode: o,
      min: r,
      max: s,
      disabled: l,
      showWeekday: u,
      "aria-label": `${i} 끝`,
      onChange: (f) => a(e, f)
    }
  ), _.length > 0 && /* @__PURE__ */ t.createElement(
    Id,
    {
      label: "기간",
      title: `${i} 빠른 선택`,
      disabled: l,
      entries: _.map((f) => qd(
        f.label,
        f.label,
        () => a(f.from, f.to),
        p(f) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), m && /* @__PURE__ */ t.createElement("span", { className: ne.rangeErr, role: "alert" }, "시작이 끝보다 늦습니다"));
}
const er = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function tr(e, n = er) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let o = null;
  for (const r of n) r.start <= e.slice(0, 10) && (!o || r.start > o.start) && (o = r);
  return o ? { era: o, year: +a[1] - +o.start.slice(0, 4) + 1 } : null;
}
function A1(e, n = {}) {
  const a = tr(e, n.eras);
  return a ? `${a.era.name}${a.year === 1 && n.gannen !== !1 ? "元" : a.year}年` : null;
}
function lN(e, n) {
  const a = tr(e, n);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const xe = 1440, Un = (e) => String(e).padStart(2, "0");
function ye(e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return n ? Date.UTC(+n[1], +n[2] - 1, +n[3], n[4] ? +n[4] : 0, n[5] ? +n[5] : 0) / 6e4 : NaN;
}
function Pt(e) {
  const n = new Date(e * 6e4);
  return Ge(n.getUTCFullYear(), n.getUTCMonth() + 1, n.getUTCDate());
}
function Nn(e) {
  const n = new Date(e * 6e4);
  return `${Pt(e)}T${Un(n.getUTCHours())}:${Un(n.getUTCMinutes())}`;
}
function nt(e) {
  const n = (e % xe + xe) % xe;
  return `${Un(Math.floor(n / 60))}:${Un(n % 60)}`;
}
function ve(e, n) {
  const a = me(e);
  if (!a) return e;
  const o = rn(a, n);
  return Ge(o.y, o.m, o.d);
}
function sn(e, n) {
  return Math.round((ye(n) - ye(e)) / xe);
}
function Cn(e) {
  const n = me(e);
  if (!n) return !1;
  const a = Me(n);
  return a === 0 || a === 6;
}
function M1(e) {
  var r;
  const n = ye(e.start);
  if (Number.isNaN(n)) return null;
  const a = (r = e.allDay) != null ? r : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const s = Pt(n), l = e.end ? Pt(ye(e.end)) : s, i = l < s ? s : l;
    return { ev: e, s: ye(s), e: ye(i) + xe, allDay: a, sDay: s, eDay: i };
  }
  let o = e.end ? ye(e.end) : n + 60;
  return (Number.isNaN(o) || o <= n) && (o = n + 30), { ev: e, s: n, e: o, allDay: a, sDay: Pt(n), eDay: Pt(o - 1) };
}
function ta(e, n, a, o) {
  const r = [];
  for (const s of e) {
    const l = o && s.id === o.id ? { ...s, start: o.start, end: o.end } : s, i = M1(l);
    i && i.eDay >= n && i.sDay <= a && r.push(i);
  }
  return r.sort(B1);
}
function B1(e, n) {
  if (e.sDay !== n.sDay) return e.sDay < n.sDay ? -1 : 1;
  const a = sn(n.sDay, n.eDay) - sn(e.sDay, e.eDay);
  return a || (e.allDay !== n.allDay ? e.allDay ? -1 : 1 : e.s !== n.s ? e.s - n.s : e.ev.title.localeCompare(n.ev.title));
}
function j1(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function nr(e) {
  return e.allDay || e.e - e.s >= xe;
}
function Yn(e, n) {
  const a = me(e);
  if (!a) return e;
  const o = (Me(a) - n + 7) % 7;
  return ve(e, -o);
}
function na(e, n) {
  const a = sn(e, n);
  return Array.from({ length: Math.max(0, a + 1) }, (o, r) => ve(e, r));
}
function ar(e, n) {
  const a = me(e), o = Ge(a.y, a.m, 1), r = Ge(a.y, a.m, Oe(a.y, a.m)), s = Yn(o, n), l = ve(Yn(r, n), 6), i = na(s, l), c = [];
  for (let u = 0; u < i.length; u += 7) c.push(i.slice(u, u + 7));
  return c;
}
function ja(e, n, a) {
  if (e === "month") {
    const o = ar(n, a);
    return { from: o[0][0], to: o[o.length - 1][6] };
  }
  if (e === "agenda") {
    const o = me(n);
    return { from: Ge(o.y, o.m, 1), to: Ge(o.y, o.m, Oe(o.y, o.m)) };
  }
  if (e === "week") {
    const o = Yn(n, a);
    return { from: o, to: ve(o, 6) };
  }
  return { from: n, to: n };
}
function T1(e, n, a, o = !1) {
  const r = me(n);
  if (!r) return n;
  if (e === "month" || e === "agenda") {
    const l = Ct(r, a);
    return Ge(l.y, l.m, l.d);
  }
  if (e === "week") return ve(n, 7 * a);
  let s = ve(n, a);
  for (; o && Cn(s); ) s = ve(s, a);
  return s;
}
function L1(e, n, a, o) {
  if (!me(n)) return "";
  if (e === "month" || e === "agenda") return o.ym(`${n.slice(0, 7)}-01`);
  if (e === "day") return o.dayTitle(n);
  const { from: r, to: s } = ja("week", n, a);
  return o.year(r) !== o.year(s) ? `${o.ymd(r)} – ${o.ymd(s)}` : r.slice(5, 7) !== s.slice(5, 7) ? `${o.ymd(r)} – ${o.md(s)}` : `${o.ymd(r)} – ${o.d(s)}`;
}
function or(e, n) {
  const a = [], o = [];
  for (const r of e) {
    let s = -1, l = -1;
    for (let c = 0; c < n.length; c++)
      n[c] >= r.sDay && n[c] <= r.eDay && (s < 0 && (s = c), l = c);
    if (s < 0) continue;
    let i = o.findIndex((c) => c < s);
    i < 0 ? (i = o.length, o.push(l)) : o[i] = l, a.push({ item: r, col: s, span: l - s + 1, lane: i, contL: r.sDay < n[s], contR: r.eDay > n[l] });
  }
  return a;
}
function q1(e, n, a) {
  const o = new Array(n).fill(0);
  for (const i of e) for (let c = i.col; c < i.col + i.span; c++) o[c]++;
  const r = Math.max(1, a), s = e.filter((i) => {
    if (i.lane < r - 1) return !0;
    if (i.lane > r - 1) return !1;
    for (let c = i.col; c < i.col + i.span; c++) if (o[c] > r) return !1;
    return !0;
  }), l = new Array(n).fill(0);
  for (const i of s) for (let c = i.col; c < i.col + i.span; c++) l[c]++;
  return { shown: s, more: o.map((i, c) => i - l[c]) };
}
const I1 = 20;
function F1(e, n) {
  const a = ye(n), o = a + xe, r = e.filter((u) => !nr(u) && u.s < o && u.e > a).map((u) => ({
    item: u,
    top: Math.max(u.s, a) - a,
    bottom: Math.min(u.e, o) - a,
    col: 0,
    cols: 1,
    contTop: u.s < a,
    contBottom: u.e > o
  })).sort((u, m) => u.top - m.top || m.bottom - u.bottom);
  let s = [], l = [], i = -1;
  const c = () => {
    for (const u of s) u.cols = l.length;
    s = [], l = [];
  };
  for (const u of r) {
    u.top >= i && c();
    const m = Math.max(u.bottom, u.top + I1);
    let d = l.findIndex((_) => _ <= u.top);
    d < 0 ? (d = l.length, l.push(m)) : l[d] = m, u.col = d, s.push(u), i = Math.max(i, m);
  }
  return c(), r;
}
function so(e, n) {
  return Math.round(e / n) * n;
}
function Na(e, n) {
  if (e.allDay) {
    const a = Math.round(n / xe);
    return { start: ve(e.sDay, a), end: ve(e.eDay, a) };
  }
  return { start: Nn(e.s + n), end: Nn(e.e + n) };
}
function Ta(e, n = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return n;
    const l = me(e.sDay), i = me(e.eDay);
    return `${l.m}/${l.d} – ${i.m}/${i.d}`;
  }
  const a = ye(e.sDay), o = nt(e.s - a);
  if (e.sDay === e.eDay) return `${o} – ${e.e - a === xe ? "24:00" : nt(e.e - a)}`;
  const r = me(e.sDay), s = me(Pt(e.e));
  return `${r.m}/${r.d} ${o} – ${s.m}/${s.d} ${nt(e.e - ye(Pt(e.e)))}`;
}
const Ne = (e) => {
  const n = me(e);
  return { ...n, w: Me(n) };
};
function lo(e, n, a, o, r) {
  const s = `${+e.slice(0, 4)}${a}`;
  if (n === "gregorian") return s;
  const l = A1(e, { eras: o, gannen: r });
  return l ? n === "era" ? l : `${s}(${l})` : s;
}
function R1(e = "ko", n = {}) {
  var c, u;
  const a = (c = n.year) != null ? c : e === "ja" ? "era" : "gregorian", o = (u = n.eras) != null ? u : er, r = n.gannen !== !1;
  if (e === "ja") {
    const m = ["日", "月", "火", "水", "木", "金", "土"], d = (p) => lo(p, a, "年", o, r), _ = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: m,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (p) => `前の${_[p]} (P)`,
      next: (p) => `次の${_[p]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (p) => `他${p}件`,
      eventCount: (p) => `予定${p}件`,
      dayOfSpan: (p, f) => `${p}/${f}日目`,
      openDay: (p) => {
        const f = Ne(p);
        return `${f.m}月${f.d}日を日表示`;
      },
      year: d,
      ym: (p) => `${d(p)}${Ne(p).m}月`,
      ymd: (p) => {
        const f = Ne(p);
        return `${d(p)}${f.m}月${f.d}日`;
      },
      md: (p) => {
        const f = Ne(p);
        return `${f.m}月${f.d}日`;
      },
      d: (p) => `${Ne(p).d}日`,
      m: (p) => `${Ne(p).m}月`,
      dayTitle: (p) => {
        const f = Ne(p);
        return `${d(p)}${f.m}月${f.d}日(${m[f.w]})`;
      },
      dayAria: (p) => {
        const f = Ne(p);
        return `${f.m}月${f.d}日 ${m[f.w]}曜日`;
      }
    };
  }
  const s = ["일", "월", "화", "수", "목", "금", "토"], l = (m) => lo(m, a, "년", o, r), i = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: s,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (m) => `이전 ${i[m]} (P)`,
    next: (m) => `다음 ${i[m]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (m) => `+${m}개`,
    eventCount: (m) => `일정 ${m}건`,
    dayOfSpan: (m, d) => `${m}/${d}일째`,
    openDay: (m) => {
      const d = Ne(m);
      return `${d.m}월 ${d.d}일 일 보기`;
    },
    year: l,
    ym: (m) => `${l(m)} ${Ne(m).m}월`,
    ymd: (m) => {
      const d = Ne(m);
      return `${l(m)} ${d.m}월 ${d.d}일`;
    },
    md: (m) => {
      const d = Ne(m);
      return `${d.m}월 ${d.d}일`;
    },
    d: (m) => `${Ne(m).d}일`,
    m: (m) => `${Ne(m).m}월`,
    dayTitle: (m) => {
      const d = Ne(m);
      return `${l(m)} ${d.m}월 ${d.d}일 (${s[d.w]})`;
    },
    dayAria: (m) => {
      const d = Ne(m);
      return `${d.m}월 ${d.d}일 ${s[d.w]}요일`;
    }
  };
}
const rr = R1("ko"), P1 = "_cal_1rwx2_2", O1 = "_toolbar_1rwx2_20", X1 = "_navBtns_1rwx2_28", W1 = "_title_1rwx2_29", z1 = "_toolRight_1rwx2_36", K1 = "_toggle_1rwx2_37", H1 = "_body_1rwx2_58", G1 = "_busy_1rwx2_59", U1 = "_sun_1rwx2_71", Y1 = "_sat_1rwx2_72", V1 = "_tAccent_1rwx2_75", J1 = "_tOk_1rwx2_76", Q1 = "_tWarn_1rwx2_77", Z1 = "_tDanger_1rwx2_78", ey = "_tViolet_1rwx2_79", ty = "_tGray_1rwx2_80", ny = "_month_1rwx2_83", ay = "_mHead_1rwx2_84", oy = "_wdName_1rwx2_85", ry = "_mBody_1rwx2_91", sy = "_mWeek_1rwx2_92", ly = "_mCells_1rwx2_94", cy = "_cell_1rwx2_96", iy = "_out_1rwx2_104", uy = "_dayNum_1rwx2_105", my = "_creatable_1rwx2_106", dy = "_selDay_1rwx2_109", _y = "_cellHead_1rwx2_111", py = "_isToday_1rwx2_124", fy = "_holiday_1rwx2_125", yy = "_addHint_1rwx2_130", hy = "_barLayer_1rwx2_138", by = "_chip_1rwx2_139", Ey = "_more_1rwx2_139", gy = "_tEv_1rwx2_155", vy = "_aRow_1rwx2_155", ky = "_popItem_1rwx2_155", wy = "_bar_1rwx2_138", Ny = "_contL_1rwx2_165", $y = "_contR_1rwx2_166", xy = "_dotChip_1rwx2_167", Dy = "_dot_1rwx2_167", Cy = "_chipTime_1rwx2_170", Sy = "_chipTitle_1rwx2_171", Ay = "_movable_1rwx2_173", My = "_ghost_1rwx2_176", By = "_time_1rwx2_189", jy = "_tHead_1rwx2_190", Ty = "_tAllDay_1rwx2_190", Ly = "_gutter_1rwx2_193", qy = "_tHeadDays_1rwx2_197", Iy = "_tAllDayCells_1rwx2_197", Fy = "_tDay_1rwx2_198", Ry = "_tDayBtn_1rwx2_202", Py = "_tWd_1rwx2_206", Oy = "_tDayNum_1rwx2_208", Xy = "_tAllDayRow_1rwx2_216", Wy = "_allDayCell_1rwx2_218", zy = "_tBody_1rwx2_222", Ky = "_tGrid_1rwx2_223", Hy = "_tGutter_1rwx2_224", Gy = "_tCols_1rwx2_230", Uy = "_tCol_1rwx2_230", Yy = "_tSel_1rwx2_238", Vy = "_tEvTitle_1rwx2_258", Jy = "_tEvTime_1rwx2_259", Qy = "_tEvShort_1rwx2_261", Zy = "_contTop_1rwx2_263", eh = "_contBottom_1rwx2_264", th = "_resize_1rwx2_265", nh = "_now_1rwx2_268", ah = "_agenda_1rwx2_272", oh = "_aDay_1rwx2_273", rh = "_aDate_1rwx2_275", sh = "_aDateBtn_1rwx2_276", lh = "_aDayNum_1rwx2_280", ch = "_aDayWd_1rwx2_286", ih = "_aList_1rwx2_288", uh = "_aTime_1rwx2_295", mh = "_aTitle_1rwx2_296", dh = "_aSpan_1rwx2_297", _h = "_aLoc_1rwx2_298", ph = "_empty_1rwx2_303", fh = "_pop_1rwx2_155", yh = "_popHead_1rwx2_321", hh = "_popDay_1rwx2_322", bh = "_popClose_1rwx2_329", Eh = "_popList_1rwx2_334", M = {
  cal: P1,
  toolbar: O1,
  navBtns: X1,
  title: W1,
  toolRight: z1,
  toggle: K1,
  body: H1,
  busy: G1,
  sun: U1,
  sat: Y1,
  tAccent: V1,
  tOk: J1,
  tWarn: Q1,
  tDanger: Z1,
  tViolet: ey,
  tGray: ty,
  month: ny,
  mHead: ay,
  wdName: oy,
  mBody: ry,
  mWeek: sy,
  mCells: ly,
  cell: cy,
  out: iy,
  dayNum: uy,
  creatable: my,
  selDay: dy,
  cellHead: _y,
  isToday: py,
  holiday: fy,
  addHint: yy,
  barLayer: hy,
  chip: by,
  more: Ey,
  tEv: gy,
  aRow: vy,
  popItem: ky,
  bar: wy,
  contL: Ny,
  contR: $y,
  dotChip: xy,
  dot: Dy,
  chipTime: Cy,
  chipTitle: Sy,
  movable: Ay,
  ghost: My,
  time: By,
  tHead: jy,
  tAllDay: Ty,
  gutter: Ly,
  tHeadDays: qy,
  tAllDayCells: Iy,
  tDay: Fy,
  tDayBtn: Ry,
  tWd: Py,
  tDayNum: Oy,
  tAllDayRow: Xy,
  allDayCell: Wy,
  tBody: zy,
  tGrid: Ky,
  tGutter: Hy,
  tCols: Gy,
  tCol: Uy,
  tSel: Yy,
  tEvTitle: Vy,
  tEvTime: Jy,
  tEvShort: Qy,
  contTop: Zy,
  contBottom: eh,
  resize: th,
  now: nh,
  agenda: ah,
  aDay: oh,
  aDate: rh,
  aDateBtn: sh,
  aDayNum: lh,
  aDayWd: ch,
  aList: ih,
  aTime: uh,
  aTitle: mh,
  aSpan: dh,
  aLoc: _h,
  empty: ph,
  pop: fh,
  popHead: yh,
  popDay: hh,
  popClose: bh,
  popList: Eh
}, Vn = 22, gh = {
  accent: M.tAccent,
  ok: M.tOk,
  warn: M.tWarn,
  danger: M.tDanger,
  violet: M.tViolet,
  gray: M.tGray
};
function aa(e) {
  var n;
  return e.color ? "" : gh[(n = e.tone) != null ? n : "accent"];
}
function oa(e) {
  if (e.color)
    return { "--ev": e.color };
}
function sr(e, n) {
  return [e.ev.title, Ta(e, n.allDay), e.ev.location].filter(Boolean).join(", ");
}
const $n = (e, n) => !!e.onEventChange && !n.locked;
function zn(e, n, a) {
  var o;
  for (const r of document.elementsFromPoint(e, n)) {
    const s = (o = r.closest) == null ? void 0 : o.call(r, `[${a}]`);
    if (s) return s;
  }
  return null;
}
function Jn(e, n) {
  const a = e.clientX, o = e.clientY;
  let r = !1;
  const s = (m) => {
    !r && Math.hypot(m.clientX - a, m.clientY - o) < 4 || (r = !0, n.move(m));
  }, l = () => {
    window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", i), window.removeEventListener("pointercancel", c), window.removeEventListener("keydown", u, !0);
  }, i = (m) => {
    l(), n.end(m, r);
  }, c = () => {
    l(), n.cancel();
  }, u = (m) => {
    m.key === "Escape" && (m.preventDefault(), m.stopPropagation(), c());
  };
  window.addEventListener("pointermove", s), window.addEventListener("pointerup", i), window.addEventListener("pointercancel", c), window.addEventListener("keydown", u, !0);
}
function lr(e) {
  const [n, a] = A(null), [o, r] = A(null), s = I(!1);
  return { preview: n, items: (d, _) => ta(e.events, d, _, n), onItemDown: (d, _) => {
    var y;
    if (d.button !== 0 || !$n(e, _.ev)) return;
    const p = (y = zn(d.clientX, d.clientY, "data-cal-day")) == null ? void 0 : y.dataset.calDay;
    if (!p) return;
    s.current = !1;
    let f = 0;
    Jn(d, {
      move: (E) => {
        var w;
        s.current = !0;
        const g = (w = zn(E.clientX, E.clientY, "data-cal-day")) == null ? void 0 : w.dataset.calDay;
        g && (f = sn(p, g), a({ id: _.ev.id, ...Na(_, f * xe) }));
      },
      end: (E, g) => {
        var w;
        a(null), g && f && ((w = e.onEventChange) == null || w.call(e, _.ev, Na(_, f * xe)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (d, _) => {
    if (d.button !== 0 || !e.onCreate) return;
    d.preventDefault();
    let p = _;
    r({ a: _, b: _ }), Jn(d, {
      move: (f) => {
        var E;
        const y = (E = zn(f.clientX, f.clientY, "data-cal-day")) == null ? void 0 : E.dataset.calDay;
        y && (p = y, r({ a: _, b: y }));
      },
      end: () => {
        var E;
        r(null);
        const [f, y] = _ <= p ? [_, p] : [p, _];
        (E = e.onCreate) == null || E.call(e, { start: f, end: y, allDay: !0 });
      },
      cancel: () => r(null)
    });
  }, clickItem: (d, _) => {
    var p;
    if (s.current) {
      s.current = !1;
      return;
    }
    (p = e.onEventClick) == null || p.call(e, _, d);
  }, inSel: (d) => !!o && d >= (o.a < o.b ? o.a : o.b) && d <= (o.a < o.b ? o.b : o.a) };
}
function cr({
  segs: e,
  cols: n,
  top: a,
  ctx: o,
  drag: r
}) {
  return /* @__PURE__ */ t.createElement("div", { className: M.barLayer }, e.map((s) => {
    var d;
    const l = s.item, i = l.ev, c = j1(l), u = nt(l.s - ye(l.sDay)), m = [
      M.chip,
      c ? M.bar : M.dotChip,
      aa(i),
      s.contL ? M.contL : "",
      s.contR ? M.contR : "",
      ((d = r.preview) == null ? void 0 : d.id) === i.id ? M.ghost : "",
      $n(o, i) ? M.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: `${i.id}:${s.col}`,
        type: "button",
        className: m,
        style: {
          left: `calc(${s.col / n * 100}% + 2px)`,
          width: `calc(${s.span / n * 100}% - 4px)`,
          top: a + s.lane * Vn,
          ...oa(i)
        },
        "aria-label": sr(l, o.L),
        onPointerDown: (_) => r.onItemDown(_, l),
        onClick: (_) => r.clickItem(_.currentTarget, i)
      },
      c ? /* @__PURE__ */ t.createElement("span", { className: M.chipTitle }, !l.allDay && !s.contL && /* @__PURE__ */ t.createElement("span", { className: M.chipTime }, u), i.title) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("i", { className: M.dot, "aria-hidden": !0 }), /* @__PURE__ */ t.createElement("span", { className: M.chipTime }, u), /* @__PURE__ */ t.createElement("span", { className: M.chipTitle }, i.title))
    );
  }));
}
const ua = 26;
function vh({ ctx: e }) {
  const { L: n, cursor: a, today: o, weekStartsOn: r, showWeekends: s, holidays: l } = e, i = a.slice(0, 7), c = De(
    () => ar(a, r).map((k) => s ? k : k.filter((b) => !Cn(b))),
    [a, r, s]
  ), u = c[0].length, m = lr(e), d = m.items(c[0][0], c[c.length - 1][u - 1]), _ = I(null), [p, f] = A(0);
  He(() => {
    const k = _.current;
    if (!k) return;
    const b = () => f(k.clientHeight / c.length);
    if (b(), typeof ResizeObserver == "undefined") return;
    const $ = new ResizeObserver(b);
    return $.observe(k), () => $.disconnect();
  }, [c.length]);
  const y = p ? Math.max(1, Math.floor((p - ua - 4) / Vn)) : 3, E = I(!1), g = I(null);
  Z(() => {
    var k, b;
    E.current && (E.current = !1, (b = (k = g.current) == null ? void 0 : k.querySelector(`[data-cal-day="${a}"]`)) == null || b.focus());
  }, [a, i]);
  const w = (k, b) => {
    let $ = ve(k, b);
    for (; !s && Cn($); ) $ = ve($, b > 0 ? 1 : -1);
    return $;
  }, D = (k, b, $) => {
    let h = null;
    if (k.key === "ArrowLeft") h = w(b, -1);
    else if (k.key === "ArrowRight") h = w(b, 1);
    else if (k.key === "ArrowUp") h = w(b, -7);
    else if (k.key === "ArrowDown") h = w(b, 7);
    else if (k.key === "Home") h = $[0];
    else if (k.key === "End") h = $[$.length - 1];
    else if (k.key === "Enter" || k.key === " ") {
      k.preventDefault(), e.goto("day", b);
      return;
    }
    h && (k.preventDefault(), E.current = !0, e.setCursor(h));
  };
  return /* @__PURE__ */ t.createElement("div", { className: M.month, role: "grid", "aria-label": n.ym(`${i}-01`), ref: g }, /* @__PURE__ */ t.createElement("div", { className: M.mHead, role: "row" }, c[0].map((k) => {
    const b = Me(me(k));
    return /* @__PURE__ */ t.createElement("div", { key: k, role: "columnheader", className: [M.wdName, b === 0 ? M.sun : "", b === 6 ? M.sat : ""].join(" ") }, n.weekdays[b]);
  })), /* @__PURE__ */ t.createElement("div", { className: M.mBody, ref: _ }, c.map((k) => {
    const { shown: b, more: $ } = q1(or(d, k), u, y);
    return /* @__PURE__ */ t.createElement("div", { key: k[0], className: M.mWeek, role: "row" }, /* @__PURE__ */ t.createElement("div", { className: M.mCells, style: { gridTemplateColumns: `repeat(${u}, minmax(0, 1fr))` } }, k.map((h) => {
      const v = me(h), x = Me(v), C = l[h], B = d.filter((P) => P.sDay <= h && P.eDay >= h).length, R = [
        M.cell,
        h.slice(0, 7) !== i ? M.out : "",
        x === 0 || C ? M.sun : x === 6 ? M.sat : "",
        h === o ? M.isToday : "",
        m.inSel(h) ? M.selDay : "",
        e.onCreate ? M.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ t.createElement(
        "div",
        {
          key: h,
          role: "gridcell",
          "data-cal-day": h,
          tabIndex: h === a ? 0 : -1,
          "aria-selected": h === a,
          "aria-current": h === o ? "date" : void 0,
          "aria-label": `${n.dayAria(h)}${C ? ` ${C}` : ""}, ${n.eventCount(B)}`,
          className: R,
          onPointerDown: (P) => m.onCellDown(P, h),
          onKeyDown: (P) => D(P, h, k)
        },
        /* @__PURE__ */ t.createElement("div", { className: M.cellHead }, /* @__PURE__ */ t.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: M.dayNum,
            "aria-label": n.openDay(h),
            onPointerDown: (P) => P.stopPropagation(),
            onClick: () => e.goto("day", h)
          },
          v.d === 1 ? n.md(h) : v.d
        ), C && /* @__PURE__ */ t.createElement("span", { className: M.holiday, title: C }, C), e.onCreate && /* @__PURE__ */ t.createElement("span", { className: M.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ t.createElement(cr, { segs: b, cols: u, top: ua, ctx: e, drag: m }), $.map((h, v) => h > 0 ? /* @__PURE__ */ t.createElement(
      "button",
      {
        key: k[v],
        type: "button",
        className: M.more,
        style: {
          left: `calc(${v / u * 100}% + 2px)`,
          width: `calc(${100 / u}% - 4px)`,
          top: ua + (y - 1) * Vn
        },
        onClick: (x) => e.openMore(k[v], x.currentTarget)
      },
      n.more(h)
    ) : null));
  })));
}
const tt = 44, kh = Array.from({ length: 23 }, (e, n) => n + 1);
function co() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function ma(e, n) {
  const a = n.getBoundingClientRect();
  return Math.max(0, Math.min(xe, (e - a.top) / tt * 60));
}
function io({ ctx: e, days: n }) {
  const a = n.length, o = e.slotMinutes, r = lr(e), [s, l] = A(null), [i, c] = A(null), u = I(!1), m = ta(e.events, n[0], n[a - 1], s != null ? s : r.preview), d = or(m.filter(nr), n), _ = d.reduce((b, $) => Math.max(b, $.lane + 1), 0), p = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [f, y] = A(co);
  Z(() => {
    const b = window.setInterval(() => y(co()), 6e4);
    return () => window.clearInterval(b);
  }, []);
  const E = I(null), g = n.includes(e.today);
  He(() => {
    const b = E.current;
    if (!b) return;
    const $ = g ? Math.max(0, Math.floor((f - ye(e.today)) / 60) - 1) : e.scrollToHour;
    b.scrollTop = $ * tt;
  }, [n[0], a]);
  const w = (b, $) => {
    if (b.button !== 0 || !e.onCreate) return;
    b.preventDefault();
    const h = b.currentTarget, v = Math.min(xe - o, Math.floor(ma(b.clientY, h) / o) * o);
    let x = v;
    c({ day: $, a: v, b: v + o }), Jn(b, {
      move: (C) => {
        x = Math.min(xe - o, Math.floor(ma(C.clientY, h) / o) * o), c({ day: $, a: Math.min(v, x), b: Math.max(v, x) + o });
      },
      end: (C, B) => {
        var q;
        c(null);
        const R = ye($), P = B ? Math.min(v, x) : v, G = B ? Math.max(v, x) + o : Math.min(v + 60, xe);
        (q = e.onCreate) == null || q.call(e, { start: Nn(R + P), end: Nn(R + G), allDay: !1 });
      },
      cancel: () => c(null)
    });
  }, D = (b, $, h) => {
    if (b.stopPropagation(), b.button !== 0 || !$n(e, $.ev)) return;
    const v = (B, R) => {
      const P = zn(B, R, "data-cal-col");
      return P ? ye(P.dataset.calCol) + ma(R, P) : null;
    }, x = v(b.clientX, b.clientY);
    if (x == null) return;
    u.current = !1;
    let C = null;
    Jn(b, {
      move: (B) => {
        u.current = !0;
        const R = v(B.clientX, B.clientY);
        if (R != null) {
          if (h === "move") {
            const P = so(R - x, o);
            C = P ? Na($, P) : null;
          } else {
            const P = Math.max($.s + o, so(R, o));
            C = P !== $.e ? { start: $.ev.start, end: Nn(P) } : null;
          }
          l(C ? { id: $.ev.id, ...C } : null);
        }
      },
      end: (B, R) => {
        var P;
        l(null), R && C && ((P = e.onEventChange) == null || P.call(e, $.ev, C));
      },
      cancel: () => l(null)
    });
  }, k = (b, $) => {
    var h;
    if (u.current) {
      u.current = !1;
      return;
    }
    (h = e.onEventClick) == null || h.call(e, $, b);
  };
  return /* @__PURE__ */ t.createElement("div", { className: M.time }, /* @__PURE__ */ t.createElement("div", { className: M.tHead }, /* @__PURE__ */ t.createElement("div", { className: M.gutter }), /* @__PURE__ */ t.createElement("div", { className: M.tHeadDays, style: p }, n.map((b) => {
    const $ = me(b), h = Me($), v = e.holidays[b];
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        key: b,
        className: [M.tDay, b === e.today ? M.isToday : "", h === 0 || v ? M.sun : h === 6 ? M.sat : ""].join(" ")
      },
      /* @__PURE__ */ t.createElement("button", { type: "button", className: M.tDayBtn, onClick: () => e.goto("day", b), "aria-label": e.L.openDay(b) }, /* @__PURE__ */ t.createElement("span", { className: M.tWd }, e.L.weekdays[h]), /* @__PURE__ */ t.createElement("span", { className: M.tDayNum }, $.d)),
      v && /* @__PURE__ */ t.createElement("span", { className: M.holiday, title: v }, v)
    );
  }))), /* @__PURE__ */ t.createElement("div", { className: M.tAllDay }, /* @__PURE__ */ t.createElement("div", { className: M.gutter }, e.L.allDay), /* @__PURE__ */ t.createElement("div", { className: M.tAllDayRow, style: { height: Math.max(1, _) * Vn + 6 } }, /* @__PURE__ */ t.createElement("div", { className: M.tAllDayCells, style: p }, n.map((b) => /* @__PURE__ */ t.createElement(
    "div",
    {
      key: b,
      "data-cal-day": b,
      className: [M.allDayCell, r.inSel(b) ? M.selDay : "", e.onCreate ? M.creatable : ""].join(" "),
      onPointerDown: ($) => r.onCellDown($, b)
    }
  ))), /* @__PURE__ */ t.createElement(cr, { segs: d, cols: a, top: 3, ctx: e, drag: r }))), /* @__PURE__ */ t.createElement("div", { className: M.tBody, ref: E }, /* @__PURE__ */ t.createElement("div", { className: M.tGrid, style: { height: 24 * tt } }, /* @__PURE__ */ t.createElement("div", { className: M.tGutter, "aria-hidden": !0 }, kh.map((b) => /* @__PURE__ */ t.createElement("span", { key: b, style: { top: b * tt } }, nt(b * 60)))), /* @__PURE__ */ t.createElement("div", { className: M.tCols, style: { ...p, backgroundSize: `100% ${tt}px` } }, n.map((b) => {
    const $ = F1(m, b);
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        key: b,
        "data-cal-col": b,
        className: [M.tCol, b === e.today ? M.isToday : "", e.onCreate ? M.creatable : ""].join(" "),
        onPointerDown: (h) => w(h, b)
      },
      (i == null ? void 0 : i.day) === b && /* @__PURE__ */ t.createElement("div", { className: M.tSel, style: { top: i.a / 60 * tt, height: (i.b - i.a) / 60 * tt } }, nt(i.a), " – ", i.b === xe ? "24:00" : nt(i.b)),
      $.map((h) => {
        const v = h.item.ev, x = (h.bottom - h.top) / 60 * tt, C = [
          M.tEv,
          aa(v),
          x < 34 ? M.tEvShort : "",
          h.contTop ? M.contTop : "",
          h.contBottom ? M.contBottom : "",
          (s == null ? void 0 : s.id) === v.id ? M.ghost : "",
          $n(e, v) ? M.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ t.createElement(
          "button",
          {
            key: v.id,
            type: "button",
            className: C,
            style: {
              top: h.top / 60 * tt,
              height: Math.max(18, x - 1),
              left: `calc(${h.col / h.cols * 100}% + 1px)`,
              width: `calc(${100 / h.cols}% - 4px)`,
              ...oa(v)
            },
            "aria-label": sr(h.item, e.L),
            onPointerDown: (B) => D(B, h.item, "move"),
            onClick: (B) => k(B.currentTarget, v)
          },
          /* @__PURE__ */ t.createElement("span", { className: M.tEvTitle }, v.title),
          /* @__PURE__ */ t.createElement("span", { className: M.tEvTime }, Ta(h.item, e.L.allDay)),
          $n(e, v) && !h.contBottom && /* @__PURE__ */ t.createElement("span", { className: M.resize, "aria-hidden": !0, onPointerDown: (B) => D(B, h.item, "resize") })
        );
      }),
      b === e.today && /* @__PURE__ */ t.createElement("div", { className: M.now, style: { top: (f - ye(b)) / 60 * tt }, "aria-hidden": !0 })
    );
  })))));
}
function uo(e, n, a) {
  return e.sDay === e.eDay ? Ta(e, a) : e.allDay ? a : n === e.sDay ? `${nt(e.s - ye(n))} ~` : n === e.eDay ? `~ ${nt(e.e - ye(n))}` : a;
}
function wh({ ctx: e }) {
  const { L: n } = e, { from: a, to: o } = ja("agenda", e.cursor, e.weekStartsOn), r = ta(e.events, a, o), s = na(a, o).filter((l) => e.showWeekends || !Cn(l)).map((l) => {
    const i = ye(l), c = (m) => uo(m, l, "") === "" ? -1 : Math.max(m.s, i), u = r.filter((m) => m.sDay <= l && m.eDay >= l);
    return { day: l, list: u.sort((m, d) => c(m) - c(d)) };
  }).filter((l) => l.list.length > 0);
  return s.length ? /* @__PURE__ */ t.createElement("div", { className: M.agenda }, s.map(({ day: l, list: i }) => {
    const c = me(l), u = e.holidays[l], m = Me(c), d = n.weekdays[m];
    return /* @__PURE__ */ t.createElement("section", { key: l, className: [M.aDay, l === e.today ? M.isToday : ""].join(" "), "aria-label": n.dayAria(l) }, /* @__PURE__ */ t.createElement("div", { className: [M.aDate, m === 0 || u ? M.sun : m === 6 ? M.sat : ""].join(" ") }, /* @__PURE__ */ t.createElement("button", { type: "button", className: M.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ t.createElement("span", { className: M.aDayNum }, c.d), /* @__PURE__ */ t.createElement("span", { className: M.aDayWd }, n.m(l), " · ", d)), u && /* @__PURE__ */ t.createElement("span", { className: M.holiday }, u)), /* @__PURE__ */ t.createElement("ul", { className: M.aList }, i.map((_) => {
      const p = _.ev, f = sn(_.sDay, _.eDay) + 1;
      return /* @__PURE__ */ t.createElement("li", { key: p.id }, /* @__PURE__ */ t.createElement(
        "button",
        {
          type: "button",
          className: [M.aRow, aa(p)].join(" "),
          style: oa(p),
          onClick: (y) => {
            var E;
            return (E = e.onEventClick) == null ? void 0 : E.call(e, p, y.currentTarget);
          }
        },
        /* @__PURE__ */ t.createElement("i", { className: M.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ t.createElement("span", { className: M.aTime }, uo(_, l, n.allDay)),
        /* @__PURE__ */ t.createElement("span", { className: M.aTitle }, p.title, f > 1 && /* @__PURE__ */ t.createElement("em", { className: M.aSpan }, n.dayOfSpan(sn(_.sDay, l) + 1, f))),
        p.location && /* @__PURE__ */ t.createElement("span", { className: M.aLoc }, p.location)
      ));
    })));
  })) : /* @__PURE__ */ t.createElement("div", { className: M.empty }, n.empty);
}
const da = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function mo(e, n, a) {
  const [o, r] = A(n), s = e !== void 0 ? e : o;
  return [s, (i) => {
    e === void 0 && r(i), i !== s && (a == null || a(i));
  }];
}
const _o = ({ dir: e }) => /* @__PURE__ */ t.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ t.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function cN({
  events: e,
  view: n,
  defaultView: a,
  onViewChange: o,
  date: r,
  defaultDate: s,
  onDateChange: l,
  views: i = ["month", "week", "day", "agenda"],
  weekStartsOn: c = 0,
  defaultShowWeekends: u = !0,
  weekendToggle: m = !0,
  holidays: d,
  slotMinutes: _ = 30,
  scrollToHour: p = 8,
  onRangeChange: f,
  onEventClick: y,
  onCreate: E,
  onEventChange: g,
  locale: w = rr,
  loading: D,
  headerExtra: k,
  className: b = "",
  style: $,
  "aria-label": h
}) {
  var ce;
  const v = Zo(), [x, C] = mo(n, (ce = a != null ? a : i[0]) != null ? ce : "month", o), [B, R] = mo(r, s != null ? s : v, l), P = me(B) ? B : v, [G, q] = A(u), [L, F] = A(null), oe = I(null), N = I(!1);
  Z(() => {
    var ie;
    if (!N.current) return;
    N.current = !1;
    const z = oe.current;
    !z || z.contains(document.activeElement) || ((ie = z.querySelector('[data-cal-day][tabindex="0"]')) != null ? ie : z).focus();
  });
  const { from: O, to: Y } = ja(x, P, c), H = I(f);
  H.current = f, Z(() => {
    var z;
    (z = H.current) == null || z.call(H, { from: O, to: Y, view: x });
  }, [O, Y, x]);
  const ue = (z, ie) => {
    R(ie), i.includes(z) && C(z);
  }, j = {
    events: e,
    L: w,
    cursor: P,
    today: v,
    weekStartsOn: c,
    showWeekends: G,
    holidays: d != null ? d : {},
    slotMinutes: _,
    scrollToHour: p,
    setCursor: R,
    goto: ue,
    openMore: (z, ie) => F({ day: z, anchor: ie }),
    onEventClick: y,
    onCreate: E,
    onEventChange: g
  }, U = (z) => R(T1(x, P, z, x === "day" && !G)), ee = (z) => {
    if (z.defaultPrevented || z.ctrlKey || z.metaKey || z.altKey || z.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const ie = z.nativeEvent.code;
    if (ie === "KeyT") R(v);
    else if (ie === "KeyN" || ie === "KeyJ" || z.key === "PageDown") U(1);
    else if (ie === "KeyP" || ie === "KeyK" || z.key === "PageUp") U(-1);
    else if (da[ie] && i.includes(da[ie])) C(da[ie]);
    else if (ie === "KeyC" && E)
      E(x === "month" || x === "agenda" ? { start: P, end: P, allDay: !0 } : { start: `${P}T09:00`, end: `${P}T10:00`, allDay: !1 });
    else return;
    z.preventDefault(), N.current = !0;
  }, ae = De(
    () => na(O, Y).filter((z) => G || !Cn(z)),
    [O, Y, G]
  );
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [M.cal, b].filter(Boolean).join(" "),
      style: $,
      role: "region",
      "aria-label": h != null ? h : w.region,
      "aria-busy": D || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: ee,
      ref: oe,
      tabIndex: -1
    },
    /* @__PURE__ */ t.createElement("div", { className: M.toolbar }, /* @__PURE__ */ t.createElement(on, { onClick: () => R(v), title: `${w.today} (T)` }, w.today), /* @__PURE__ */ t.createElement("span", { className: M.navBtns }, /* @__PURE__ */ t.createElement(ka, { label: w.prev(x), onClick: () => U(-1) }, /* @__PURE__ */ t.createElement(_o, { dir: "l" })), /* @__PURE__ */ t.createElement(ka, { label: w.next(x), onClick: () => U(1) }, /* @__PURE__ */ t.createElement(_o, { dir: "r" }))), /* @__PURE__ */ t.createElement("h2", { className: M.title, "aria-live": "polite" }, L1(x, P, c, w)), /* @__PURE__ */ t.createElement("span", { className: M.toolRight }, k, m && x !== "day" && /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: M.toggle,
        "aria-pressed": !G,
        onClick: () => q((z) => !z)
      },
      w.hideWeekends
    ), i.length > 1 && /* @__PURE__ */ t.createElement(
      Yo,
      {
        variant: "segmented",
        "aria-label": w.viewTabs,
        items: i.map((z) => ({ key: z, label: w.views[z] })),
        value: x,
        onChange: (z) => C(z)
      }
    ))),
    /* @__PURE__ */ t.createElement("div", { className: M.body }, D && /* @__PURE__ */ t.createElement("div", { className: M.busy, role: "progressbar", "aria-label": w.loading }), x === "month" && /* @__PURE__ */ t.createElement(vh, { ctx: j }), x === "week" && /* @__PURE__ */ t.createElement(io, { ctx: j, days: ae }), x === "day" && /* @__PURE__ */ t.createElement(io, { ctx: j, days: [P] }), x === "agenda" && /* @__PURE__ */ t.createElement(wh, { ctx: j })),
    L && /* @__PURE__ */ t.createElement(Nh, { ctx: j, day: L.day, anchor: L.anchor, onClose: () => F(null) })
  );
}
function Nh({ ctx: e, day: n, anchor: a, onClose: o }) {
  const r = I(null), [s, l] = A({ top: -9999, left: -9999 }), i = me(n), c = ta(e.events, n, n);
  return He(() => {
    var p;
    const u = r.current;
    if (!u) return;
    const m = a.getBoundingClientRect(), d = u.offsetWidth, _ = u.offsetHeight;
    l({
      left: Math.max(8, Math.min(m.left + m.width / 2 - d / 2, window.innerWidth - d - 8)),
      top: Math.max(8, Math.min(m.top - 60, window.innerHeight - _ - 8))
    }), (p = u.querySelector("[data-cal-pop-item]")) == null || p.focus();
  }, [a]), Z(() => {
    const u = () => {
      o(), a.isConnected && a.focus();
    }, m = (_) => {
      var p;
      (p = r.current) != null && p.contains(_.target) || o();
    }, d = (_) => {
      _.key === "Escape" && (_.preventDefault(), u());
    };
    return document.addEventListener("mousedown", m), document.addEventListener("keydown", d), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("keydown", d);
    };
  }, [a, o]), /* @__PURE__ */ t.createElement(un, null, /* @__PURE__ */ t.createElement("div", { ref: r, className: M.pop, style: s, role: "dialog", "aria-label": `${e.L.md(n)} ${e.L.eventCount(c.length)}` }, /* @__PURE__ */ t.createElement("div", { className: M.popHead }, /* @__PURE__ */ t.createElement("button", { type: "button", className: M.popDay, onClick: () => {
    o(), e.goto("day", n);
  } }, /* @__PURE__ */ t.createElement("span", null, e.L.weekdays[Me(i)]), /* @__PURE__ */ t.createElement("b", null, i.d)), /* @__PURE__ */ t.createElement("button", { type: "button", className: M.popClose, "aria-label": e.L.close, onClick: o }, "✕")), /* @__PURE__ */ t.createElement("ul", { className: M.popList }, c.map((u) => {
    const m = u.ev, d = u.allDay || u.sDay !== u.eDay;
    return /* @__PURE__ */ t.createElement("li", { key: m.id }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [M.popItem, d ? M.bar : M.dotChip, aa(m)].join(" "),
        style: oa(m),
        onClick: () => {
          var _;
          o(), (_ = e.onEventClick) == null || _.call(e, m, a);
        }
      },
      !d && /* @__PURE__ */ t.createElement("i", { className: M.dot, "aria-hidden": !0 }),
      !u.allDay && /* @__PURE__ */ t.createElement("span", { className: M.chipTime }, nt(Math.max(u.s, ye(n)) - ye(n))),
      /* @__PURE__ */ t.createElement("span", { className: M.chipTitle }, m.title)
    ));
  }))));
}
const $h = "_mini_q7p5n_3", xh = "_nav_q7p5n_5", Dh = "_navBtn_q7p5n_6", Ch = "_todayBtn_q7p5n_6", Sh = "_title_q7p5n_6", Ah = "_day_q7p5n_25", Mh = "_mon_q7p5n_25", Bh = "_grid_q7p5n_29", jh = "_wdRow_q7p5n_30", Th = "_row_q7p5n_30", Lh = "_sun_q7p5n_35", qh = "_sat_q7p5n_36", Ih = "_num_q7p5n_45", Fh = "_sel_q7p5n_46", Rh = "_out_q7p5n_50", Ph = "_isToday_q7p5n_52", Oh = "_dots_q7p5n_55", Xh = "_months_q7p5n_59", le = {
  mini: $h,
  nav: xh,
  navBtn: Dh,
  todayBtn: Ch,
  title: Sh,
  day: Ah,
  mon: Mh,
  grid: Bh,
  wdRow: jh,
  row: Th,
  sun: Lh,
  sat: qh,
  num: Ih,
  sel: Fh,
  out: Rh,
  isToday: Ph,
  dots: Oh,
  months: Xh
}, po = (e, n) => `${String(e).padStart(4, "0")}-${String(n).padStart(2, "0")}`;
function iN({
  month: e,
  onMonthChange: n,
  value: a,
  onPick: o,
  marks: r = {},
  markLabel: s,
  holidays: l = {},
  weekStartsOn: i = 0,
  locale: c = rr,
  today: u,
  children: m,
  className: d = "",
  "aria-label": _
}) {
  const p = u != null ? u : Zo(), f = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${p.slice(0, 7)}-01`, y = me(f), E = Yn(f, i), g = na(E, ve(E, 41)), w = s != null ? s : c.eventCount, [D, k] = A("day"), [b, $] = A(y.y), h = (L) => !!L && L.slice(0, 7) === f.slice(0, 7), [v, x] = A(() => h(a) ? a : h(p) ? p : f);
  Z(() => {
    h(v) || x(h(a) ? a : h(p) ? p : f);
  }, [f]);
  const C = I(!1), B = I(null);
  Z(() => {
    var L, F;
    C.current && (C.current = !1, (F = (L = B.current) == null ? void 0 : L.querySelector(`[data-day="${v}"]`)) == null || F.focus());
  }, [v, f]);
  const R = (L) => {
    C.current = !0, x(L), h(L) || n(L.slice(0, 7));
  }, P = (L) => {
    const F = Ct(y, L);
    n(po(F.y, F.m));
  }, G = (L, F) => {
    const oe = me(F), N = (Me(oe) - i + 7) % 7;
    let O = null;
    if (L.key === "ArrowLeft") O = ve(F, -1);
    else if (L.key === "ArrowRight") O = ve(F, 1);
    else if (L.key === "ArrowUp") O = ve(F, -7);
    else if (L.key === "ArrowDown") O = ve(F, 7);
    else if (L.key === "Home") O = ve(F, -N);
    else if (L.key === "End") O = ve(F, 6 - N);
    else if (L.key === "PageUp" || L.key === "PageDown") {
      const Y = Ct(oe, L.key === "PageUp" ? -1 : 1);
      O = Ge(Y.y, Y.m, Y.d);
    }
    O && (L.preventDefault(), R(O));
  }, q = () => {
    $(y.y), k("month");
  };
  return /* @__PURE__ */ t.createElement("div", { className: [le.mini, d].filter(Boolean).join(" "), role: _ ? "group" : void 0, "aria-label": _ }, D === "day" ? /* @__PURE__ */ t.createElement("div", { className: le.nav }, /* @__PURE__ */ t.createElement("button", { type: "button", className: le.navBtn, "aria-label": c.prevMonth, onClick: () => P(-1) }, "‹"), /* @__PURE__ */ t.createElement("button", { type: "button", className: le.title, "aria-label": `${c.ym(f)}, ${c.pickMonth}`, "aria-live": "polite", onClick: q }, c.ym(f)), /* @__PURE__ */ t.createElement("button", { type: "button", className: le.navBtn, "aria-label": c.nextMonth, onClick: () => P(1) }, "›"), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: le.todayBtn,
      disabled: h(p),
      onClick: () => {
        n(p.slice(0, 7)), R(p);
      }
    },
    c.today
  )) : /* @__PURE__ */ t.createElement("div", { className: le.nav }, /* @__PURE__ */ t.createElement("button", { type: "button", className: le.navBtn, "aria-label": c.prevYear, onClick: () => $((L) => L - 1) }, "‹"), /* @__PURE__ */ t.createElement("span", { className: le.title, "aria-live": "polite" }, c.year(`${b}-12-31`)), /* @__PURE__ */ t.createElement("button", { type: "button", className: le.navBtn, "aria-label": c.nextYear, onClick: () => $((L) => L + 1) }, "›"), /* @__PURE__ */ t.createElement("button", { type: "button", className: le.todayBtn, onClick: () => k("day"), "aria-label": c.close }, "✕")), D === "month" ? /* @__PURE__ */ t.createElement("div", { className: le.months, onKeyDown: (L) => {
    L.key === "Escape" && (L.preventDefault(), k("day"));
  } }, Array.from({ length: 12 }, (L, F) => {
    const oe = po(b, F + 1), N = oe === f.slice(0, 7);
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: oe,
        type: "button",
        className: [le.mon, N ? le.sel : "", oe === p.slice(0, 7) ? le.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": N,
        autoFocus: N,
        onClick: () => {
          n(oe), k("day");
        }
      },
      c.m(`${oe}-01`)
    );
  })) : /* @__PURE__ */ t.createElement("div", { className: le.grid, role: "grid", "aria-label": c.ym(f), ref: B }, /* @__PURE__ */ t.createElement("div", { className: le.wdRow, role: "row" }, g.slice(0, 7).map((L) => {
    const F = Me(me(L));
    return /* @__PURE__ */ t.createElement("span", { key: L, role: "columnheader", className: F === 0 ? le.sun : F === 6 ? le.sat : "" }, c.weekdays[F]);
  })), [0, 1, 2, 3, 4, 5].map((L) => /* @__PURE__ */ t.createElement("div", { key: L, className: le.row, role: "row" }, g.slice(L * 7, L * 7 + 7).map((F) => {
    var H;
    const oe = Me(me(F)), N = l[F], O = (H = r[F]) != null ? H : 0, Y = [
      le.day,
      h(F) ? "" : le.out,
      oe === 0 || N ? le.sun : oe === 6 ? le.sat : "",
      F === p ? le.isToday : "",
      F === a ? le.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: F,
        type: "button",
        role: "gridcell",
        "data-day": F,
        className: Y,
        tabIndex: F === v ? 0 : -1,
        "aria-selected": F === a,
        "aria-current": F === p ? "date" : void 0,
        "aria-label": [c.dayAria(F), N, O ? w(O) : ""].filter(Boolean).join(", "),
        onKeyDown: (ue) => G(ue, F),
        onFocus: () => x(F),
        onClick: () => o(F)
      },
      /* @__PURE__ */ t.createElement("span", { className: le.num }, +F.slice(8)),
      /* @__PURE__ */ t.createElement("span", { className: le.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(O, 3) }, (ue, j) => /* @__PURE__ */ t.createElement("i", { key: j })))
    );
  })))), m);
}
function Wh(e) {
  return e.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function zh(e) {
  return e.replace(/[０-９]/g, (n) => String.fromCharCode(n.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function ir(e, n = !0) {
  e = zh(e);
  const a = n && /^\s*-/.test(e), o = e.split(".", 1)[0].replace(/[^\d]/g, "");
  return o ? (a ? "-" : "") + o.replace(/^0+(?=\d)/, "") : a ? "-" : "";
}
function Kh(e) {
  var o;
  if (e == null || e === "") return "";
  const n = typeof e == "number" ? String(e) : e.trim(), a = /^(-?)(\d+)(\.\d+)?$/.exec(n);
  return a ? a[1] + Wh(a[2]) + ((o = a[3]) != null ? o : "") : n;
}
function Hh(e) {
  const n = ir(e);
  if (n === "" || n === "-") return;
  const a = Number(n);
  return Number.isFinite(a) ? a : void 0;
}
function Gh(e) {
  const n = e.match(/\d/g);
  return n ? n.length : 0;
}
function uN({
  value: e,
  onChangeAm: n,
  allowNegative: a = !0,
  className: o,
  ...r
}) {
  const s = I(null), l = I(null);
  return He(() => {
    const i = s.current, c = l.current;
    if (l.current = null, !i || c === null) return;
    let u = 0, m = 0;
    for (; u < i.value.length && m < c; )
      /\d/.test(i.value[u]) && (m += 1), u += 1;
    i.setSelectionRange(u, u);
  }), /* @__PURE__ */ t.createElement(
    "input",
    {
      ...r,
      ref: s,
      type: "text",
      inputMode: "numeric",
      className: o,
      value: Kh(e),
      onChange: (i) => {
        var m;
        const c = i.target;
        l.current = Gh(c.value.slice(0, (m = c.selectionStart) != null ? m : c.value.length));
        const u = ir(c.value, a);
        n({ text: u, num: Hh(u) });
      }
    }
  );
}
const Uh = "_box_996df_3", Yh = "_banner_996df_9", Vh = "_verify_996df_10", Jh = "_t_info_996df_15", Qh = "_t_warn_996df_16", Zh = "_t_danger_996df_17", eb = "_error_996df_22", tb = "_note_996df_30", nb = "_noteI_996df_42", ab = "_noteBody_996df_43", ob = "_badge_996df_49", rb = "_b_muted_996df_53", sb = "_b_ok_996df_54", lb = "_b_warn_996df_55", cb = "_b_info_996df_56", ib = "_b_off_996df_57", Xe = {
  box: Uh,
  banner: Yh,
  verify: Vh,
  t_info: Jh,
  t_warn: Qh,
  t_danger: Zh,
  error: eb,
  note: tb,
  noteI: nb,
  noteBody: ab,
  badge: ob,
  b_muted: rb,
  b_ok: sb,
  b_warn: lb,
  b_info: cb,
  b_off: ib
};
function mN({ tone: e = "warn", className: n = "", children: a }) {
  return /* @__PURE__ */ t.createElement("div", { className: [Xe.box, Xe.banner, Xe[`t_${e}`], n].filter(Boolean).join(" ") }, a);
}
function dN({ tone: e = "ok", className: n = "", children: a }) {
  const o = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ t.createElement("div", { className: [Xe.box, Xe.verify, Xe[`t_${o}`], n].filter(Boolean).join(" ") }, a);
}
function ur({ className: e = "", children: n }) {
  return n == null || n === !1 || n === "" ? null : /* @__PURE__ */ t.createElement("p", { className: [Xe.error, e].filter(Boolean).join(" "), role: "alert" }, typeof n == "string" ? /* @__PURE__ */ t.createElement(ub, { text: n }) : n);
}
function _N({ label: e = "안내", className: n = "", children: a }) {
  return /* @__PURE__ */ t.createElement("details", { className: [Xe.note, n].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("summary", null, /* @__PURE__ */ t.createElement("span", { className: Xe.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ t.createElement("div", { className: Xe.noteBody }, a));
}
function pN({ tone: e = "muted", className: n = "", children: a }) {
  return /* @__PURE__ */ t.createElement("span", { className: ["axe-badge", Xe.badge, Xe[`b_${e}`], n].filter(Boolean).join(" ") }, a);
}
function ub({ text: e }) {
  return e ? /* @__PURE__ */ t.createElement(t.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((n, a) => a % 2 ? /* @__PURE__ */ t.createElement("b", { key: a }, n) : /* @__PURE__ */ t.createElement(Lo, { key: a }, n))) : null;
}
const mb = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function db(e, n = mb) {
  const a = I(e);
  return a.current = e, Z(() => {
    if (!e) return;
    const o = (r) => {
      r.preventDefault(), r.returnValue = "";
    };
    return window.addEventListener("beforeunload", o), () => window.removeEventListener("beforeunload", o);
  }, [e]), se(() => !a.current || window.confirm(n), [n]);
}
const _b = "_overlay_1c9bs_2", pb = "_modal_1c9bs_7", fb = "_wide_1c9bs_14", yb = "_head_1c9bs_15", hb = "_title_1c9bs_19", bb = "_close_1c9bs_20", Eb = "_body_1c9bs_24", gb = "_flush_1c9bs_25", vb = "_error_1c9bs_26", kb = "_foot_1c9bs_28", Ze = {
  overlay: _b,
  modal: pb,
  wide: fb,
  head: yb,
  title: hb,
  close: bb,
  body: Eb,
  flush: gb,
  error: vb,
  foot: kb
}, Ft = [];
function fo(e) {
  const n = Ft[Ft.length - 1];
  e.key !== "Escape" || !n || !n.esc || (e.preventDefault(), n.close());
}
const wb = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function yo(e) {
  return Array.from(e.querySelectorAll(wb)).filter((n) => n.getClientRects().length > 0 && getComputedStyle(n).visibility !== "hidden");
}
let ho = 0, bo = "";
function mr({
  title: e,
  onClose: n,
  children: a,
  wide: o,
  footer: r,
  headerExtra: s,
  flush: l,
  closeOnBackdrop: i = !0,
  closeOnEsc: c = !1,
  error: u,
  confirmDiscard: m = !0
}) {
  const [d, _] = A(!1), p = m ? () => {
    d || _(!0);
  } : void 0, f = db(m && d, "입력한 내용을 저장하지 않고 닫을까요?"), y = () => {
    f() && n();
  }, E = I(y);
  E.current = y;
  const g = I({ close: () => E.current(), esc: c });
  g.current.esc = c, Z(() => {
    const b = g.current;
    return Ft.push(b), Ft.length === 1 && window.addEventListener("keydown", fo), () => {
      const $ = Ft.lastIndexOf(b);
      $ >= 0 && Ft.splice($, 1), Ft.length === 0 && window.removeEventListener("keydown", fo);
    };
  }, []);
  const w = I(null), D = I(null);
  Z(() => {
    const b = w.current, $ = document.activeElement;
    return b && !b.contains(document.activeElement) && (D.current && yo(D.current)[0] || null || b).focus(), ho++ === 0 && (bo = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --ho === 0 && (document.body.style.overflow = bo), $ && $.isConnected && typeof $.focus == "function" && $.focus();
    };
  }, []);
  const k = (b) => {
    const $ = w.current;
    if (b.key !== "Tab" || !$ || !$.contains(b.target)) return;
    const h = yo($);
    if (h.length === 0) {
      b.preventDefault(), $.focus();
      return;
    }
    const v = h[0], x = h[h.length - 1], C = document.activeElement;
    b.shiftKey && (C === v || C === $) ? (b.preventDefault(), x.focus()) : !b.shiftKey && C === x && (b.preventDefault(), v.focus());
  };
  return /* @__PURE__ */ t.createElement("div", { className: Ze.overlay, onClick: i ? y : void 0 }, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: w,
      tabIndex: -1,
      className: [Ze.modal, o ? Ze.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (b) => b.stopPropagation(),
      onKeyDown: k
    },
    /* @__PURE__ */ t.createElement("header", { className: Ze.head }, /* @__PURE__ */ t.createElement("strong", { className: Ze.title }, e), s, /* @__PURE__ */ t.createElement("button", { type: "button", className: Ze.close, onClick: y, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: D,
        className: [Ze.body, l ? Ze.flush : ""].filter(Boolean).join(" "),
        onInputCapture: p,
        onChangeCapture: p
      },
      a
    ),
    u != null && u !== !1 && u !== "" && /* @__PURE__ */ t.createElement("div", { className: Ze.error }, /* @__PURE__ */ t.createElement(ur, null, u)),
    r && /* @__PURE__ */ t.createElement("footer", { className: Ze.foot }, r)
  ));
}
function fN(e = 4e3) {
  const [n, a] = A(""), [o, r] = A(!1), s = I(void 0), l = se((u) => {
    window.clearTimeout(s.current), r(!1), a(u), s.current = window.setTimeout(() => a(""), e);
  }, [e]), i = se((u) => {
    window.clearTimeout(s.current), r(!0), a(u);
  }, []), c = se(() => {
    window.clearTimeout(s.current), r(!1), a("");
  }, []);
  return [n, l, i, o, c];
}
const Nb = "_message_psco6_1", $b = "_details_psco6_2", xb = "_warn_psco6_7", Db = "_field_psco6_8", Rn = {
  message: Nb,
  details: $b,
  warn: xb,
  field: Db
};
function yN() {
  var p, f;
  const [e, n] = A(null), [a, o] = A(""), r = I(null), s = I(null), l = I(null), i = se((y) => new Promise((E) => {
    n({ kind: "confirm", opts: y, resolve: E });
  }), []), c = se((y) => new Promise((E) => {
    var g, w, D, k;
    o((k = (D = y.defaultValue) != null ? D : (w = (g = y.choices) == null ? void 0 : g[0]) == null ? void 0 : w.value) != null ? k : ""), n({ kind: "prompt", opts: y, resolve: E });
  }), []);
  Z(() => {
    var y, E, g;
    e && (e.kind === "prompt" ? (y = l.current) == null || y.focus() : e.opts.danger || e.opts.focusCancel ? (E = s.current) == null || E.focus() : (g = r.current) == null || g.focus());
  }, [e]);
  const u = (y) => {
    e && (e.kind === "confirm" ? e.resolve(y) : e.resolve(y ? a : null), n(null));
  }, m = e == null ? void 0 : e.opts, d = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), _ = e && m ? /* @__PURE__ */ t.createElement(
    mr,
    {
      title: m.title,
      onClose: () => u(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(on, { ref: s, onClick: () => u(!1) }, (p = m.cancelLabel) != null ? p : "취소"), /* @__PURE__ */ t.createElement(
        on,
        {
          ref: r,
          variant: m.danger ? "danger" : "primary",
          disabled: d,
          onClick: () => u(!0)
        },
        (f = m.confirmLabel) != null ? f : "확인"
      ))
    },
    m.message && /* @__PURE__ */ t.createElement("div", { className: Rn.message }, m.message),
    m.details && m.details.length > 0 && /* @__PURE__ */ t.createElement("ul", { className: Rn.details }, m.details.map((y, E) => /* @__PURE__ */ t.createElement("li", { key: E }, y))),
    m.irreversible && /* @__PURE__ */ t.createElement("p", { className: Rn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ t.createElement("label", { className: Rn.field }, /* @__PURE__ */ t.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ t.createElement("select", { ref: l, value: a, onChange: (y) => o(y.target.value) }, e.opts.choices.map((y) => /* @__PURE__ */ t.createElement("option", { key: y.value, value: y.value }, y.label))) : /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (y) => o(y.target.value),
        onKeyDown: (y) => {
          y.key === "Enter" && !d && (y.preventDefault(), u(!0));
        }
      }
    ))
  ) : null;
  return { confirm: i, prompt: c, dialog: _ };
}
function hN(e, n) {
  const a = n ? `${n}에 실패했습니다 — ` : "", o = e > 0 ? ` (오류 ${e})` : "";
  return a + Cb(e) + o;
}
function Cb(e) {
  return e === 0 ? "서버에 연결하지 못했습니다. 네트워크 상태를 확인한 뒤 다시 시도하세요" : e === 400 || e === 422 ? "서버가 요청 내용을 받아들이지 않았습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 필요합니다. 다시 로그인해 주세요" : e === 403 ? "이 작업을 할 권한이 없습니다. 필요하면 관리자에게 권한을 요청하세요" : e === 404 ? "요청한 자료나 기능을 찾지 못했습니다. 화면을 새로고침한 뒤 다시 시도하고, 계속되면 관리자에게 알려 주세요" : e === 409 ? "다른 곳에서 먼저 바뀌었습니다. 다시 조회한 뒤 시도하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "서버에서 처리하지 못했습니다. 잠시 후 다시 시도하고, 계속되면 관리자에게 알려 주세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
const Sb = "_section_1qksw_3", Ab = "_row_1qksw_10", Mb = "_label_1qksw_15", Bb = "_value_1qksw_20", jb = "_invalid_1qksw_41", Tb = "_help_1qksw_43", Lb = "_err_1qksw_43", qb = "_req_1qksw_47", Ib = "_opt_1qksw_48", Fb = "_sr_1qksw_49", Rb = "_ro_1qksw_10", Pb = "_readonly_1qksw_56", Ob = "_hint_1qksw_63", Xb = "_toggle_1qksw_71", Wb = "_table_1qksw_78", zb = "_isReq_1qksw_93", $e = {
  section: Sb,
  row: Ab,
  label: Mb,
  value: Bb,
  invalid: jb,
  help: Tb,
  err: Lb,
  req: qb,
  opt: Ib,
  sr: Fb,
  ro: Rb,
  readonly: Pb,
  hint: Ob,
  toggle: Xb,
  table: Wb,
  isReq: zb
};
let Kb = 0;
const Hb = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function bN({
  label: e,
  children: n,
  hint: a,
  ro: o,
  htmlFor: r,
  required: s,
  optional: l,
  help: i,
  error: c,
  className: u = ""
}) {
  var D, k, b, $;
  const m = I(`axe-fr${++Kb}`).current, d = i ? `${m}-help` : void 0, _ = c ? `${m}-err` : void 0, p = [d, _].filter(Boolean).join(" ") || void 0, f = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let y = n;
  const E = ba.count(n) === 1 ? ba.toArray(n)[0] : null, g = Kn(E) && typeof E.type != "string" && !!E.type.axeFormControl;
  if (Kn(E) && (typeof E.type == "string" && Hb.has(E.type) || g)) {
    const h = E, v = h.props;
    y = Io(h, {
      id: (D = v.id) != null ? D : r,
      "aria-describedby": (k = v["aria-describedby"]) != null ? k : p,
      "aria-invalid": (b = v["aria-invalid"]) != null ? b : c ? !0 : void 0,
      "aria-required": ($ = v["aria-required"]) != null ? $ : s ? !0 : void 0
    });
  }
  const w = /* @__PURE__ */ t.createElement(t.Fragment, null, e, s && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: $e.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ t.createElement("span", { className: $e.sr }, "필수")), l && /* @__PURE__ */ t.createElement("span", { className: $e.opt }, "(선택)"));
  return /* @__PURE__ */ t.createElement("div", { className: ["axe-form-row", $e.row, o ? $e.ro : "", c ? $e.invalid : "", s ? $e.isReq : "", u].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("span", { className: `axe-form-label ${$e.label}` }, r ? /* @__PURE__ */ t.createElement("label", { htmlFor: r }, w) : w, a && /* @__PURE__ */ t.createElement(ea, { content: f, describe: !1 }, /* @__PURE__ */ t.createElement("span", { className: `axe-form-hint ${$e.hint}`, role: "img", "aria-label": `도움말: ${f}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ t.createElement("span", { className: `axe-form-value ${$e.value}` }, y, i && /* @__PURE__ */ t.createElement("span", { id: d, className: $e.help }, i), c && /* @__PURE__ */ t.createElement("span", { id: _, className: $e.err }, c)));
}
function EN({ title: e, children: n, className: a = "", variant: o = "stack" }) {
  return /* @__PURE__ */ t.createElement("section", { className: ["axe-form-section", o === "table" ? `axe-form-table ${$e.table}` : "", $e.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("h3", null, e), n);
}
function gN({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: $e.readonly }, e);
}
function vN({ checked: e, onChange: n, disabled: a, label: o, className: r = "" }) {
  return /* @__PURE__ */ t.createElement("label", { className: [$e.toggle, r].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (s) => n(s.target.checked) }), /* @__PURE__ */ t.createElement("span", null, o));
}
const Gb = "_mono_15nbe_2", Ub = "_invalid_15nbe_3", Yb = "_qty_15nbe_6", Vb = "_qtyInput_15nbe_7", Jb = "_unit_15nbe_8", Qb = "_note_15nbe_9", Rt = {
  mono: Gb,
  invalid: Ub,
  qty: Yb,
  qtyInput: Vb,
  unit: Jb,
  note: Qb
};
function Zb({
  value: e,
  onChange: n,
  disabled: a,
  maxLength: o,
  placeholder: r,
  mono: s,
  invalid: l,
  multiline: i,
  rows: c = 4,
  label: u,
  id: m,
  "aria-describedby": d,
  "aria-invalid": _,
  "aria-required": p,
  className: f = ""
}) {
  const y = [s ? Rt.mono : "", l ? Rt.invalid : "", f].filter(Boolean).join(" ") || void 0, E = {
    id: m,
    className: y,
    value: e != null ? e : "",
    maxLength: o,
    placeholder: r,
    disabled: a,
    "aria-label": u,
    "aria-describedby": d,
    "aria-invalid": _ != null ? _ : l || void 0,
    "aria-required": p,
    onChange: (g) => n(g.target.value === "" ? null : g.target.value)
  };
  return i ? /* @__PURE__ */ t.createElement("textarea", { ...E, rows: c }) : /* @__PURE__ */ t.createElement("input", { type: "text", ...E });
}
Zb.axeFormControl = !0;
function eE(e) {
  const {
    value: n,
    options: a,
    allLabel: o,
    disabled: r,
    label: s,
    id: l,
    "aria-describedby": i,
    "aria-invalid": c,
    "aria-required": u,
    className: m
  } = e, d = (p) => {
    e.codeType === "string" ? e.onChange(p === "" ? null : p) : e.onChange(p === "" ? null : Number(p));
  }, _ = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ t.createElement(
    "select",
    {
      id: l,
      className: m,
      value: n == null ? "" : String(n),
      disabled: r,
      "aria-label": s,
      "aria-describedby": i,
      "aria-invalid": c,
      "aria-required": u,
      onChange: (p) => d(p.target.value)
    },
    o != null && /* @__PURE__ */ t.createElement("option", { value: "" }, o),
    _.map(([p, f]) => /* @__PURE__ */ t.createElement("option", { key: p, value: String(p) }, f))
  );
}
eE.axeFormControl = !0;
function tE(e) {
  return e.replace(/[０-９]/g, (n) => String.fromCharCode(n.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const nE = /^-?(\d+\.?\d*|\.\d+)$/;
function En(e) {
  const n = tE(e).trim().replace(/,/g, "");
  if (n === "") return { kind: "empty" };
  if (n === "-" || n === "." || n === "-.") return { kind: "partial" };
  if (!nE.test(n)) return { kind: "bad" };
  const a = Number(n);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function Qn(e) {
  if (!Number.isFinite(e)) return 0;
  const n = Math.abs(e).toString(), a = n.indexOf("e-");
  if (a >= 0) {
    const r = n.slice(0, a), s = r.indexOf(".");
    return (s >= 0 ? r.length - s - 1 : 0) + Number(n.slice(a + 2));
  }
  const o = n.indexOf(".");
  return o >= 0 ? n.length - o - 1 : 0;
}
function dr(e, n) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(n));
  if (Qn(e) <= a) return e;
  const o = e < 0 ? -1 : 1, r = Math.abs(e).toFixed(Math.min(20, Qn(e))), s = Math.round(+`${r}e${a}`), l = o * +`${s}e-${a}`;
  return l === 0 ? 0 : l;
}
function en(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function aE(e, n, a) {
  return n != null && e < n || a != null && e > a;
}
function oE(e, n, a, o, r, s) {
  let l = e == null ? r != null ? r : 0 : dr(e + a * n, Math.max(o, Qn(n)));
  return r != null && l < r && (l = r), s != null && l > s && (l = s), l;
}
const rE = 2500;
function sE({
  value: e,
  onChange: n,
  decimals: a = 1,
  min: o,
  max: r,
  step: s,
  unit: l,
  disabled: i,
  label: c,
  id: u,
  "aria-describedby": m,
  "aria-invalid": d,
  "aria-required": _,
  width: p,
  onEnter: f,
  placeholder: y,
  className: E = ""
}) {
  const [g, w] = A(() => en(e)), [D, k] = A(!1), [b, $] = A(null), h = I(null), v = I(g);
  v.current = g, Z(() => {
    const q = En(v.current), L = q.kind === "num" ? q.value : q.kind === "empty" ? null : void 0;
    L !== void 0 && L === (e != null ? e : null) || w(en(e));
  }, [e]), Z(() => () => {
    h.current && clearTimeout(h.current);
  }, []);
  const x = (q) => {
    h.current && clearTimeout(h.current), $(q), h.current = setTimeout(() => $(null), rE);
  }, C = (q) => {
    w(q);
    const L = En(q);
    L.kind === "empty" ? n(null) : L.kind === "num" && n(L.value);
  }, B = () => {
    const q = En(g);
    if (q.kind !== "num") return;
    if (Qn(q.value) > a) {
      const F = dr(q.value, a);
      w(en(F)), n(F), x(`반올림했습니다 → ${en(F)}`);
      return;
    }
    const L = en(q.value);
    L !== g && w(L);
  }, R = (q) => {
    if (!q.nativeEvent.isComposing) {
      if (q.key === "Enter") {
        B(), f == null || f();
        return;
      }
      if (s && (q.key === "ArrowUp" || q.key === "ArrowDown")) {
        q.preventDefault();
        const L = En(g), F = L.kind === "num" ? L.value : L.kind === "empty" ? null : e, oe = oE(F, s, q.key === "ArrowUp" ? 1 : -1, a, o, r);
        w(en(oe)), n(oe);
      }
    }
  }, P = En(g), G = P.kind === "bad" || P.kind === "partial" && !D || P.kind === "num" && aE(P.value, o, r);
  return /* @__PURE__ */ t.createElement("span", { className: [Rt.qty, E].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: u,
      className: [Rt.qtyInput, G ? Rt.invalid : ""].filter(Boolean).join(" "),
      style: p != null ? { width: p, maxWidth: "none" } : void 0,
      value: g,
      placeholder: y,
      disabled: i,
      "aria-label": c,
      "aria-describedby": m,
      "aria-invalid": d != null ? d : G || void 0,
      "aria-required": _,
      onChange: (q) => C(q.target.value),
      onFocus: () => k(!0),
      onBlur: () => {
        k(!1), B();
      },
      onKeyDown: R
    }
  ), l && /* @__PURE__ */ t.createElement("span", { className: Rt.unit }, l), /* @__PURE__ */ t.createElement("span", { className: Rt.note, role: "status", "aria-live": "polite" }, b));
}
sE.axeFormControl = !0;
function lE(e, n) {
  if (e === n || e == null && n == null) return !0;
  if (e == null || n == null) return !1;
  if (typeof e == "object" && typeof n == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(n);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof n == "number" && Number.isNaN(e) && Number.isNaN(n);
}
function cE(e, n) {
  var r;
  if (e === n) return [];
  if (e === null || n === null) return e === null && n === null ? [] : Object.keys((r = e != null ? e : n) != null ? r : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(n)]), o = [];
  return a.forEach((s) => {
    lE(e[s], n[s]) || o.push(s);
  }), o;
}
function iE(e, n) {
  return e === null || n === null ? e === n : cE(e, n).length === 0;
}
function kN() {
  const [e, n] = A(null), [a, o] = A(!1), [r, s] = A(null), l = De(() => a || !iE(r, e), [a, r, e]), i = se((p) => {
    n((f) => f === null ? f : { ...f, ...p });
  }, []), c = se((p, f) => {
    n((y) => y === null ? y : { ...y, [p]: f });
  }, []), u = I(null), m = se((p) => {
    u.current = p, n(p), s(p), o(!1);
  }, []), d = se((p) => {
    u.current = p, n(p), s(p), o(!0);
  }, []), _ = se(() => n(u.current), []);
  return De(
    () => ({ draft: e, isNew: a, dirty: l, set: c, patch: i, load: m, start: d, reset: _, snapshot: r }),
    [e, a, l, c, i, m, d, _, r]
  );
}
function wN() {
  const e = I(!1), [n, a] = A(!1), o = se(async (r) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await r();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [n, o];
}
const uE = "_panel_1w7xx_2", mE = "_band_1w7xx_7", dE = "_chev_1w7xx_11", _E = "_title_1w7xx_17", pE = "_note_1w7xx_19", fE = "_chip_1w7xx_21", yE = "_other_1w7xx_32", hE = "_reset_1w7xx_33", bE = "_form_1w7xx_42", _t = {
  panel: uE,
  band: mE,
  chev: dE,
  title: _E,
  note: pE,
  chip: fE,
  other: yE,
  reset: hE,
  form: bE
};
function NN({
  chips: e,
  onReset: n,
  open: a,
  onToggle: o,
  toggleLabel: r = "상세검색",
  title: s = "적용된 조건",
  note: l,
  children: i,
  hideWhenEmpty: c,
  ariaLabel: u = "상세검색",
  className: m = ""
}) {
  const d = I(null);
  if (c && !a && e.length === 0) return null;
  const _ = (f, y = 0) => {
    var k, b, $;
    const E = (k = document.querySelector(`section[aria-label="${CSS.escape(u)}"]`)) != null ? k : d.current, g = E == null ? void 0 : E.querySelectorAll("button[data-chip-clear]"), w = ($ = g && ((b = g[f]) != null ? b : g[f - 1])) != null ? $ : E == null ? void 0 : E.querySelector("button[aria-expanded]"), D = !document.activeElement || document.activeElement === document.body;
    w && w !== document.activeElement && (y === 0 || D) && w.focus(), y < 4 && setTimeout(() => _(f, y + 1), 250);
  }, p = (f) => {
    e[f].onClear(), requestAnimationFrame(() => _(f));
  };
  return /* @__PURE__ */ t.createElement("section", { className: [_t.panel, m].filter(Boolean).join(" "), "aria-label": u }, /* @__PURE__ */ t.createElement("div", { className: _t.band, ref: d }, o && /* @__PURE__ */ t.createElement("button", { type: "button", className: _t.chev, "aria-expanded": !!a, onClick: o }, /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", r), s !== null && /* @__PURE__ */ t.createElement("span", { className: _t.title, "aria-live": "polite" }, s, " ", /* @__PURE__ */ t.createElement("b", null, e.length), "개"), e.map((f, y) => {
    var E;
    return /* @__PURE__ */ t.createElement("span", { key: f.key, className: [_t.chip, f.tone === "other" ? _t.other : ""].filter(Boolean).join(" ") }, f.text, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(E = f.label) != null ? E : typeof f.text == "string" ? f.text : "조건"} 해제`,
        onClick: () => p(y)
      },
      "✕"
    ));
  }), n && e.length > 0 && /* @__PURE__ */ t.createElement("button", { type: "button", className: _t.reset, onClick: () => {
    n(), requestAnimationFrame(() => _(0));
  } }, "초기화"), l && /* @__PURE__ */ t.createElement("span", { className: _t.note }, l)), a && i && /* @__PURE__ */ t.createElement("div", { className: _t.form }, i));
}
const EE = "_zone_1y6sp_2", gE = "_drag_1y6sp_8", vE = "_busy_1y6sp_9", kE = "_attached_1y6sp_10", wE = "_left_1y6sp_12", NE = "_icon_1y6sp_13", $E = "_title_1y6sp_18", xE = "_desc_1y6sp_19", DE = "_right_1y6sp_20", CE = "_count_1y6sp_21", SE = "_pick_1y6sp_22", ze = {
  zone: EE,
  drag: gE,
  busy: vE,
  attached: kE,
  left: wE,
  icon: NE,
  title: $E,
  desc: xE,
  right: DE,
  count: CE,
  pick: SE
};
function $N({
  onFiles: e,
  title: n = "파일 업로드",
  desc: a,
  countText: o,
  accept: r,
  multiple: s = !0,
  disabled: l,
  attached: i,
  pickLabel: c = "파일 선택",
  className: u = ""
}) {
  const m = I(null), [d, _] = A(!1), p = (f) => {
    !f || f.length === 0 || l || e(Array.from(f));
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [ze.zone, d ? ze.drag : "", l ? ze.busy : "", i ? ze.attached : "", u].filter(Boolean).join(" "),
      onClick: () => {
        var f;
        l || (f = m.current) == null || f.click();
      },
      onDragOver: (f) => {
        f.preventDefault(), l || _(!0);
      },
      onDragLeave: () => _(!1),
      onDrop: (f) => {
        f.preventDefault(), _(!1), p(f.dataTransfer.files);
      }
    },
    /* @__PURE__ */ t.createElement("div", { className: ze.left }, /* @__PURE__ */ t.createElement("div", { className: ze.icon, "aria-hidden": "true" }, /* @__PURE__ */ t.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ t.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ t.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ t.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: ze.title }, n), a && /* @__PURE__ */ t.createElement("div", { className: ze.desc }, a))),
    /* @__PURE__ */ t.createElement("div", { className: ze.right }, o && /* @__PURE__ */ t.createElement("span", { className: ze.count, "aria-live": "polite" }, o), /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: ze.pick,
        disabled: l,
        onClick: (f) => {
          var y;
          f.stopPropagation(), (y = m.current) == null || y.click();
        }
      },
      c
    ), /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: m,
        type: "file",
        accept: r,
        multiple: s,
        hidden: !0,
        onChange: (f) => {
          p(f.target.files), f.target.value = "";
        }
      }
    ))
  );
}
function AE(e, n) {
  var s, l;
  const a = (s = e.headers.get("Content-Disposition")) != null ? s : "", o = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (o)
    try {
      return decodeURIComponent(o[1]);
    } catch {
    }
  const r = /filename="?([^";]+)"?/i.exec(a);
  return (l = r == null ? void 0 : r[1]) != null ? l : n;
}
function _r(e, n) {
  const a = URL.createObjectURL(e), o = document.createElement("a");
  o.href = a, o.download = n, document.body.appendChild(o), o.click(), o.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function xN(e, n, a) {
  _r(await e.blob(), a != null ? a : AE(e, n));
}
const ME = /^([△▲\-−]?)\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, BE = /^\(\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function pr(e, n = {}) {
  var r, s;
  const a = e.trim();
  if (n.parenNegative) {
    const l = BE.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(r = l[2]) != null ? r : ""}`;
  }
  const o = ME.exec(a);
  return o ? (o[1] ? "-" : "") + o[2].replace(/,/g, "") + ((s = o[3]) != null ? s : "") : null;
}
function Sn(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function jE(e, n = {}) {
  const a = [];
  n.meta && n.meta.length && (n.meta.forEach((l) => a.push(l.map((i) => On(Sn(String(i != null ? i : "")))).join(","))), a.push(""));
  const o = a.length;
  let r = null;
  const s = (l) => {
    var c;
    const i = TE(l, e);
    !i || i === r || (r = i, a.length > o && a.push(""), a.push(On(Sn((c = i.getAttribute("data-csv-title")) != null ? c : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var u;
    if (l.tagName !== "TABLE") {
      if ((u = l.parentElement) != null && u.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const m = LE(l, n);
      if (!m) return;
      s(l), a.push(m.map(On).join(","));
      return;
    }
    const i = l;
    s(i);
    const c = [];
    Array.from(i.rows).forEach((m) => {
      if (m.hasAttribute("data-state") || m.getAttribute("aria-hidden") === "true") return;
      const d = [];
      let _ = 0;
      const p = () => {
        for (; c[_] && c[_].n > 0; )
          c[_].n -= 1, c[_].skip || d.push(""), _ += 1;
      };
      Array.from(m.cells).forEach((f) => {
        p();
        const y = IE(f), E = y ? "" : FE(f, n), g = Math.max(1, f.colSpan || 1), w = Math.max(1, f.rowSpan || 1);
        for (let D = 0; D < g; D += 1)
          y || d.push(D === 0 ? E : ""), c[_] = { n: w - 1, skip: y }, _ += 1;
      }), p(), d.some((f) => f !== "") && a.push(d.map(On).join(","));
    });
  }), a.join(`\r
`);
}
function TE(e, n) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === n) return null;
    a = a.parentElement;
  }
  return null;
}
function LE(e, n) {
  var u, m;
  const a = e.querySelector("[data-csv-k]"), o = e.querySelector("[data-csv-v]"), r = e.querySelector("[data-csv-unit]"), s = r ? Pn(r) : "";
  let i = ((u = e.getAttribute("data-csv-kv")) != null ? u : "") || (a ? Pn(a) : "");
  if (!i) return null;
  s && (i = `${i} (${s})`);
  let c;
  if (o) {
    const d = o.cloneNode(!0);
    d.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), c = Pn(d);
  } else {
    const d = e.cloneNode(!0);
    d.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((_) => _.remove()), c = Pn(d);
  }
  return (c === "—" || c === "-" || c === "–") && (c = ""), [Sn(i), (m = pr(c, n)) != null ? m : Sn(c)];
}
function Pn(e) {
  var n, a;
  return ((a = (n = e.innerText) != null ? n : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function qE(e, n) {
  const a = n.toLowerCase().endsWith(".csv") ? n : `${n}.csv`;
  _r(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function IE(e) {
  var n;
  return ((n = e.textContent) != null ? n : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function FE(e, n) {
  var r, s, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((i) => i.remove()), a.querySelectorAll("[data-csv-sep]").forEach((i) => i.after(" ")));
  let o = ((s = (r = a.innerText) != null ? r : a.textContent) != null ? s : "").replace(/\s+/g, " ").trim();
  if (!o) {
    const i = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    i && (o = i.value.trim());
  }
  return o === "—" || o === "-" || o === "–" ? "" : (l = pr(o, n)) != null ? l : Sn(o);
}
function On(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const RE = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function DN({ target: e, fileName: n, label: a = "CSV 내려받기", disabled: o, parenNegative: r, prepare: s, meta: l }) {
  return /* @__PURE__ */ t.createElement(
    ka,
    {
      label: a,
      disabled: o,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let i;
        s && (i = await s(), await RE());
        try {
          const c = e.current;
          if (!c) return;
          qE(jE(c, { parenNegative: r, meta: l == null ? void 0 : l() }), typeof n == "function" ? n() : n);
        } finally {
          typeof i == "function" && i();
        }
      }
    },
    /* @__PURE__ */ t.createElement(Hn, { name: "download", size: 14 }),
    "CSV"
  );
}
const PE = "_card_1adld_1", OE = "_sub_1adld_2", XE = "_state_1adld_3", WE = "_list_1adld_7", zE = "_row_1adld_8", KE = "_warn_1adld_20", HE = "_danger_1adld_21", Tt = {
  card: PE,
  sub: OE,
  state: XE,
  list: WE,
  row: zE,
  warn: KE,
  danger: HE
};
function CN({
  title: e,
  sub: n,
  trailing: a,
  state: o = "ready",
  error: r,
  onRetry: s,
  loadingText: l = "불러오는 중…",
  rows: i,
  className: c = ""
}) {
  return /* @__PURE__ */ t.createElement(
    Jo,
    {
      flush: !0,
      className: [Tt.card, c].filter(Boolean).join(" "),
      title: /* @__PURE__ */ t.createElement(t.Fragment, null, e, n ? /* @__PURE__ */ t.createElement("small", { className: Tt.sub }, n) : null),
      trailing: a
    },
    o === "loading" && /* @__PURE__ */ t.createElement("div", { className: Tt.state }, l),
    o === "error" && /* @__PURE__ */ t.createElement("div", { className: Tt.state }, /* @__PURE__ */ t.createElement(ur, null, r != null ? r : "불러오지 못했습니다"), s && /* @__PURE__ */ t.createElement(Ba, { onClick: s }, "다시 시도")),
    o === "ready" && /* @__PURE__ */ t.createElement("div", { className: Tt.list }, i.map((u, m) => {
      var p, f;
      const d = [Tt.row, u.tone ? Tt[u.tone] : ""].filter(Boolean).join(" "), _ = /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", null, u.label), /* @__PURE__ */ t.createElement("strong", null, u.value, u.unit ? /* @__PURE__ */ t.createElement("small", null, u.unit) : null));
      return u.onClick ? /* @__PURE__ */ t.createElement("button", { type: "button", key: (p = u.key) != null ? p : m, className: d, onClick: u.onClick }, _) : /* @__PURE__ */ t.createElement("div", { key: (f = u.key) != null ? f : m, className: d }, _);
    }))
  );
}
function GE(e, n, a, o, r) {
  const s = Math.max(0, Math.floor(e));
  if (s === 0) return 1;
  const l = Math.max(1, Math.min(s, r != null && r > 0 ? Math.floor(r) : s)), i = Math.max(1, Math.min(l, Math.floor((n + o) / (a + o)))), c = Math.ceil(s / i);
  return Math.ceil(s / c);
}
const UE = "_group_1i1dn_1", YE = "_tile_1i1dn_2", VE = "_click_1i1dn_8", JE = "_ok_1i1dn_11", QE = "_warn_1i1dn_12", ZE = "_danger_1i1dn_13", eg = "_info_1i1dn_14", tg = "_accent_1i1dn_15", ng = "_muted_1i1dn_16", ag = "_label_1i1dn_17", og = "_value_1i1dn_19", rg = "_desc_1i1dn_21", qt = {
  group: UE,
  tile: YE,
  click: VE,
  ok: JE,
  warn: QE,
  danger: ZE,
  info: eg,
  accent: tg,
  muted: ng,
  label: ag,
  value: og,
  desc: rg
};
function SN({
  label: e,
  value: n,
  unit: a,
  desc: o,
  tone: r = "info",
  onClick: s,
  className: l = ""
}) {
  const i = [qt.tile, qt[r], s ? qt.click : "", l].filter(Boolean).join(" "), c = /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: qt.label, "data-csv-k": "" }, /* @__PURE__ */ t.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ t.createElement("span", { className: qt.value, "data-csv-v": "" }, n, a ? /* @__PURE__ */ t.createElement("small", { "data-csv-unit": "" }, a) : null), o ? /* @__PURE__ */ t.createElement("span", { className: qt.desc }, o) : null);
  return s ? /* @__PURE__ */ t.createElement("button", { type: "button", className: i, onClick: s, "data-csv-kv": "" }, c) : /* @__PURE__ */ t.createElement("div", { className: i, "data-csv-kv": "" }, c);
}
const sg = 150, lg = 12, cg = 8;
function AN({ children: e, columns: n, className: a = "" }) {
  const o = I(null), r = ba.toArray(e).filter(Kn).length, s = n != null || r <= cg, [l, i] = A(null);
  He(() => {
    const m = o.current;
    if (!s || !m || (i(m.clientWidth), typeof ResizeObserver == "undefined")) return;
    const d = new ResizeObserver(() => i(m.clientWidth));
    return d.observe(m), () => d.disconnect();
  }, [s]);
  const c = s ? GE(r, l != null ? l : Number.MAX_SAFE_INTEGER, sg, lg, n) : 0, u = s ? { gridTemplateColumns: `repeat(${c}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ t.createElement("div", { ref: o, className: [qt.group, a].filter(Boolean).join(" "), style: u }, e);
}
const ig = "_card_1lav2_1", ug = "_n_1lav2_2", mg = "_list_1lav2_7", dg = "_row_1lav2_8", _g = "_go_1lav2_15", pg = "_name_1lav2_16", fg = "_empty_1lav2_17", yg = "_star_1lav2_18", hg = "_clear_1lav2_27", et = {
  card: ig,
  n: ug,
  list: mg,
  row: dg,
  go: _g,
  name: pg,
  empty: fg,
  star: yg,
  clear: hg
};
function MN({
  mine: e,
  recent: n,
  onOpen: a,
  onClearRecent: o,
  mineHint: r = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: s = ""
}) {
  const [l, i] = A("mine"), c = l === "mine" ? e : n;
  return /* @__PURE__ */ t.createElement(
    Jo,
    {
      flush: !0,
      className: [et.card, s].filter(Boolean).join(" "),
      title: /* @__PURE__ */ t.createElement(
        Yo,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: l,
          onChange: (u) => i(u),
          items: [
            { key: "mine", label: /* @__PURE__ */ t.createElement(t.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ t.createElement("em", { className: et.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ t.createElement(t.Fragment, null, "최근 사용", n.length > 0 && /* @__PURE__ */ t.createElement("em", { className: et.n }, n.length)) }
          ]
        }
      ),
      trailing: l === "recent" && n.length > 0 && o ? /* @__PURE__ */ t.createElement(Ba, { className: et.clear, onClick: o }, "지우기") : void 0
    },
    c.length > 0 ? /* @__PURE__ */ t.createElement("ul", { className: et.list }, c.map((u) => /* @__PURE__ */ t.createElement("li", { key: u.path }, /* @__PURE__ */ t.createElement("button", { type: "button", className: et.row, onClick: () => a(u) }, /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true", className: et.go }, "↗"), /* @__PURE__ */ t.createElement("span", { className: et.name }, u.label))))) : /* @__PURE__ */ t.createElement("div", { className: et.empty }, /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true", className: et.star }, "★"), /* @__PURE__ */ t.createElement("strong", null, l === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ t.createElement("p", null, l === "mine" ? r : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function Eo(e) {
  var n;
  try {
    const a = JSON.parse((n = window.localStorage.getItem(e)) != null ? n : "[]");
    return Array.isArray(a) ? a.filter((o) => o && typeof o.path == "string" && typeof o.label == "string") : [];
  } catch {
    return [];
  }
}
function _a(e, n) {
  try {
    window.localStorage.setItem(e, JSON.stringify(n));
  } catch {
  }
}
function BN({ mineKey: e, recentKey: n, recentMax: a = 6 }) {
  const [o, r] = A(() => Eo(e)), [s, l] = A(() => Eo(n)), i = se((d) => o.some((_) => _.path === d), [o]), c = se((d) => r((_) => {
    const p = _.some((f) => f.path === d.path) ? _.filter((f) => f.path !== d.path) : [..._, d];
    return _a(e, p), p;
  }), [e]), u = se((d) => l((_) => {
    const p = [d, ..._.filter((f) => f.path !== d.path)].slice(0, a);
    return _a(n, p), p;
  }), [n, a]), m = se(() => {
    l([]), _a(n, []);
  }, [n]);
  return { mine: o, recent: s, isMine: i, toggleMine: c, remember: u, clearRecent: m };
}
const bg = "_banner_7tqhk_2", Eg = "_heading_7tqhk_7", gg = "_sparkleBox_7tqhk_8", vg = "_eyebrow_7tqhk_12", kg = "_headline_7tqhk_13", wg = "_desc_7tqhk_15", Ng = "_err_7tqhk_16", $g = "_chips_7tqhk_18", xg = "_footer_7tqhk_28", Dg = "_kicker_7tqhk_35", Cg = "_list_7tqhk_36", Sg = "_row_7tqhk_37", Ag = "_icon_7tqhk_39", Mg = "_text_7tqhk_40", Bg = "_cap_7tqhk_41", jg = "_body_7tqhk_43", Tg = "_reason_7tqhk_44", Lg = "_empty_7tqhk_45", he = {
  banner: bg,
  heading: Eg,
  sparkleBox: gg,
  eyebrow: vg,
  headline: kg,
  desc: wg,
  err: Ng,
  chips: $g,
  footer: xg,
  kicker: Dg,
  list: Cg,
  row: Sg,
  icon: Ag,
  text: Mg,
  cap: Bg,
  body: jg,
  reason: Tg,
  empty: Lg
};
function go({ size: e = 18 }) {
  return /* @__PURE__ */ t.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ t.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function jN({
  eyebrow: e,
  headline: n,
  desc: a,
  error: o,
  groups: r,
  maxChips: s = 4,
  onOpen: l,
  note: i,
  noteError: c,
  allLabel: u = "전체 업무 제안 보기",
  allDisabled: m,
  className: d = ""
}) {
  const _ = r.slice(0, s), p = r.length - _.length;
  return /* @__PURE__ */ t.createElement("section", { className: [he.banner, d].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: he.heading }, /* @__PURE__ */ t.createElement("span", { className: he.sparkleBox }, /* @__PURE__ */ t.createElement(go, { size: 22 })), /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: he.eyebrow }, /* @__PURE__ */ t.createElement(go, { size: 11 }), " ", e), /* @__PURE__ */ t.createElement("h2", { className: he.headline }, n), a ? /* @__PURE__ */ t.createElement("p", { className: [he.desc, o ? he.err : ""].filter(Boolean).join(" ") }, a) : null)), r.length > 0 && /* @__PURE__ */ t.createElement("div", { className: he.chips }, _.map((f) => /* @__PURE__ */ t.createElement("button", { type: "button", key: f.key, title: f.label, onClick: () => l(f.key) }, /* @__PURE__ */ t.createElement("i", { style: f.color ? { background: f.color } : void 0, "aria-hidden": "true" }), f.label, " ", /* @__PURE__ */ t.createElement("strong", { style: f.color ? { color: f.color } : void 0 }, f.count, "건"))), p > 0 && /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => l(null) }, "+", p, "종류 더")), /* @__PURE__ */ t.createElement("div", { className: he.footer }, /* @__PURE__ */ t.createElement(
    "span",
    {
      className: c ? he.err : void 0,
      role: c ? "alert" : void 0
    },
    i
  ), /* @__PURE__ */ t.createElement(Ba, { onClick: () => l(null), disabled: m }, u, " ", /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function qg({ items: e, onRun: n, onSkip: a, busy: o, emptyText: r = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ t.createElement("div", { className: he.empty }, r) : /* @__PURE__ */ t.createElement("ul", { className: he.list }, e.map((s) => {
    var l, i;
    return /* @__PURE__ */ t.createElement("li", { key: s.id, className: he.row }, /* @__PURE__ */ t.createElement("span", { className: he.icon, "aria-hidden": "true" }, (l = s.icon) != null ? l : "💡"), /* @__PURE__ */ t.createElement("div", { className: he.text }, /* @__PURE__ */ t.createElement("div", { className: he.cap }, s.title, s.meta ? /* @__PURE__ */ t.createElement("small", null, " · ", s.meta) : null), /* @__PURE__ */ t.createElement("div", { className: he.body }, s.body), s.reason ? /* @__PURE__ */ t.createElement("div", { className: he.reason }, s.reason) : null), /* @__PURE__ */ t.createElement(on, { variant: "primary", disabled: o, onClick: () => n(s) }, (i = s.actionLabel) != null ? i : "실행"), /* @__PURE__ */ t.createElement(on, { disabled: o, onClick: () => a(s) }, "무시"));
  }));
}
function TN({ title: e, kicker: n = "ProActive AI 업무 제안", items: a, onClose: o, onRun: r, onSkip: s }) {
  const l = I(!1), [i, c] = A(!1), [u, m] = A(""), d = async (_) => {
    if (!l.current) {
      l.current = !0, c(!0), m("");
      try {
        await _();
      } catch (p) {
        m(p instanceof Error ? p.message : "처리에 실패했습니다");
      } finally {
        l.current = !1, c(!1);
      }
    }
  };
  return /* @__PURE__ */ t.createElement(
    mr,
    {
      title: e,
      onClose: o,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ t.createElement("span", { className: he.kicker }, "✦ ", n),
      error: u,
      footer: /* @__PURE__ */ t.createElement(on, { onClick: o }, "닫기")
    },
    /* @__PURE__ */ t.createElement(qg, { items: a, busy: i, onRun: (_) => d(() => r(_)), onSkip: (_) => d(() => s(_)) })
  );
}
const Ig = "_wrap_1wvdc_2", Fg = "_header_1wvdc_7", Rg = "_iconBox_1wvdc_8", Pg = "_headText_1wvdc_12", Og = "_eyebrow_1wvdc_13", Xg = "_headline_1wvdc_14", Wg = "_headerExtra_1wvdc_16", zg = "_grid_1wvdc_19", Kg = "_card_1wvdc_20", Hg = "_badge_1wvdc_29", Gg = "_toneRed_1wvdc_33", Ug = "_toneViolet_1wvdc_34", Yg = "_toneGreen_1wvdc_35", Vg = "_toneBlue_1wvdc_36", Jg = "_title_1wvdc_38", Qg = "_summary_1wvdc_42", Zg = "_action_1wvdc_46", ev = "_notice_1wvdc_53", tv = "_err_1wvdc_56", fe = {
  wrap: Ig,
  header: Fg,
  iconBox: Rg,
  headText: Pg,
  eyebrow: Og,
  headline: Xg,
  headerExtra: Wg,
  grid: zg,
  card: Kg,
  badge: Hg,
  toneRed: Gg,
  toneViolet: Ug,
  toneGreen: Yg,
  toneBlue: Vg,
  title: Jg,
  summary: Qg,
  action: Zg,
  notice: ev,
  err: tv
};
function vo({ size: e = 16 }) {
  return /* @__PURE__ */ t.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ t.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const nv = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function LN({
  items: e,
  onOpen: n,
  eyebrow: a = "PROACTIVE AI",
  headline: o = "지금 처리할 수 있는 업무를 발견했습니다",
  error: r,
  loading: s,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: i,
  className: c = ""
}) {
  return /* @__PURE__ */ t.createElement("section", { className: [fe.wrap, c].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: fe.header }, /* @__PURE__ */ t.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ t.createElement(vo, { size: 18 })), /* @__PURE__ */ t.createElement("div", { className: fe.headText }, /* @__PURE__ */ t.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ t.createElement("h2", { className: fe.headline }, o)), i ? /* @__PURE__ */ t.createElement("div", { className: fe.headerExtra }, i) : null), r ? /* @__PURE__ */ t.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, r) : null, e.length === 0 ? r ? null : s ? /* @__PURE__ */ t.createElement("div", { className: fe.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ t.createElement("div", { className: fe.notice }, l) : /* @__PURE__ */ t.createElement("div", { className: fe.grid }, e.map((u) => {
    var m, d;
    return /* @__PURE__ */ t.createElement("button", { type: "button", key: u.id, className: fe.card, onClick: () => n(u) }, /* @__PURE__ */ t.createElement("span", { className: [fe.badge, nv[(m = u.tone) != null ? m : "violet"]].join(" ") }, /* @__PURE__ */ t.createElement(vo, { size: 9 }), u.badge), /* @__PURE__ */ t.createElement("span", { className: fe.title }, u.title), u.summary ? /* @__PURE__ */ t.createElement("span", { className: fe.summary, title: typeof u.summary == "string" ? u.summary : void 0 }, u.summary) : null, /* @__PURE__ */ t.createElement("span", { className: fe.action }, (d = u.actionLabel) != null ? d : "상세 보기", " ", /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const av = "_screen_1bsma_1", ov = "_shell_1bsma_8", rv = "_command_1bsma_10", sv = "_body_1bsma_20", lv = "_overview_1bsma_22", cv = "_areaHead_1bsma_25", nn = {
  screen: av,
  shell: ov,
  command: rv,
  body: sv,
  overview: lv,
  areaHead: cv
};
function qN({ search: e, panel: n, children: a, className: o = "" }) {
  var r;
  return /* @__PURE__ */ t.createElement("main", { className: [nn.screen, o].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: nn.shell }, e && /* @__PURE__ */ t.createElement("div", { className: nn.command }, /* @__PURE__ */ t.createElement(
    xu,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (r = e.hint) != null ? r : /* @__PURE__ */ t.createElement("kbd", null, "F10")
    }
  ), n), /* @__PURE__ */ t.createElement("div", { className: nn.body }, a)));
}
function IN({ children: e, className: n = "" }) {
  return /* @__PURE__ */ t.createElement("div", { className: [nn.overview, n].filter(Boolean).join(" ") }, e);
}
function FN({ title: e, hint: n }) {
  return /* @__PURE__ */ t.createElement("div", { className: nn.areaHead }, /* @__PURE__ */ t.createElement("h2", null, e), n && /* @__PURE__ */ t.createElement("span", null, n));
}
const iv = "_group_oodts_1", uv = "_grid_oodts_7", mv = "_row_oodts_8", dv = "_item_oodts_9", _v = "_launch_oodts_14", pv = "_name_oodts_17", fv = "_desc_oodts_18", yv = "_badge_oodts_19", hv = "_disabled_oodts_23", bv = "_tab_oodts_25", Ev = "_star_oodts_25", gv = "_on_oodts_30", vv = "_empty_oodts_32", qe = {
  group: iv,
  grid: uv,
  row: mv,
  item: dv,
  launch: _v,
  name: pv,
  desc: fv,
  badge: yv,
  disabled: hv,
  tab: bv,
  star: Ev,
  on: gv,
  empty: vv
};
function kv() {
  return /* @__PURE__ */ t.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ t.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function wv() {
  return /* @__PURE__ */ t.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function RN({ title: e, items: n, emptyText: a, className: o = "" }) {
  return /* @__PURE__ */ t.createElement("section", { className: [qe.group, o].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("h3", null, e), /* @__PURE__ */ t.createElement("div", { className: qe.grid }, n.map((r) => /* @__PURE__ */ t.createElement("div", { className: qe.row, key: r.key }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [qe.item, r.disabled ? qe.disabled : ""].filter(Boolean).join(" "),
      disabled: r.disabled,
      onClick: r.onOpen
    },
    /* @__PURE__ */ t.createElement("span", { className: qe.launch }, /* @__PURE__ */ t.createElement(kv, null)),
    /* @__PURE__ */ t.createElement("span", { className: qe.name }, r.label),
    r.desc && /* @__PURE__ */ t.createElement("span", { className: qe.desc }, r.desc),
    r.badge != null && /* @__PURE__ */ t.createElement("em", { className: qe.badge }, r.badge)
  ), r.onOpenNewTab && !r.disabled && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: qe.tab,
      "aria-label": `${r.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: r.onOpenNewTab
    },
    /* @__PURE__ */ t.createElement(wv, null)
  ), r.onToggleStar && !r.disabled && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [qe.star, r.starred ? qe.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!r.starred,
      "aria-label": `${r.label} ${r.starred ? "마이메뉴에서 빼기" : "마이메뉴에 담기"}`,
      onClick: r.onToggleStar
    },
    r.starred ? "★" : "☆"
  ))), n.length === 0 && a != null && /* @__PURE__ */ t.createElement("p", { className: qe.empty }, a)));
}
const Nv = "_strip_vrxvn_2", $v = "_day_vrxvn_9", xv = "_total_vrxvn_10", Dv = "_sel_vrxvn_31", Cv = "_today_vrxvn_35", Sv = "_md_vrxvn_35", Av = "_off_vrxvn_36", Mv = "_head_vrxvn_45", Bv = "_wd_vrxvn_46", jv = "_sun_vrxvn_47", Tv = "_sat_vrxvn_48", Lv = "_lock_vrxvn_50", qv = "_value_vrxvn_60", Iv = "_mark_vrxvn_66", Fv = "_warn_vrxvn_67", Rv = "_danger_vrxvn_68", Pv = "_info_vrxvn_69", ke = {
  strip: Nv,
  day: $v,
  total: xv,
  sel: Dv,
  today: Cv,
  md: Sv,
  off: Av,
  head: Mv,
  wd: Bv,
  sun: jv,
  sat: Tv,
  lock: Lv,
  value: qv,
  mark: Iv,
  warn: Fv,
  danger: Rv,
  info: Pv
}, ko = ["일", "월", "화", "수", "목", "금", "토"];
function Ov(e) {
  const [n, a, o] = e.split("-").map(Number), r = new Date(n, a - 1, o).getDay();
  return { md: `${a}/${o}`, wd: r };
}
function PN({
  days: e,
  selected: n,
  today: a,
  onSelect: o,
  total: r,
  totalLabel: s = "합계",
  "aria-label": l,
  className: i
}) {
  const c = I([]), u = (_) => {
    var f;
    const p = e.length;
    for (let y = 0; y < p; y++) {
      const E = (_ + y + p) % p;
      if (!e[E].disabled) {
        (f = c.current[E]) == null || f.focus();
        return;
      }
    }
  }, m = (_, p) => {
    _.key === "ArrowRight" ? (_.preventDefault(), u(p + 1)) : _.key === "ArrowLeft" ? (_.preventDefault(), u(p - 1)) : _.key === "Home" ? (_.preventDefault(), u(0)) : _.key === "End" && (_.preventDefault(), u(e.length - 1));
  }, d = Math.max(0, e.findIndex((_) => _.date === n));
  return /* @__PURE__ */ t.createElement("div", { className: `${ke.strip}${i ? ` ${i}` : ""}`, role: "group", "aria-label": l }, e.map((_, p) => {
    var w, D, k, b;
    const { md: f, wd: y } = Ov(_.date), E = [
      ke.day,
      _.off ? ke.off : "",
      _.date === n ? ke.sel : "",
      _.date === a ? ke.today : "",
      y === 0 ? ke.sun : y === 6 ? ke.sat : ""
    ].filter(Boolean).join(" "), g = [`${f}(${ko[y]})`, _.offLabel, _.locked ? "잠김" : null, (w = _.mark) == null ? void 0 : w.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: _.date,
        ref: ($) => {
          c.current[p] = $;
        },
        type: "button",
        className: E,
        disabled: _.disabled,
        tabIndex: p === d ? 0 : -1,
        "aria-pressed": _.date === n,
        "aria-label": g,
        title: g,
        onClick: () => o == null ? void 0 : o(_.date),
        onKeyDown: ($) => m($, p)
      },
      /* @__PURE__ */ t.createElement("span", { className: ke.head }, /* @__PURE__ */ t.createElement("span", { className: ke.wd }, ko[y]), /* @__PURE__ */ t.createElement("span", { className: ke.md }, f), _.locked && /* @__PURE__ */ t.createElement("span", { className: ke.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ t.createElement("span", { className: ke.value }, _.value),
      /* @__PURE__ */ t.createElement("span", { className: `${ke.mark}${_.mark ? ` ${ke[_.mark.tone]}` : ""}` }, (b = (D = _.mark) == null ? void 0 : D.text) != null ? b : _.off && (k = _.offLabel) != null ? k : "")
    );
  }), r !== void 0 && /* @__PURE__ */ t.createElement("div", { className: ke.total }, /* @__PURE__ */ t.createElement("span", { className: ke.wd }, s), /* @__PURE__ */ t.createElement("span", { className: ke.value }, r)));
}
const Xv = "_stepper_1wbt2_1", Wv = "_nav_1wbt2_2", zv = "_today_1wbt2_3", Kv = "_range_1wbt2_14", gn = {
  stepper: Xv,
  nav: Wv,
  today: zv,
  range: Kv
};
function fr(e) {
  const [n, a, o] = e.split("-").map(Number);
  return new Date(Date.UTC(n, a - 1, o));
}
function yr(e) {
  return e.toISOString().slice(0, 10);
}
function Hv(e) {
  const n = e.getUTCDay();
  return n === 0 ? 7 : n;
}
function Gv(e, n = 1) {
  const a = fr(e), o = (Hv(a) - n + 7) % 7;
  return a.setUTCDate(a.getUTCDate() - o), yr(a);
}
function pa(e, n) {
  const a = fr(e);
  return a.setUTCDate(a.getUTCDate() + n), yr(a);
}
function ON({ value: e, onChange: n, weekStart: a = 1, today: o, disabled: r, label: s = "주" }) {
  const l = pa(e, 6), i = Gv(o, a), c = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ t.createElement("span", { className: gn.stepper, role: "group", "aria-label": s }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: gn.nav,
      onClick: () => n(pa(e, -7)),
      disabled: r,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ t.createElement("span", { className: gn.range, "aria-live": "polite" }, e, " ~ ", c), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: gn.nav,
      onClick: () => n(pa(e, 7)),
      disabled: r,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: gn.today,
      onClick: () => n(i),
      disabled: r || e === i
    },
    "이번 주"
  ));
}
const Uv = "_wrap_1fk95_1", Yv = "_svg_1fk95_2", Vv = "_grid_1fk95_3", Jv = "_axis_1fk95_4", Qv = "_accent_1fk95_5", Zv = "_muted_1fk95_6", e0 = "_ok_1fk95_7", t0 = "_warn_1fk95_8", n0 = "_danger_1fk95_9", a0 = "_legend_1fk95_10", o0 = "_dot_accent_1fk95_13", r0 = "_dot_muted_1fk95_14", s0 = "_dot_ok_1fk95_15", l0 = "_dot_warn_1fk95_16", c0 = "_dot_danger_1fk95_17", xt = {
  wrap: Uv,
  svg: Yv,
  grid: Vv,
  axis: Jv,
  accent: Qv,
  muted: Zv,
  ok: e0,
  warn: t0,
  danger: n0,
  legend: a0,
  dot_accent: o0,
  dot_muted: r0,
  dot_ok: s0,
  dot_warn: l0,
  dot_danger: c0
}, i0 = 600;
function u0(e) {
  if (e <= 0) return 1;
  const n = Math.pow(10, Math.floor(Math.log10(e))), a = e / n;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * n;
}
const wo = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function XN({ categories: e, series: n, unit: a = "", height: o = 180, label: r, labelEvery: s }) {
  const l = I(null), [i, c] = A(i0);
  He(() => {
    const h = l.current;
    if (!h) return;
    const v = () => {
      const C = h.clientWidth;
      C > 0 && c((B) => B === C ? B : C);
    };
    if (v(), typeof ResizeObserver == "undefined") return;
    const x = new ResizeObserver(v);
    return x.observe(h), () => x.disconnect();
  }, []);
  const u = o, m = 40, d = 22, _ = 8, p = i - m - 4, f = u - d - _, y = n.flatMap((h) => h.values.filter((v) => v != null)), E = u0(Math.max(0, ...y)), g = Math.max(e.length, 1), w = p / g, D = Math.min(8, w * 0.2), k = Math.max(1, (w - D) / Math.max(n.length, 1)), b = s != null ? s : Math.max(1, Math.ceil(g / 8)), $ = [0, E / 2, E];
  return /* @__PURE__ */ t.createElement("div", { className: xt.wrap, ref: l }, /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: xt.svg,
      viewBox: `0 0 ${i} ${u}`,
      role: "img",
      "aria-label": r,
      style: { height: o }
    },
    $.map((h) => {
      const v = _ + f - h / E * f;
      return /* @__PURE__ */ t.createElement("g", { key: h }, /* @__PURE__ */ t.createElement("line", { className: xt.grid, x1: m, x2: i - 4, y1: v, y2: v }), /* @__PURE__ */ t.createElement("text", { className: xt.axis, x: m - 4, y: v + 3, textAnchor: "end" }, wo(h)));
    }),
    e.map((h, v) => /* @__PURE__ */ t.createElement("g", { key: h }, n.map((x, C) => {
      var P;
      const B = x.values[v];
      if (B == null || B <= 0) return null;
      const R = B / E * f;
      return /* @__PURE__ */ t.createElement(
        "rect",
        {
          key: x.key,
          className: xt[(P = x.tone) != null ? P : "accent"],
          x: m + v * w + D / 2 + C * k,
          y: _ + f - R,
          width: k,
          height: R
        },
        /* @__PURE__ */ t.createElement("title", null, `${h} · ${x.label} ${wo(B)}${a}`)
      );
    }), v % b === 0 && /* @__PURE__ */ t.createElement("text", { className: xt.axis, x: m + v * w + w / 2, y: u - 6, textAnchor: "middle" }, h)))
  ), /* @__PURE__ */ t.createElement("ul", { className: xt.legend }, n.map((h) => {
    var v;
    return /* @__PURE__ */ t.createElement("li", { key: h.key }, /* @__PURE__ */ t.createElement("i", { className: xt[`dot_${(v = h.tone) != null ? v : "accent"}`], "aria-hidden": "true" }), h.label, a ? ` (${a})` : "");
  })));
}
const m0 = "_wrap_85lir_1", d0 = "_track_85lir_2", _0 = "_accent_85lir_3", p0 = "_muted_85lir_3", f0 = "_ok_85lir_3", y0 = "_warn_85lir_3", h0 = "_danger_85lir_3", b0 = "_center_85lir_9", E0 = "_legend_85lir_10", g0 = "_name_85lir_13", v0 = "_val_85lir_14", k0 = "_pct_85lir_15", w0 = "_dot_accent_85lir_16", N0 = "_dot_muted_85lir_17", $0 = "_dot_ok_85lir_18", x0 = "_dot_warn_85lir_19", D0 = "_dot_danger_85lir_20", pt = {
  wrap: m0,
  track: d0,
  accent: _0,
  muted: p0,
  ok: f0,
  warn: y0,
  danger: h0,
  center: b0,
  legend: E0,
  name: g0,
  val: v0,
  pct: k0,
  dot_accent: w0,
  dot_muted: N0,
  dot_ok: $0,
  dot_warn: x0,
  dot_danger: D0
}, $a = 40, No = 2 * Math.PI * $a;
function WN({ items: e, center: n, size: a = 120, label: o, emptyText: r = "자료 없음", unit: s = "" }) {
  const l = e.reduce((c, u) => c + Math.max(0, u.value), 0);
  let i = 0;
  return /* @__PURE__ */ t.createElement("div", { className: pt.wrap }, /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": o }, /* @__PURE__ */ t.createElement("circle", { className: pt.track, cx: "50", cy: "50", r: $a }), l > 0 && e.map((c) => {
    var d;
    const u = Math.max(0, c.value) / l * No, m = i;
    return i += u, u <= 0 ? null : /* @__PURE__ */ t.createElement(
      "circle",
      {
        key: c.key,
        className: pt[(d = c.tone) != null ? d : "accent"],
        cx: "50",
        cy: "50",
        r: $a,
        strokeDasharray: `${u} ${No - u}`,
        strokeDashoffset: -m,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ t.createElement("title", null, `${c.label} ${c.value.toLocaleString("ko-KR")}${s}`)
    );
  }), /* @__PURE__ */ t.createElement("text", { className: pt.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? n != null ? n : l.toLocaleString("ko-KR") : r)), /* @__PURE__ */ t.createElement("ul", { className: pt.legend }, e.map((c) => {
    var u;
    return /* @__PURE__ */ t.createElement("li", { key: c.key }, /* @__PURE__ */ t.createElement("i", { className: pt[`dot_${(u = c.tone) != null ? u : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ t.createElement("span", { className: pt.name }, c.label), /* @__PURE__ */ t.createElement("span", { className: pt.val }, c.value.toLocaleString("ko-KR"), s), /* @__PURE__ */ t.createElement("span", { className: pt.pct }, l > 0 ? `${Math.round(c.value / l * 100)}%` : "-"));
  })));
}
const C0 = "_wrap_17qzl_1", S0 = "_track_17qzl_2", A0 = "_compact_17qzl_3", M0 = "_fill_17qzl_4", B0 = "_accent_17qzl_5", j0 = "_muted_17qzl_6", T0 = "_ok_17qzl_7", L0 = "_warn_17qzl_8", q0 = "_danger_17qzl_9", I0 = "_num_17qzl_10", F0 = "_none_17qzl_12", Lt = {
  wrap: C0,
  track: S0,
  compact: A0,
  fill: M0,
  accent: B0,
  muted: j0,
  ok: T0,
  warn: L0,
  danger: q0,
  num: I0,
  none: F0
};
function zN({ value: e, label: n, tone: a = "accent", compact: o }) {
  if (e == null)
    return /* @__PURE__ */ t.createElement("span", { className: Lt.none, "aria-label": `${n} 해당 없음` }, "-");
  const r = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: [Lt.wrap, o ? Lt.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": n,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": r
    },
    /* @__PURE__ */ t.createElement("span", { className: Lt.track }, /* @__PURE__ */ t.createElement("span", { className: `${Lt.fill} ${Lt[a]}`, style: { width: `${r}%` } })),
    /* @__PURE__ */ t.createElement("span", { className: Lt.num }, r, "%")
  );
}
const R0 = { day: 28, week: 10, month: 3 }, La = 864e5;
function Dt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / La);
}
function P0(e) {
  const n = new Date(e * La);
  return `${n.getUTCFullYear()}-${String(n.getUTCMonth() + 1).padStart(2, "0")}-${String(n.getUTCDate()).padStart(2, "0")}`;
}
function Ot(e, n) {
  return P0(Dt(e) + n);
}
function xa(e, n) {
  return Dt(n) - Dt(e) + 1;
}
function hr(e) {
  return new Date(Dt(e) * La).getUTCDay();
}
const $o = (e) => {
  const n = hr(e);
  return n === 0 || n === 6;
};
function tn(e, n, a, o) {
  const r = [], s = xa(e, n);
  for (let l = 0; l < s; l++) {
    const i = Ot(e, l), c = a(i), u = r[r.length - 1];
    u && u.key === c ? u.days++ : r.push({ key: c, label: o(i), offset: l, days: 1 });
  }
  return r;
}
function O0(e, n, a) {
  const o = (s) => s.slice(0, 7), r = (s) => `${s.slice(0, 4)}.${s.slice(5, 7)}`;
  if (a === "month")
    return {
      top: tn(e, n, (s) => s.slice(0, 4), (s) => `${s.slice(0, 4)}년`),
      bottom: tn(e, n, o, (s) => `${Number(s.slice(5, 7))}월`)
    };
  if (a === "week") {
    const s = (l) => Ot(l, -((hr(l) + 6) % 7));
    return {
      top: tn(e, n, o, r),
      bottom: tn(e, n, s, (l) => {
        const i = s(l);
        return `${Number(i.slice(5, 7))}/${Number(i.slice(8, 10))}`;
      })
    };
  }
  return {
    top: tn(e, n, o, r),
    bottom: tn(e, n, (s) => s, (s) => String(Number(s.slice(8, 10))))
  };
}
function fa(e, n, a, o) {
  if (a === "move") return { start: Ot(e, o), end: Ot(n, o) };
  if (a === "start") {
    const s = Ot(e, o);
    return { start: s > n ? n : s, end: n };
  }
  const r = Ot(n, o);
  return { start: e, end: r < e ? e : r };
}
const X0 = "_gantt_1j2fn_3", W0 = "_scroll_1j2fn_15", z0 = "_canvas_1j2fn_21", K0 = "_head_1j2fn_24", H0 = "_headLabel_1j2fn_32", G0 = "_headTrack_1j2fn_43", U0 = "_band_1j2fn_44", Y0 = "_seg_1j2fn_46", V0 = "_tick_1j2fn_59", J0 = "_tickOff_1j2fn_60", Q0 = "_body_1j2fn_62", Z0 = "_overlay_1j2fn_65", ek = "_weekend_1j2fn_66", tk = "_holiday_1j2fn_66", nk = "_today_1j2fn_68", ak = "_row_1j2fn_70", ok = "_label_1j2fn_76", rk = "_sel_1j2fn_77", sk = "_track_1j2fn_77", lk = "_dim_1j2fn_78", ck = "_labelText_1j2fn_95", ik = "_dot_1j2fn_96", uk = "_warn_1j2fn_97", mk = "_err_1j2fn_98", dk = "_bar_1j2fn_113", _k = "_can_1j2fn_21", pk = "_dragging_1j2fn_126", fk = "_fill_1j2fn_127", yk = "_late_1j2fn_128", hk = "_summary_1j2fn_130", bk = "_handle_1j2fn_133", Ek = "_hL_1j2fn_134", gk = "_hR_1j2fn_135", vk = "_mark_1j2fn_137", kk = "_barText_1j2fn_138", wk = "_empty_1j2fn_147", Nk = "_srOnly_1j2fn_150", Q = {
  gantt: X0,
  scroll: W0,
  canvas: z0,
  head: K0,
  headLabel: H0,
  headTrack: G0,
  band: U0,
  seg: Y0,
  tick: V0,
  tickOff: J0,
  body: Q0,
  overlay: Z0,
  weekend: ek,
  holiday: tk,
  today: nk,
  row: ak,
  label: ok,
  sel: rk,
  track: sk,
  dim: lk,
  labelText: ck,
  dot: ik,
  warn: uk,
  err: mk,
  bar: dk,
  can: _k,
  dragging: pk,
  fill: fk,
  late: yk,
  summary: hk,
  handle: bk,
  hL: Ek,
  hR: gk,
  mark: vk,
  barText: kk,
  empty: wk,
  srOnly: Nk
}, xo = 28, Do = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let $k = 0;
function KN({
  rows: e,
  from: n,
  to: a,
  scale: o = "day",
  holidays: r = {},
  today: s,
  scrollToToday: l = !0,
  onChange: i,
  onRowClick: c,
  selectedId: u,
  labelWidth: m = 280,
  labelHeader: d,
  lockedReason: _,
  className: p = "",
  style: f,
  "aria-label": y
}) {
  const E = I("");
  E.current || (E.current = `axe-gantt-keys-${++$k}`);
  const g = R0[o], w = Math.max(xa(n, a), 1), D = Dt(n), k = w * g, b = De(() => O0(n, a, o), [n, a, o]), $ = De(() => {
    const N = [];
    for (let O = 0; O < w; O++) {
      const Y = Ot(n, O), H = Y in r;
      if (!H && !$o(Y)) continue;
      const ue = N[N.length - 1];
      ue && ue.offset + ue.days === O && ue.holiday === H ? ue.days++ : N.push({ offset: O, days: 1, holiday: H });
    }
    return N;
  }, [n, w, r]), [h, v] = A(null), x = I(null), C = (N) => !!i && !N.locked && !N.summary && !!N.start && !!N.end, B = (N, O, Y) => {
    if (!C(O) || N.button !== 0) return;
    N.stopPropagation(), N.currentTarget.setPointerCapture(N.pointerId);
    const H = { id: O.id, mode: Y, x: N.clientX, delta: 0, moved: !1 };
    x.current = H, v(H);
  }, R = (N) => {
    const O = x.current;
    if (!O) return;
    const Y = Math.round((N.clientX - O.x) / g), H = O.moved || Math.abs(N.clientX - O.x) > 3;
    if (Y !== O.delta || H !== O.moved) {
      const ue = { ...O, delta: Y, moved: H };
      x.current = ue, v(ue);
    }
  }, P = (N) => {
    const O = x.current;
    if (x.current = null, v(null), !!O) {
      if (!O.moved) {
        c == null || c(N);
        return;
      }
      O.delta !== 0 && N.start && N.end && (i == null || i(N, fa(N.start, N.end, O.mode, O.delta), O.mode));
    }
  }, G = () => {
    x.current = null, v(null);
  }, q = (N, O) => {
    if (N.key === "Escape" && x.current) {
      G();
      return;
    }
    if (N.key === "Enter") {
      c == null || c(O);
      return;
    }
    if (!C(O) || N.key !== "ArrowLeft" && N.key !== "ArrowRight") return;
    N.preventDefault();
    const Y = N.key === "ArrowLeft" ? -1 : 1, H = N.shiftKey ? "end" : N.altKey ? "start" : "move";
    i == null || i(O, fa(O.start, O.end, H, Y), H);
  }, L = s ? Dt(s) - D : -1, F = I(null), oe = I(null);
  return He(() => {
    const N = F.current;
    if (!l || !N || L < 0 || L >= w || oe.current === o) return;
    oe.current = o;
    const O = Math.max(N.clientWidth - m, 0);
    N.scrollLeft = Math.max(0, L * g + g / 2 - O / 3);
  }, [l, o, L, w, g, m]), /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [Q.gantt, p].filter(Boolean).join(" "),
      style: f,
      role: "region",
      "aria-label": y != null ? y : "간트",
      onKeyDown: (N) => {
        N.key === "Escape" && x.current && G();
      }
    },
    /* @__PURE__ */ t.createElement("span", { id: E.current, className: Q.srOnly }, Do),
    /* @__PURE__ */ t.createElement("div", { ref: F, className: Q.scroll }, /* @__PURE__ */ t.createElement("div", { className: Q.canvas, style: { width: m + k } }, /* @__PURE__ */ t.createElement("div", { className: Q.head, style: { gridTemplateColumns: `${m}px ${k}px` } }, /* @__PURE__ */ t.createElement("div", { className: Q.headLabel }, d), /* @__PURE__ */ t.createElement("div", { className: Q.headTrack }, /* @__PURE__ */ t.createElement("div", { className: Q.band }, b.top.map((N) => /* @__PURE__ */ t.createElement("span", { key: N.key, className: Q.seg, style: { left: N.offset * g, width: N.days * g }, title: N.label }, N.label))), /* @__PURE__ */ t.createElement("div", { className: Q.band }, b.bottom.map((N) => {
      var Y;
      const O = o === "day" && (N.key in r || $o(N.key));
      return /* @__PURE__ */ t.createElement(
        "span",
        {
          key: N.key,
          className: [Q.seg, Q.tick, O ? Q.tickOff : ""].filter(Boolean).join(" "),
          style: { left: N.offset * g, width: N.days * g },
          title: (Y = r[N.key]) != null ? Y : N.key
        },
        N.days * g >= 16 ? N.label : ""
      );
    })))), /* @__PURE__ */ t.createElement("div", { className: Q.body, style: { minHeight: xo } }, /* @__PURE__ */ t.createElement("div", { className: Q.overlay, style: { left: m, width: k }, "aria-hidden": "true" }, $.map((N) => /* @__PURE__ */ t.createElement("span", { key: N.offset, className: N.holiday ? Q.holiday : Q.weekend, style: { left: N.offset * g, width: N.days * g } })), L >= 0 && L < w && /* @__PURE__ */ t.createElement("span", { className: Q.today, style: { left: L * g + g / 2 }, title: "오늘" })), e.map((N) => {
      var z, ie, Et, gt;
      const O = !!N.start && !!N.end && N.start <= N.end, Y = h && h.id === N.id ? h : null, H = O && Y && Y.delta !== 0 ? fa(N.start, N.end, Y.mode, Y.delta) : O ? { start: N.start, end: N.end } : null, ue = H ? (Dt(H.start) - D) * g : 0, j = H ? xa(H.start, H.end) * g : 0, U = Math.max(0, Math.min(100, (z = N.progress) != null ? z : 0)), ee = u != null && u === N.id, ae = C(N), ce = !ae && i && H ? _ == null ? void 0 : _(N) : void 0;
      return /* @__PURE__ */ t.createElement(
        "div",
        {
          key: N.id,
          className: [Q.row, ee ? Q.sel : "", N.dim ? Q.dim : ""].filter(Boolean).join(" "),
          style: { height: xo }
        },
        /* @__PURE__ */ t.createElement(
          "div",
          {
            className: Q.label,
            style: { width: m },
            title: N.name,
            onClick: () => c == null ? void 0 : c(N)
          },
          /* @__PURE__ */ t.createElement("span", { className: Q.labelText }, N.label),
          N.marked && /* @__PURE__ */ t.createElement("span", { className: Q.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          N.warn && /* @__PURE__ */ t.createElement("span", { className: Q.warn, title: N.warn, "aria-label": N.warn }, "⚠"),
          N.error && /* @__PURE__ */ t.createElement("span", { className: Q.err, title: N.error, "aria-label": N.error }, "!")
        ),
        /* @__PURE__ */ t.createElement("div", { className: Q.track, style: { width: k }, onClick: () => !Y && (c == null ? void 0 : c(N)) }, H ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
          "div",
          {
            className: [Q.bar, N.summary ? Q.summary : "", N.late ? Q.late : "", ae ? Q.can : "", Y ? Q.dragging : ""].filter(Boolean).join(" "),
            style: { left: ue, width: Math.max(j, 2) },
            role: "button",
            tabIndex: 0,
            "aria-label": `${(ie = N.name) != null ? ie : ""} ${H.start} ~ ${H.end}${N.progress != null ? ` ${U}%` : ""}${N.late ? " 지연" : ""}${ce ? ` 잠김: ${ce}` : ""}`,
            "aria-describedby": ae ? E.current : void 0,
            title: `${H.start} ~ ${H.end}${N.progress != null ? ` · ${U}%` : ""}${N.late ? " · 지연" : ""}${ae ? `
끌어 옮기기·양 끝 조절
${Do}` : ""}${ce ? `
잠김: ${ce}` : ""}`,
            onPointerDown: (de) => B(de, N, "move"),
            onPointerMove: R,
            onPointerUp: () => P(N),
            onPointerCancel: G,
            onClick: (de) => de.stopPropagation(),
            onKeyDown: (de) => q(de, N)
          },
          N.progress != null && /* @__PURE__ */ t.createElement("span", { className: Q.fill, style: { width: `${U}%` } }),
          ae && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: `${Q.handle} ${Q.hL}`, onPointerDown: (de) => B(de, N, "start") }), /* @__PURE__ */ t.createElement("span", { className: `${Q.handle} ${Q.hR}`, onPointerDown: (de) => B(de, N, "end") }))
        ), N.markDate && N.markDate >= n && N.markDate <= a && /* @__PURE__ */ t.createElement("span", { className: Q.mark, style: { left: (Dt(N.markDate) - D + 1) * g - 1 }, title: (Et = N.markLabel) != null ? Et : N.markDate }), N.barText && /* @__PURE__ */ t.createElement("span", { className: Q.barText, style: { left: ue + Math.max(j, 2) + 4 } }, N.barText)) : /* @__PURE__ */ t.createElement("span", { className: Q.empty }, (gt = N.emptyText) != null ? gt : "기간 없음"))
      );
    }))))
  );
}
const xk = "_board_pw08j_3", Dk = "_col_pw08j_13", Ck = "_over_pw08j_21", Sk = "_head_pw08j_23", Ak = "_title_pw08j_31", Mk = "_count_pw08j_32", Bk = "_hint_pw08j_41", jk = "_list_pw08j_43", Tk = "_empty_pw08j_52", Lk = "_card_pw08j_54", qk = "_sel_pw08j_66", Ik = "_dragging_pw08j_67", Fk = "_hasErr_pw08j_68", Rk = "_dot_pw08j_69", Pk = "_err_pw08j_70", Ce = {
  board: xk,
  col: Dk,
  over: Ck,
  head: Sk,
  title: Ak,
  count: Mk,
  hint: Bk,
  list: jk,
  empty: Tk,
  card: Lk,
  sel: qk,
  dragging: Ik,
  hasErr: Fk,
  dot: Rk,
  err: Pk
}, ya = "application/x-axerp-kanban";
function HN({
  columns: e,
  cards: n,
  cardKey: a,
  columnOf: o,
  renderCard: r,
  cardLabel: s,
  onMove: l,
  onCardClick: i,
  selectedKey: c,
  marked: u,
  error: m,
  lockedReason: d,
  emptyText: _ = "카드가 없습니다",
  moveHint: p,
  className: f = "",
  style: y,
  "aria-label": E
}) {
  const [g, w] = A(null), [D, k] = A(null), b = new Map(n.map((v) => [String(a(v)), v])), $ = (v, x) => {
    v.preventDefault(), w(null), k(null);
    const C = v.dataTransfer.getData(ya), B = b.get(C);
    B && o(B) !== x && (l == null || l(B, x));
  }, h = (v, x) => {
    if (v.key === "Enter" || v.key === " ") {
      v.preventDefault(), i == null || i(x);
      return;
    }
    if (!l || !v.altKey || v.key !== "ArrowLeft" && v.key !== "ArrowRight" || d != null && d(x)) return;
    v.preventDefault();
    const C = e.findIndex((R) => R.key === o(x)), B = C + (v.key === "ArrowLeft" ? -1 : 1);
    C >= 0 && B >= 0 && B < e.length && l(x, e[B].key);
  };
  return /* @__PURE__ */ t.createElement("div", { className: [Ce.board, f].filter(Boolean).join(" "), style: y, role: "region", "aria-label": E != null ? E : "보드" }, e.map((v) => {
    const x = n.filter((C) => o(C) === v.key);
    return /* @__PURE__ */ t.createElement(
      "section",
      {
        key: v.key,
        className: [Ce.col, g === v.key ? Ce.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof v.title == "string" ? v.title : void 0,
        onDragOver: l ? (C) => {
          C.dataTransfer.types.includes(ya) && (C.preventDefault(), w(v.key));
        } : void 0,
        onDragLeave: l ? (C) => {
          C.currentTarget.contains(C.relatedTarget) || w((B) => B === v.key ? null : B);
        } : void 0,
        onDrop: l ? (C) => $(C, v.key) : void 0
      },
      /* @__PURE__ */ t.createElement("header", { className: Ce.head }, /* @__PURE__ */ t.createElement("span", { className: Ce.title }, v.title), /* @__PURE__ */ t.createElement("span", { className: Ce.count }, x.length), v.hint && /* @__PURE__ */ t.createElement("span", { className: Ce.hint }, v.hint)),
      /* @__PURE__ */ t.createElement("div", { className: Ce.list }, x.length === 0 && /* @__PURE__ */ t.createElement("p", { className: Ce.empty }, _), x.map((C) => {
        const B = a(C), R = d == null ? void 0 : d(C), P = m == null ? void 0 : m(C), G = !!l && !R;
        return /* @__PURE__ */ t.createElement(
          "article",
          {
            key: B,
            className: [Ce.card, c === B ? Ce.sel : "", D === B ? Ce.dragging : "", P ? Ce.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            role: "button",
            "aria-label": s == null ? void 0 : s(C),
            "aria-keyshortcuts": G ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: R != null ? R : G ? p != null ? p : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0,
            draggable: G,
            onDragStart: G ? (q) => {
              q.dataTransfer.setData(ya, String(B)), q.dataTransfer.effectAllowed = "move", k(B);
            } : void 0,
            onDragEnd: () => {
              k(null), w(null);
            },
            onClick: () => i == null ? void 0 : i(C),
            onKeyDown: (q) => h(q, C)
          },
          (u == null ? void 0 : u(C)) && /* @__PURE__ */ t.createElement("span", { className: Ce.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          r(C),
          P && /* @__PURE__ */ t.createElement("p", { className: Ce.err, role: "alert" }, P)
        );
      }))
    );
  }));
}
const Ok = "_list_1aqum_2", Xk = "_empty_1aqum_3", Wk = "_item_1aqum_5", zk = "_row_block_1aqum_6", Kk = "_row_warn_1aqum_7", Hk = "_head_1aqum_9", Gk = "_mark_1aqum_16", Uk = "_msg_1aqum_17", Yk = "_count_1aqum_18", Vk = "_aside_1aqum_19", Jk = "_caret_1aqum_20", Qk = "_block_1aqum_22", Zk = "_warn_1aqum_23", ew = "_info_1aqum_24", tw = "_body_1aqum_29", nw = "_actions_1aqum_30", Se = {
  list: Ok,
  empty: Xk,
  item: Wk,
  row_block: zk,
  row_warn: Kk,
  head: Hk,
  mark: Gk,
  msg: Uk,
  count: Yk,
  aside: Vk,
  caret: Jk,
  block: Qk,
  warn: Zk,
  info: ew,
  body: tw,
  actions: nw
}, aw = { block: "■", warn: "▲", info: "●" }, ow = { block: "차단", warn: "경고", info: "정보" };
function GN({ items: e, empty: n = "점검할 항목이 없습니다", openTones: a = ["block"], className: o = "" }) {
  const [r, s] = A({}), [l, i] = A(e);
  return l !== e && (i(e), s({})), e.length ? /* @__PURE__ */ t.createElement("ul", { className: `${Se.list} ${o}` }, e.map((c) => {
    var _;
    const u = !!c.detail || !!c.actions, m = u && ((_ = r[c.key]) != null ? _ : a.includes(c.tone)), d = /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: `${Se.mark} ${Se[c.tone]}`, "aria-label": ow[c.tone], role: "img" }, aw[c.tone]), /* @__PURE__ */ t.createElement("span", { className: Se.msg }, c.message), !!c.count && /* @__PURE__ */ t.createElement("span", { className: `${Se.count} ${Se[c.tone]}` }, c.count.toLocaleString("ko-KR"), "건"), c.aside != null && /* @__PURE__ */ t.createElement("span", { className: Se.aside }, c.aside), u && /* @__PURE__ */ t.createElement("span", { className: Se.caret, "aria-hidden": "true" }, m ? "▾" : "▸"));
    return /* @__PURE__ */ t.createElement("li", { key: c.key, className: `${Se.item} ${Se[`row_${c.tone}`]}` }, u ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Se.head,
        "aria-expanded": m,
        onClick: () => s((p) => ({ ...p, [c.key]: !m }))
      },
      d
    ) : /* @__PURE__ */ t.createElement("div", { className: Se.head }, d), m && /* @__PURE__ */ t.createElement("div", { className: Se.body }, c.detail, c.actions && /* @__PURE__ */ t.createElement("div", { className: Se.actions }, c.actions)));
  })) : /* @__PURE__ */ t.createElement("p", { className: `${Se.empty} ${o}` }, n);
}
const Co = 30, rw = BigInt(10);
function ln(e) {
  let n = BigInt(1);
  for (let a = 0; a < e; a += 1) n = n * rw;
  return n;
}
function ht(e, n = 0) {
  return { u: e, s: n };
}
const br = ht(BigInt(0));
function Er(e, n) {
  if (e.s === n.s) return [e.u, n.u, e.s];
  const a = Math.max(e.s, n.s);
  return [e.u * ln(a - e.s), n.u * ln(a - n.s), a];
}
function An(e, n) {
  const [a, o, r] = Er(e, n);
  return ht(a + o, r);
}
function qa(e, n) {
  const [a, o, r] = Er(e, n);
  return ht(a - o, r);
}
function at(e, n) {
  return ht(e.u * n.u, e.s + n.s);
}
function Xt(e, n) {
  if (n.u === BigInt(0)) return null;
  const a = e.u * ln(n.s + Co), o = n.u * ln(e.s);
  return ht(a / o, Co);
}
function gr(e) {
  return ht(-e.u, e.s);
}
function bt(e, n, a) {
  if (n >= e.s)
    return ht(e.u * ln(n - e.s), n);
  const o = ln(e.s - n), r = e.u < BigInt(0), s = r ? -e.u : e.u, l = s / o, i = s % o;
  let c;
  return i === BigInt(0) || a === "down" ? c = l : a === "up" ? c = l + BigInt(1) : c = i * BigInt(2) >= o ? l + BigInt(1) : l, ht(r ? -c : c, n);
}
function be(e) {
  const n = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(n)) return null;
  const a = n.startsWith("-"), o = n.replace(/^[+-]/, ""), r = o.indexOf("."), s = r < 0 ? o : o.slice(0, r) + o.slice(r + 1), l = r < 0 ? 0 : o.length - r - 1, i = BigInt(s === "" ? "0" : s);
  return ht(a ? -i : i, l);
}
function Ia(e) {
  var a;
  const n = be(String(e));
  return n || ((a = be(e.toFixed(20))) != null ? a : br);
}
function Ue(e, n = e.s, a = !1) {
  const o = bt(e, Math.max(n, 0), "half"), r = o.u < BigInt(0), s = (r ? -o.u : o.u).toString().padStart(n + 1, "0"), l = s.length - n;
  let i = s.slice(0, l);
  const c = s.slice(l);
  return a && (i = i.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (r ? "-" : "") + i + (n > 0 ? "." + c : "");
}
function Da(e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!n) return null;
  const a = Number(n[1]), o = Number(n[2]), r = Number(n[3]);
  return o < 1 || o > 12 || r < 1 || r > Fa(a, o) ? null : { y: a, m: o, d: r };
}
function sw(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Fa(e, n) {
  return n === 2 ? sw(e) ? 29 : 28 : [4, 6, 9, 11].includes(n) ? 30 : 31;
}
function an({ y: e, m: n, d: a }) {
  const o = Math.floor((14 - n) / 12), r = e + 4800 - o, s = n + 12 * o - 3;
  return a + Math.floor((153 * s + 2) / 5) + 365 * r + Math.floor(r / 4) - Math.floor(r / 100) + Math.floor(r / 400) - 32045;
}
function vr(e, n) {
  const a = an(e) + n + 32044, o = Math.floor((4 * a + 3) / 146097), r = a - Math.floor(146097 * o / 4), s = Math.floor((4 * r + 3) / 1461), l = r - Math.floor(1461 * s / 4), i = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * i + 2) / 5) + 1,
    m: i + 3 - 12 * Math.floor(i / 10),
    y: 100 * o + s - 4800 + Math.floor(i / 10)
  };
}
function kr(e, n, a = "exclude-first") {
  const o = an(e) > an(n), r = o ? n : e, s = o ? e : n, l = a === "include-first", i = an(s) - an(r) + (l ? 1 : 0), c = l ? vr(s, 1) : s;
  let u = c.y - r.y, m = c.m - r.m, d = c.d - r.d;
  if (d < 0) {
    m -= 1;
    const _ = c.m === 1 ? 12 : c.m - 1, p = c.m === 1 ? c.y - 1 : c.y;
    d += Fa(p, _);
  }
  return m < 0 && (u -= 1, m += 12), { days: i, y: u, m, d, swapped: o };
}
function Zn(e, n) {
  return vr(e, n);
}
function So(e, n) {
  const a = e.y * 12 + (e.m - 1) + n, o = Math.floor(a / 12), r = a % 12 + 1;
  return { y: o, m: r, d: Math.min(e.d, Fa(o, r)) };
}
const lw = ["월", "화", "수", "목", "금", "토", "일"];
function Ca(e) {
  return lw[an(e) % 7];
}
function Pe(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const vn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], ha = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function Ao(e) {
  var n;
  return (n = ha[e]) != null ? n : e in ha ? ha[e] : null;
}
function Sa(e, n) {
  return e.find((a) => a.code === n);
}
function wr(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function Nr(e, n, a, o) {
  const r = Sa(e, a), s = Sa(e, o);
  if (!r || !s) return null;
  const l = be(r.krw), i = be(s.krw), c = be(String(r.per)), u = be(String(s.per));
  if (!l || !i || !c || !u) return null;
  const m = Xt(at(n, l), c);
  if (!m) return null;
  const d = Xt(at(m, u), i);
  return d ? {
    value: bt(d, 2, "half"),
    notice: `${wr(r)} · 샘플 고시(원천 미결)`
  } : null;
}
function cw(e, n) {
  let a = null;
  for (const r of e)
    if (r.value) {
      if (a === null) {
        a = r.sign === "-" ? gr(r.value) : r.value;
        continue;
      }
      switch (r.sign) {
        case "+":
          a = An(a, r.value);
          break;
        case "-":
          a = qa(a, r.value);
          break;
        case "*":
          a = at(a, r.value);
          break;
        default: {
          const s = Xt(a, r.value);
          if (!s) return { ok: !1, error: "divide-by-zero" };
          a = s;
          break;
        }
      }
    }
  const o = a != null ? a : br;
  return { ok: !0, value: n ? bt(o, n.digits, n.mode) : o };
}
const Mo = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function xn() {
  return { sign: "+", text: "" };
}
function iw(e) {
  const n = e.replace(/[^\d.-]/g, ""), a = n.startsWith("-"), o = n.replace(/-/g, ""), r = o.indexOf("."), s = r < 0 ? o : o.slice(0, r), l = r < 0 ? "" : "." + o.slice(r + 1).replace(/\./g, "");
  return (a ? "-" : "") + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function uw(e) {
  return e.map((n) => ({ sign: n.sign, value: be(n.text) }));
}
function mw(e) {
  const { lines: n, onLines: a, active: o, onActive: r, digits: s, onDigits: l, mode: i, onMode: c } = e, u = I([]), m = Math.min(o, n.length - 1);
  Z(() => {
    var D;
    (D = u.current[m]) == null || D.focus();
  }, [m, n.length]);
  const d = cw(uw(n), { digits: s, mode: i }), _ = d.ok ? Ue(d.value, s, !0) : "0으로 나눌 수 없음", p = (D, k) => {
    a(n.map((b, $) => $ === D ? { ...b, ...k } : b));
  }, f = (D = n.length, k = "") => {
    const b = [...n];
    b.splice(D, 0, { ...xn(), text: k }), a(b), r(D);
  }, y = (D) => {
    if (n.length === 1) {
      a([xn()]);
      return;
    }
    a(n.filter((k, b) => b !== D)), r(Math.max(0, D - 1));
  }, E = () => {
    d.ok && f(n.length, Ue(d.value, s, !0));
  }, g = (D, k) => {
    const b = D.key, $ = dw(b);
    if ($ && !(b === "-" && n[k].text === "")) {
      D.preventDefault(), p(k, { sign: $ });
      return;
    }
    if (b === "v" || b === "V") {
      D.preventDefault(), E();
      return;
    }
    b === "Enter" ? (D.preventDefault(), k === n.length - 1 ? f() : r(k + 1)) : b === "ArrowDown" ? (D.preventDefault(), r(Math.min(k + 1, n.length - 1))) : b === "ArrowUp" ? (D.preventDefault(), r(Math.max(k - 1, 0))) : b === "Insert" ? (D.preventDefault(), f(k + 1)) : b === "Delete" && n[k].text === "" ? (D.preventDefault(), y(k)) : b === "F4" && (D.preventDefault(), w());
  }, w = () => {
    a([xn()]), r(0);
  };
  return /* @__PURE__ */ t.createElement("div", { className: "bical-general" }, /* @__PURE__ */ t.createElement("div", { className: "bical-side" }, /* @__PURE__ */ t.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: () => f(m + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: () => y(m) }, "라인삭제 (Del)"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: E }, "현재금액추가 (V)"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: w }, "초기화 (F4)")), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ t.createElement("div", { className: "bical-keys" }, Mo.map((D) => {
    var k;
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: D.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((k = n[m]) == null ? void 0 : k.sign) === D.key,
        onClick: () => p(m, { sign: D.key })
      },
      D.label,
      " (",
      D.hot,
      ")"
    );
  })), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: s, onChange: (D) => l(Number(D.target.value)) }, [0, 1, 2, 3, 4].map((D) => /* @__PURE__ */ t.createElement("option", { key: D, value: D }, D))), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: i, onChange: (D) => c(D.target.value) }, /* @__PURE__ */ t.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ t.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ t.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ t.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ t.createElement("div", { className: "bical-grid" }, n.map((D, k) => {
    var b;
    return /* @__PURE__ */ t.createElement("div", { key: k, className: `bical-line${k === m ? " bical-line--active" : ""}` }, /* @__PURE__ */ t.createElement("span", { className: "bical-caret" }, k === m ? "❯" : ""), /* @__PURE__ */ t.createElement("span", { className: "bical-sign" }, (b = Mo.find(($) => $.key === D.sign)) == null ? void 0 : b.label), /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: ($) => {
          u.current[k] = $;
        },
        value: D.text,
        inputMode: "decimal",
        "aria-label": `${k + 1}번째 금액`,
        onFocus: () => r(k),
        onChange: ($) => p(k, { text: iw($.target.value) }),
        onKeyDown: ($) => g($, k)
      }
    ));
  })), /* @__PURE__ */ t.createElement("div", { className: `bical-result${d.ok ? "" : " bical-error"}` }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, _))));
}
function dw(e) {
  const n = e.toLowerCase();
  return n === "a" || e === "+" ? "+" : n === "s" || e === "-" ? "-" : n === "d" || e === "*" ? "*" : n === "f" || e === "/" ? "/" : null;
}
function _w(e) {
  const n = [];
  let a = 0;
  for (; a < e.length; ) {
    const o = e[a];
    if (o === " " || o === "	" || o === `
`)
      a += 1;
    else if (o >= "0" && o <= "9" || o === "." || o === ",") {
      let r = a;
      for (; r < e.length && (e[r] >= "0" && e[r] <= "9" || e[r] === "." || e[r] === ","); ) r += 1;
      const s = be(e.slice(a, r));
      if (!s) return null;
      n.push({ t: "num", v: s }), a = r;
    } else if (o === "+" || o === "-" || o === "*" || o === "/")
      n.push({ t: "op", v: o }), a += 1;
    else if (o === "(")
      n.push({ t: "(" }), a += 1;
    else if (o === ")")
      n.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return n;
}
class pw {
  constructor(n) {
    this.tokens = n, this.at = 0;
  }
  parse() {
    const n = this.expr();
    return n.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : n;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let n = this.term();
    if (!n.ok) return n;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return n;
      this.at += 1;
      const o = this.term();
      if (!o.ok) return o;
      n = { ok: !0, value: a.v === "+" ? An(n.value, o.value) : qa(n.value, o.value) };
    }
  }
  term() {
    let n = this.unary();
    if (!n.ok) return n;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return n;
      this.at += 1;
      const o = this.unary();
      if (!o.ok) return o;
      if (a.v === "*")
        n = { ok: !0, value: at(n.value, o.value) };
      else {
        const r = Xt(n.value, o.value);
        if (!r) return { ok: !1, error: "divide-by-zero" };
        n = { ok: !0, value: r };
      }
    }
  }
  unary() {
    const n = this.peek();
    if (n && n.t === "op" && (n.v === "+" || n.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: n.v === "-" ? gr(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const n = this.peek();
    if (!n) return { ok: !1, error: "syntax" };
    if (n.t === "num")
      return this.at += 1, { ok: !0, value: n.v };
    if (n.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const o = this.peek();
      return !o || o.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function fw(e) {
  const n = _w(e);
  return !n || n.length === 0 ? { ok: !1, error: "syntax" } : new pw(n).parse();
}
const Dn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (샘플 고시)"
], yw = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function hw(e, n) {
  return e.replace(/오늘/g, Pe(n)).replace(/내일/g, Pe(Zn(n, 1))).replace(/어제/g, Pe(Zn(n, -1)));
}
function bw(e) {
  const n = [];
  for (const a of e.matchAll(yw)) {
    const o = Da(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    o && n.push(o);
  }
  return n;
}
const Ew = /부터|까지|에서|일수|며칠|기간|차이|~/;
function gw(e, n) {
  if (n.length < 2 || !Ew.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), o = kr(n[0], n[1], a ? "include-first" : "exclude-first"), r = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${Pe(n[0])} ~ ${Pe(n[1])} 기간(${r})` + (o.swapped ? " · 역순 입력" : ""),
    value: `${o.days}일 (${o.y}년 ${o.m}개월 ${o.d}일)`
  };
}
const vw = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function kw(e, n) {
  if (n.length !== 1) return null;
  const a = vw.exec(e);
  if (!a) return null;
  const o = Number(a[1]), r = a[3] === "전" || a[3] === "이전", s = r ? -o : o, l = n[0];
  let i;
  return a[2] === "일" ? i = Zn(l, s) : a[2] === "주" ? i = Zn(l, s * 7) : a[2] === "년" ? i = So(l, s * 12) : i = So(l, s), {
    ok: !0,
    explain: `${Pe(l)} 에서 ${o}${a[2]} ${r ? "전" : "후"}`,
    value: `${Pe(i)} (${Ca(i)})`
  };
}
function ww(e, n) {
  if (n.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const o = a[2] ? $r(a[2]) : null, r = be(a[1]);
  if (!r) return null;
  const s = o ? at(r, o) : r, l = Ao(a[3]);
  if (!l) return null;
  const c = l !== "KRW" ? "KRW" : Ao(Nw(e));
  if (!c || c === l) return null;
  const u = Nr(n, s, l, c);
  return u ? {
    ok: !0,
    explain: `${Ue(s, s.s, !0)} ${l} → ${c} · ${u.notice}`,
    value: `${Ue(u.value, 2, !0)} ${c}`
  } : null;
}
function Nw(e) {
  const n = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return n ? n[1] : "원";
}
const $w = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function $r(e) {
  var n;
  return (n = be($w[e])) != null ? n : Ia(1);
}
const xw = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, Dw = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function Cw(e) {
  return e.replace(xw, (n) => {
    let a = be("0"), o = !1;
    for (const r of n.matchAll(Dw)) {
      const s = be(r[1]);
      s && (o = !0, a = An(a, r[2] ? at(s, $r(r[2])) : s));
    }
    return o ? Ue(a, a.s) : n;
  });
}
const Sw = /원화|원|엔|씩|개월|개|명|건/g;
function Aw(e) {
  return Cw(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(Sw, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const Mw = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function Bw(e, n, a) {
  const o = be("1"), r = Ue(at(n, Ia(100)), 0);
  if (a === "add")
    return {
      value: bt(at(e, An(o, n)), 0, "half"),
      explain: `消費税 ${r}% 가산(税抜 기준)`
    };
  const s = Xt(at(e, n), An(o, n));
  return {
    value: s ? bt(s, 0, "down") : e,
    explain: `消費税 ${r}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function jw(e, n) {
  var c;
  const a = e.trim();
  if (!a) return { ok: !1, supported: Dn };
  const o = hw(a, n.today), r = bw(o), s = gw(o, r);
  if (s) return s;
  const l = kw(o, r);
  if (l) return l;
  const i = ww(o, (c = n.rates) != null ? c : []);
  return i || Tw(o, n);
}
function Tw(e, n) {
  var u, m;
  const a = Mw.exec(e), o = a ? e.slice(0, a.index) : e, r = Aw(o);
  if (!r) return { ok: !1, supported: Dn };
  const s = fw(r);
  if (!s.ok)
    return { ok: !1, supported: Dn };
  if (!a)
    return { ok: !0, explain: r, value: Bo(s.value), expr: r };
  const l = (m = (u = Lw(a[2])) != null ? u : n.taxRate) != null ? m : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세율(a_fa_param)을 읽어 오면 계산합니다", ...Dn]
    };
  const i = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", c = Bw(s.value, l, i);
  return {
    ok: !0,
    explain: `${r} · ${c.explain}`,
    value: Bo(c.value),
    expr: r
  };
}
function Lw(e) {
  var a;
  if (!e) return null;
  const n = be(e);
  return n && (a = Xt(n, Ia(100))) != null ? a : null;
}
function Bo(e) {
  const n = bt(e, 2, "half"), a = bt(n, 0, "down");
  return qa(n, a).u === BigInt(0) ? Ue(n, 0, !0) : Ue(n, 2, !0);
}
const Ke = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function jo(e, n) {
  const a = Ke[e].units.find((r) => r.key === n);
  if (!a) return null;
  const o = be(a.factor);
  if (!o) throw new Error(`단위 환산표가 깨졌습니다 — ${a.key}`);
  return o;
}
function qw(e, n, a, o, r = 4, s = "half") {
  const l = jo(e, n), i = jo(e, a);
  if (!l || !i) return null;
  const c = Xt(at(o, l), i);
  return c ? bt(c, r, s) : null;
}
const Iw = [0, 1, 2, 3, 4, 6], Fw = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Rw(e) {
  const { tab: n, onTab: a, seed: o, onClose: r, history: s, onHistory: l } = e, [i, c] = A(() => o == null ? [xn()] : [{ sign: "+", text: Ue(Hw(o), 0, !0) }]), [u, m] = A(0), [d, _] = A(0), [p, f] = A("half"), y = I(null);
  Z(() => {
    const g = (w) => {
      w.key === "Escape" && (w.preventDefault(), r());
    };
    return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
  }, [r]), Z(() => {
    var g, w;
    (w = (g = y.current) == null ? void 0 : g.querySelector("[data-autofocus]")) == null || w.focus();
  }, [n]);
  const E = (g) => {
    const w = [...i.filter((D) => D.text !== ""), { sign: "+", text: g }, xn()];
    c(w), m(w.length - 1), a("general");
  };
  return /* @__PURE__ */ t.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ t.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: y }, /* @__PURE__ */ t.createElement("div", { className: "bical-head" }, /* @__PURE__ */ t.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ t.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: r }, "✕")), /* @__PURE__ */ t.createElement("div", { className: "bical-tabs", role: "tablist" }, Fw.map((g) => /* @__PURE__ */ t.createElement(
    "button",
    {
      key: g.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": g.key === n,
      onClick: () => a(g.key)
    },
    g.label
  ))), /* @__PURE__ */ t.createElement("div", { className: "bical-body" }, n === "text" && /* @__PURE__ */ t.createElement(Xw, { history: s, onHistory: l, onPush: E }), n === "general" && /* @__PURE__ */ t.createElement(
    mw,
    {
      lines: i,
      onLines: c,
      active: u,
      onActive: m,
      digits: d,
      onDigits: _,
      mode: p,
      onMode: f
    }
  ), n === "date" && /* @__PURE__ */ t.createElement(Ww, null), n === "unit" && /* @__PURE__ */ t.createElement(zw, null), n === "fx" && /* @__PURE__ */ t.createElement(Kw, null)), /* @__PURE__ */ t.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-btn", onClick: r }, "닫기"))));
}
const Pw = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], Ow = 20;
function Xw({ history: e, onHistory: n, onPush: a }) {
  var f;
  const [o, r] = A(""), [s, l] = A(null), [i, c] = A(!1), [u, m] = A(!1), d = I(!1), _ = De(Ra, []), p = (y) => {
    r(y), m(!1);
    const E = jw(y, { today: _, rates: vn, taxRate: null });
    l(E), y.trim() && n([y, ...e.filter((g) => g !== y)].slice(0, Ow));
  };
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "data-autofocus": !0,
      value: o,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (y) => r(y.target.value),
      onCompositionStart: () => {
        d.current = !0;
      },
      onCompositionEnd: () => {
        d.current = !1;
      },
      onKeyDown: (y) => {
        y.key === "Enter" && !y.shiftKey && !d.current && !y.nativeEvent.isComposing && (y.preventDefault(), p(o));
      }
    }
  ), /* @__PURE__ */ t.createElement("div", { className: "bical-chips" }, Pw.map((y) => /* @__PURE__ */ t.createElement("button", { key: y, type: "button", className: "bical-chip", onClick: () => p(y) }, y))), s && (s.ok ? /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, s.explain), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, s.value), /* @__PURE__ */ t.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var y;
        (y = navigator.clipboard) == null || y.writeText(s.value).then(
          () => m(!0),
          () => m(!1)
        );
      }
    },
    u ? "복사함" : "결과복사"
  ), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(s.value) }, "일반계산에 추가"))) : /* @__PURE__ */ t.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ t.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((f = s.supported) != null ? f : Dn).map((y) => /* @__PURE__ */ t.createElement("li", { key: y }, y))))), e.length > 0 && /* @__PURE__ */ t.createElement("div", { className: "bical-log" }, /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => c((y) => !y) }, "기록 ", e.length, "건 ", i ? "접기" : "펼치기"), i && /* @__PURE__ */ t.createElement("ol", null, e.map((y) => /* @__PURE__ */ t.createElement("li", { key: y }, /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => p(y) }, y))))), /* @__PURE__ */ t.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function Ww() {
  const e = De(Ra, []), [n, a] = A(Pe(e)), [o, r] = A(Pe(e)), [s, l] = A("exclude-first"), i = Da(n), c = Da(o), u = i && c ? kr(i, c, s) : null;
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: s, onChange: (m) => l(m.target.value) }, /* @__PURE__ */ t.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ t.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ t.createElement("input", { className: "bical-input", type: "date", "data-autofocus": !0, value: n, onChange: (m) => a(m.target.value) }), /* @__PURE__ */ t.createElement("span", null, "~"), /* @__PURE__ */ t.createElement("input", { className: "bical-input", type: "date", value: o, onChange: (m) => r(m.target.value) })), u ? /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, Pe(i), "(", Ca(i), ") ~ ", Pe(c), "(", Ca(c), ")", u.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, u.days.toLocaleString(), "일"), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", u.y, "년 ", u.m, "개월 ", u.d, "일")) : /* @__PURE__ */ t.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function zw() {
  const [e, n] = A("area"), [a, o] = A(Ke.area.units[0].key), [r, s] = A(Ke.area.units[4].key), [l, i] = A(""), [c, u] = A(4), [m, d] = A("half"), _ = (y) => {
    n(y), o(Ke[y].units[0].key), s(Ke[y].units[1].key), i("");
  }, p = be(l), f = p ? qw(e, a, r, p, c, m) : null;
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: e, onChange: (y) => _(y.target.value) }, Object.keys(Ke).map((y) => /* @__PURE__ */ t.createElement("option", { key: y, value: y }, Ke[y].label))), /* @__PURE__ */ t.createElement("span", { className: "bical-sub" }, "기준 ", Ke[e].base)), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ t.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (y) => i(y.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: a, onChange: (y) => o(y.target.value) }, Ke[e].units.map((y) => /* @__PURE__ */ t.createElement("option", { key: y.key, value: y.key }, y.label))), /* @__PURE__ */ t.createElement("span", null, "→"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: r, onChange: (y) => s(y.target.value) }, Ke[e].units.map((y) => /* @__PURE__ */ t.createElement("option", { key: y.key, value: y.key }, y.label)))), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: c, onChange: (y) => u(Number(y.target.value)) }, Iw.map((y) => /* @__PURE__ */ t.createElement("option", { key: y, value: y }, y))), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: m, onChange: (y) => d(y.target.value) }, /* @__PURE__ */ t.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ t.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ t.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, To(e, a), " → ", To(e, r), " · 기준단위 1단계 환산"), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, f ? Ue(f, c, !0) : "—")));
}
function To(e, n) {
  var a, o;
  return (o = (a = Ke[e].units.find((r) => r.key === n)) == null ? void 0 : a.label) != null ? o : n;
}
function Kw() {
  const e = De(Ra, []), [n, a] = A(Pe(e)), [o, r] = A("JPY"), [s, l] = A("KRW"), [i, c] = A(""), u = be(i), m = u ? Nr(vn, u, o, s) : null, d = Sa(vn, o);
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ t.createElement("input", { className: "bical-input", type: "date", value: n, onChange: (_) => a(_.target.value) })), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ t.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: i,
      onChange: (_) => c(_.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: o, onChange: (_) => r(_.target.value) }, vn.map((_) => /* @__PURE__ */ t.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")"))), /* @__PURE__ */ t.createElement("span", null, "→"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: s, onChange: (_) => l(_.target.value) }, vn.map((_) => /* @__PURE__ */ t.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")")))), /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, d ? wr(d) : ""), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, m ? Ue(m.value, 2, !0) : "—")), /* @__PURE__ */ t.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ t.createElement("b", null, "샘플 고시입니다 — 원천 미결."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function Ra() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function Hw(e) {
  var n;
  return bt((n = be(String(e))) != null ? n : be("0"), 0, "half");
}
const xr = Fo(null);
function UN({ children: e }) {
  const [n, a] = A(!1), [o, r] = A("text"), [s, l] = A(null), [i, c] = A([]), [u, m] = A(0), d = De(() => ({
    open: (_) => {
      var p, f;
      r((p = _ == null ? void 0 : _.tab) != null ? p : "text"), l((f = _ == null ? void 0 : _.seed) != null ? f : null), m((y) => y + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ t.createElement(xr.Provider, { value: d }, e, n && /* @__PURE__ */ t.createElement(
    Rw,
    {
      key: u,
      tab: o,
      onTab: r,
      seed: s,
      onClose: d.close,
      history: i,
      onHistory: c
    }
  ));
}
function YN() {
  var e;
  return (e = Ro(xr)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class VN extends qo {
  constructor() {
    super(...arguments), this.rootRef = Cr(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new Vo(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: n, children: a, ...o } = this.props;
    return /* @__PURE__ */ t.createElement("div", { ref: this.rootRef, ...o }, a);
  }
}
export {
  D2 as AXActionCard,
  o2 as AXAiIconBadge,
  p2 as AXAiSuggestionBanner,
  Ko as AXAvatar,
  r2 as AXAvatarStack,
  s2 as AXBadge,
  C2 as AXBreadcrumb,
  k2 as AXButton,
  t2 as AXCardPanel,
  l2 as AXCommentRow,
  Zw as AXCommentThread,
  g2 as AXDataTable,
  n2 as AXDivider,
  A2 as AXDrawer,
  M2 as AXDropdownMenu,
  f2 as AXEmptyState,
  Id as AXErpActionMenu,
  mN as AXErpBanner,
  XN as AXErpBarChart,
  on as AXErpButton,
  Rw as AXErpCalculatorModal,
  UN as AXErpCalculatorProvider,
  cN as AXErpCalendar,
  Jo as AXErpCard,
  GN as AXErpCheckList,
  aN as AXErpCodePicker,
  DN as AXErpCsvButton,
  ro as AXErpDatePicker,
  sN as AXErpDateRange,
  WN as AXErpDonutChart,
  ur as AXErpError,
  H_ as AXErpField,
  $N as AXErpFileDrop,
  NN as AXErpFilterBand,
  bN as AXErpFormRow,
  EN as AXErpFormSection,
  KN as AXErpGantt,
  G2 as AXErpGisuField,
  Ud as AXErpGlyph,
  U2 as AXErpGrid,
  J2 as AXErpGridStatus,
  H2 as AXErpHint,
  Hn as AXErpIcon,
  ka as AXErpIconButton,
  HN as AXErpKanban,
  SN as AXErpKpiTile,
  AN as AXErpKpiTileGroup,
  Ba as AXErpLinkButton,
  qN as AXErpMainScreen,
  FN as AXErpMenuAreaHead,
  RN as AXErpMenuGroup,
  iN as AXErpMiniCalendar,
  mr as AXErpModal,
  uN as AXErpMoneyInput,
  ub as AXErpMsg,
  _N as AXErpNote,
  IN as AXErpOverviewGrid,
  j2 as AXErpPage,
  K2 as AXErpPill,
  zN as AXErpProgressBar,
  jN as AXErpProposalBanner,
  LN as AXErpProposalCards,
  qg as AXErpProposalList,
  TN as AXErpProposalModal,
  sE as AXErpQtyInput,
  MN as AXErpQuickMenu,
  gN as AXErpReadonly,
  z2 as AXErpReadout,
  I2 as AXErpSaveBar,
  W2 as AXErpSearchBar,
  eE as AXErpSelect,
  F2 as AXErpSideBar,
  P2 as AXErpSidePanel,
  R2 as AXErpSidePanelGroup,
  O2 as AXErpStartGuide,
  CN as AXErpStatCard,
  pN as AXErpStateBadge,
  nN as AXErpSummaryCard,
  X2 as AXErpSummaryList,
  Yo as AXErpTabs,
  Zb as AXErpTextInput,
  T2 as AXErpTitleBar,
  vN as AXErpToggle,
  ea as AXErpTooltip,
  eN as AXErpTreeCell,
  dN as AXErpVerify,
  ON as AXErpWeekStepper,
  PN as AXErpWeekStrip,
  y2 as AXExpandableSummary,
  c2 as AXFileChip,
  xl as AXFileTypeIcon,
  w2 as AXIconButton,
  v2 as AXKeyValueGrid,
  i2 as AXKeyValueRow,
  u2 as AXListRow,
  B2 as AXModal,
  a2 as AXPanelHeader,
  m2 as AXPersonRow,
  h2 as AXProgressBar,
  d2 as AXRankingRow,
  xu as AXSearchInput,
  N2 as AXSegmentedControl,
  _2 as AXStatusBadge,
  b2 as AXStepProgress,
  $2 as AXTagChip,
  x2 as AXToggleSwitch,
  S2 as AXTreeItem,
  E2 as AXTypingDots,
  rr as AX_ERP_CALENDAR_KO,
  mb as AX_ERP_DIRTY_MESSAGE,
  Po as GW_ORIGIN,
  er as JAPANESE_ERAS,
  un as OBTPortal,
  VN as OBTResizeContainer,
  Vo as OBTResizeSensor,
  Mn as REFRESH_KEY,
  Ea as SESSION_EXPIRED_EVENT,
  Aa as TOKEN_KEY,
  ir as amDigits,
  Hh as amNumber,
  Bn as authorizedFetch,
  pa as axErpAddDays,
  R1 as axErpCalendarLocale,
  cE as axErpChangedKeys,
  wa as axErpCodeDisplay,
  Vp as axErpCodeLabel,
  Jp as axErpCodeNameOf,
  xN as axErpDownload,
  AE as axErpFileName,
  G_ as axErpGisuLabel,
  hN as axErpHttpMessage,
  GE as axErpKpiColumns,
  qd as axErpMenuItem,
  L2 as axErpMenuSection,
  Qn as axErpQtyDecimals,
  en as axErpQtyFormat,
  aE as axErpQtyOutOfRange,
  En as axErpQtyParse,
  dr as axErpQtyRound,
  oE as axErpQtyStep,
  rN as axErpRangeValid,
  Bp as axErpRovingMove,
  Q2 as axErpRowActivate,
  iE as axErpSameValues,
  _r as axErpSaveBlob,
  qE as axErpSaveCsv,
  Fd as axErpSubmitShortcutLabel,
  jE as axErpTableToCsv,
  Gv as axErpWeekOf,
  jr as clearTokens,
  Yw as colors,
  Vw as configureAuth,
  Qw as configureComments,
  Sn as csvFormulaGuard,
  pr as csvNumber,
  Ma as decodeClaims,
  tr as eraOf,
  lN as eraShortDate,
  A1 as eraYearLabel,
  Kh as fmtAm,
  oN as fmtDt,
  Fr as getFreshToken,
  Mr as getStoredToken,
  Ar as isExpired,
  Xo as isRefreshExpired,
  Rr as isReply,
  V2 as measureMoneyMetrics,
  Y2 as moneyColWidth,
  xp as moneyColWidthForDigits,
  kn as notifySessionExpired,
  Jw as onSessionExpired,
  zo as refreshTokens,
  Br as saveTokens,
  Lr as startRefreshExpiryWatch,
  Wo as stopRefreshExpiryWatch,
  zh as toHalfWidth,
  Zo as todayLocal,
  wN as useAXErpBusy,
  YN as useAXErpCalculator,
  yN as useAXErpConfirm,
  db as useAXErpDirtyGuard,
  kN as useAXErpEditor,
  fN as useAXErpNotice,
  BN as useAXErpQuickMenu,
  tN as useAXErpRovingGrid,
  q2 as useAXErpSubmitShortcut,
  Z2 as useAXErpTree,
  e2 as useCommentCounts,
  Kr as useComments
};
